export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Color: { input: any; output: any; }
  Currency: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  PinCode: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  Time: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  link__Import: { input: any; output: any; }
  link__Purpose: { input: any; output: any; }
};

export type AutomationCreateInput = {
  task: AutomationTaskInput;
};

export type AutomationTaskCursorsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
};

export type AutomationTaskFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationTaskInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  schedule: AutomationTaskScheduleInput;
  targetLambdaPayload?: InputMaybe<Scalars['JSON']['input']>;
  taskName: Scalars['String']['input'];
  taskType: C_Automation_Task_Type;
};

export type AutomationTaskScheduleInput = {
  /**  ISO date string which represents hours  */
  hours?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  /**  ISO date string which represents minutes  */
  minutes: Array<Scalars['DateTime']['input']>;
  /**  1-JAN, ... 12-DEC  */
  month?: InputMaybe<Array<Scalars['Int']['input']>>;
  monthDay?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**  1-SUN, ... 7-SAT  */
  weekDay?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AutomationTaskUpdateInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  schedule?: InputMaybe<AutomationTaskScheduleInput>;
  targetLambdaPayload?: InputMaybe<Scalars['JSON']['input']>;
  taskName?: InputMaybe<Scalars['String']['input']>;
};

export type B2B_AddItemToStdOrderInput = {
  articleId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  quantities: StdOrderQuantitiesInput;
  sortPos: Scalars['Int']['input'];
};

export type B2B_ArticleDataInput = {
  articleId: Scalars['ID']['input'];
  languageId: C_Language;
};

export type B2B_CreateNewOrderInput = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  userLng: C_Language;
};

export type B2B_CreateOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  day: Scalars['Date']['input'];
  deliveryCosts?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  items: Array<B2B_OrderPositionInput>;
  orderRef?: InputMaybe<Scalars['String']['input']>;
};

export type B2B_ListArticleAvailableForOrderInput = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  lang: C_Language;
  listExisted: Array<Scalars['ID']['input']>;
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type B2B_ListDeliveryNoteInput = {
  customerID: Scalars['ID']['input'];
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
};

export type B2B_ListInvoiceInput = {
  customerID: Scalars['ID']['input'];
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
};

export type B2B_ListStdArticleAvailableForOrderInput = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  lang: C_Language;
  listExisted: Array<Scalars['ID']['input']>;
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type B2B_MinMaxOnDayInput = {
  customerId: Scalars['ID']['input'];
  day: Scalars['Int']['input'];
};

export type B2B_OrderDataInput = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lang: C_Language;
};

export type B2B_OrderPositionInput = {
  articleId: Scalars['ID']['input'];
  articleNo?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  priceForCalc?: InputMaybe<Scalars['Float']['input']>;
  priceWithDiscount?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  quantityPerLot?: InputMaybe<Scalars['Float']['input']>;
  saleUnitName?: InputMaybe<Scalars['String']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  vatCode: C_Vat_Code;
  vatRate: Scalars['Float']['input'];
};

export type B2B_OrderPriceCheckInput = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  items: Array<B2B_OrderPositionInput>;
};

export type B2B_UpdateCurrentCustomerInput = {
  companyGUID: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
};

export type B2B_UpdateCurrentUserInput = {
  isEmailForOrder: Scalars['Boolean']['input'];
  lang: C_Language;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum C_Activate_Operation_Status {
  AOS_RECORD_ACTIVATED = 'AOS_RECORD_ACTIVATED',
  AOS_RECORD_NOT_ACTIVATED = 'AOS_RECORD_NOT_ACTIVATED'
}

export enum C_Ai_Assistant_Query_Status {
  AQS_ERROR = 'AQS_ERROR',
  AQS_LOADING = 'AQS_LOADING',
  AQS_SUCCESS = 'AQS_SUCCESS'
}

export enum C_Article_Weekly_Availability_Status {
  AWAS0_AVAILABLE = 'AWAS0_AVAILABLE',
  AWAS1_SOMETIMES_DELIVERED = 'AWAS1_SOMETIMES_DELIVERED',
  AWAS2_NOT_DELIVERED = 'AWAS2_NOT_DELIVERED',
  AWAS3_NOT_ACTIVE = 'AWAS3_NOT_ACTIVE',
  AWAS4_ACTIVE_AMOUNT_0 = 'AWAS4_ACTIVE_AMOUNT_0',
  AWAS5_NOT_AVAILABLE_GROUP = 'AWAS5_NOT_AVAILABLE_GROUP'
}

export enum C_Attached_Orders_Action {
  AOA0_UNBIND = 'AOA0_UNBIND',
  AOA1_DELETE = 'AOA1_DELETE'
}

export enum C_Automation_Task_Type {
  ATT_HOGASHOP_EXPORT_ARTICLES = 'ATT_HOGASHOP_EXPORT_ARTICLES',
  ATT_HOGASHOP_EXPORT_ARTICLE_ATTRIBUTES = 'ATT_HOGASHOP_EXPORT_ARTICLE_ATTRIBUTES',
  ATT_HOGASHOP_EXPORT_PRICES = 'ATT_HOGASHOP_EXPORT_PRICES',
  ATT_HOGASHOP_IMPORT_ORDERS = 'ATT_HOGASHOP_IMPORT_ORDERS',
  ATT_IMPORT_TOOLBOX_CORRECTIONS = 'ATT_IMPORT_TOOLBOX_CORRECTIONS',
  ATT_TERMINATION_ACCEPTING_ORDERS = 'ATT_TERMINATION_ACCEPTING_ORDERS',
  ATT_TOOLBOX_EXPORT = 'ATT_TOOLBOX_EXPORT',
  ATT_ZENPROD_EXPORT = 'ATT_ZENPROD_EXPORT'
}

export enum C_B2B_Order_State {
  OS_FIXED = 'OS_FIXED',
  OS_MODIFY = 'OS_MODIFY',
  OS_NEW = 'OS_NEW'
}

export enum C_Bakery2B_Currency {
  CHF = 'CHF',
  EUR = 'EUR',
  USD = 'USD'
}

export enum C_Bakery2B_Language {
  de_DE = 'de_DE',
  en_GB = 'en_GB',
  fr_FR = 'fr_FR',
  it_IT = 'it_IT'
}

export enum C_Bakery2B_Menu_Color {
  BMC_BLACK = 'BMC_BLACK',
  BMC_RED = 'BMC_RED',
  BMC_WHITE = 'BMC_WHITE'
}

export enum C_Besr_Format {
  BF1_HSSOFT = 'BF1_HSSOFT',
  BF2_ABACUS = 'BF2_ABACUS',
  BF3_ABACUS2 = 'BF3_ABACUS2'
}

export enum C_Booking_Type {
  BO1_BOOKING_DATE_CREDIT = 'BO1_BOOKING_DATE_CREDIT',
  BO2_BOOKING_PROCESSING_DATE = 'BO2_BOOKING_PROCESSING_DATE'
}

export enum C_Ca_Visibility_Status {
  CAVS1_ALWAYS = 'CAVS1_ALWAYS',
  CAVS2_ONLY_CR_MODE = 'CAVS2_ONLY_CR_MODE',
  CAVS3_ONLY_ORDER_MODE = 'CAVS3_ONLY_ORDER_MODE',
  CAVS4_DISABLED = 'CAVS4_DISABLED'
}

export enum C_Content_Translation_Type {
  ARTICLE_CUSTOM_LABEL_DESCRIPTION = 'ARTICLE_CUSTOM_LABEL_DESCRIPTION',
  ARTICLE_DECLARATION = 'ARTICLE_DECLARATION',
  ARTICLE_DESCRIPTION = 'ARTICLE_DESCRIPTION',
  CONFIGURATION_DEBT_REMINDER_EMAIL_TEXT = 'CONFIGURATION_DEBT_REMINDER_EMAIL_TEXT',
  CONFIGURATION_INVOICE_EMAIL_TEXT = 'CONFIGURATION_INVOICE_EMAIL_TEXT',
  CONFIGURATION_OFFER_EMAIL_TEXT = 'CONFIGURATION_OFFER_EMAIL_TEXT',
  CONFIGURATION_ORDER_EMAIL_TEXT = 'CONFIGURATION_ORDER_EMAIL_TEXT',
  CUSTOMER_INVOICE_NOTE = 'CUSTOMER_INVOICE_NOTE',
  CUSTOMER_ORDER_NOTE = 'CUSTOMER_ORDER_NOTE',
  DEBT_REMINDER_DESCRIPTION = 'DEBT_REMINDER_DESCRIPTION',
  DEBT_REMINDER_TEXT = 'DEBT_REMINDER_TEXT',
  TEXT_BLOCK_TEXT = 'TEXT_BLOCK_TEXT'
}

export enum C_Correspondence_Language {
  CL1_ENGLISH = 'CL1_ENGLISH',
  CL2_GERMAN = 'CL2_GERMAN',
  CL3_FRENCH = 'CL3_FRENCH',
  CL4_ITALIAN = 'CL4_ITALIAN'
}

export enum C_Country {
  CO1_SWITZERLAND = 'CO1_SWITZERLAND',
  CO2_GERMANY = 'CO2_GERMANY',
  CO3_AUSTRIA = 'CO3_AUSTRIA',
  CO4_MALDIVES = 'CO4_MALDIVES',
  CO5_LUXEMBOURG = 'CO5_LUXEMBOURG'
}

export enum C_Created_Invoices_Filter_Mode {
  CURRENT_MONTH = 'CURRENT_MONTH',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_GROUP = 'CUSTOMER_GROUP',
  CUSTOMER_LIST = 'CUSTOMER_LIST',
  DATE_RANGE = 'DATE_RANGE',
  INVOICES_NO_RANGE = 'INVOICES_NO_RANGE',
  LAST_MONTH = 'LAST_MONTH',
  ONE_TIME_CUSTOMERS = 'ONE_TIME_CUSTOMERS',
  UNPAID_INVOICES_TILL_DATE = 'UNPAID_INVOICES_TILL_DATE'
}

export enum C_Created_Orders_Filter_Mode {
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_GROUP = 'CUSTOMER_GROUP',
  CUSTOMER_LIST = 'CUSTOMER_LIST',
  DATE = 'DATE',
  DATE_RANGE = 'DATE_RANGE',
  DELIVERY_NOTES_RANGE = 'DELIVERY_NOTES_RANGE',
  ONE_TIME_CUSTOMERS = 'ONE_TIME_CUSTOMERS'
}

export enum C_Currency {
  CUR1_DEFAULT = 'CUR1_DEFAULT',
  CUR2_EURO = 'CUR2_EURO',
  CUR3_USD = 'CUR3_USD'
}

export enum C_Customer_Address_Kind {
  CAK1_COMPANY = 'CAK1_COMPANY',
  CAK2_COMPANY_WITH_DELIVERY_ADDRESS = 'CAK2_COMPANY_WITH_DELIVERY_ADDRESS',
  CAK3_PRIVATE_PERSON = 'CAK3_PRIVATE_PERSON'
}

export enum C_Customer_Def_Order_Source {
  DO1_DEFAULT_ORDER = 'DO1_DEFAULT_ORDER',
  DO2_WEEK_AGO_ORDER = 'DO2_WEEK_AGO_ORDER',
  DO3_LAST_ORDER = 'DO3_LAST_ORDER',
  DO4_EMPTY_ORDER = 'DO4_EMPTY_ORDER'
}

export enum C_Custom_Rights {
  CR_ARTICLE = 'CR_ARTICLE',
  CR_CUSTOMER = 'CR_CUSTOMER',
  CR_DEBITOR = 'CR_DEBITOR',
  CR_INVOICE = 'CR_INVOICE',
  CR_OFFER = 'CR_OFFER',
  CR_OPTIONS = 'CR_OPTIONS',
  CR_ORDER = 'CR_ORDER',
  CR_PRODUCTION = 'CR_PRODUCTION',
  CR_STATISTIC = 'CR_STATISTIC'
}

export enum C_Deactivate_Operation_Status {
  DOS_RECORD_DEACTIVATED = 'DOS_RECORD_DEACTIVATED',
  DOS_RECORD_NOT_DEACTIVATED = 'DOS_RECORD_NOT_DEACTIVATED'
}

export enum C_Debitor_Status {
  DS1_DEBITOR = 'DS1_DEBITOR',
  DS2_INVOICE_DOES_NOT_INITIATE_DEBITOR = 'DS2_INVOICE_DOES_NOT_INITIATE_DEBITOR',
  DS3_INTERNAL_INVOICE = 'DS3_INTERNAL_INVOICE'
}

export enum C_Delete_Operation_Status {
  DOS_RECORD_DELETED = 'DOS_RECORD_DELETED',
  DOS_RECORD_NOT_DELETED = 'DOS_RECORD_NOT_DELETED'
}

export enum C_Dictionary {
  DICT1_HISTORY_OPERATIONS = 'DICT1_HISTORY_OPERATIONS',
  DICT2_HISTORY_FORM_TYPES = 'DICT2_HISTORY_FORM_TYPES',
  DICT3_REPORT_GROUPS = 'DICT3_REPORT_GROUPS',
  DICT4_REPORT_TYPES = 'DICT4_REPORT_TYPES',
  DICT5_DEFAULT_FORMULAR = 'DICT5_DEFAULT_FORMULAR',
  DICT6_TASK_CODES = 'DICT6_TASK_CODES',
  DICT7_COUNTRIES = 'DICT7_COUNTRIES',
  DICT8_WEIGHT_FRACTION_TYPES = 'DICT8_WEIGHT_FRACTION_TYPES',
  DICT9_PRICE_ROUNDING_METHODS = 'DICT9_PRICE_ROUNDING_METHODS',
  DICT11_DISCOUNTS = 'DICT11_DISCOUNTS',
  DICT12_TAX_KINDS = 'DICT12_TAX_KINDS',
  DICT13_TAX_INCLUSION_KINDS = 'DICT13_TAX_INCLUSION_KINDS',
  DICT15_DIRECT_DEBIT_BANKS = 'DICT15_DIRECT_DEBIT_BANKS',
  DICT17_BOOKING_TYPES = 'DICT17_BOOKING_TYPES',
  DICT18_INVOICE_INTERVALS = 'DICT18_INVOICE_INTERVALS',
  DICT21_ORDER_TYPES = 'DICT21_ORDER_TYPES',
  DICT22_DEBITOR_STATUSES = 'DICT22_DEBITOR_STATUSES',
  DICT24_CUSTOMER_DEFAULT_ORDER_KINDS = 'DICT24_CUSTOMER_DEFAULT_ORDER_KINDS',
  DICT26_KG_AMOUNT_REPRESENTATION_KINDS = 'DICT26_KG_AMOUNT_REPRESENTATION_KINDS',
  DICT28_SALE_UNITS = 'DICT28_SALE_UNITS',
  DICT29_REDUCTIONS_AND_PRICES_TAKE_FROM_KINDS = 'DICT29_REDUCTIONS_AND_PRICES_TAKE_FROM_KINDS',
  DICT30_CA_VISIBILITY_STATUSES = 'DICT30_CA_VISIBILITY_STATUSES',
  DICT31_CUSTOMER_ADDRESS_KINDS = 'DICT31_CUSTOMER_ADDRESS_KINDS',
  DICT32_BESR_FORMATS = 'DICT32_BESR_FORMATS',
  DICT33_STATISTIC_GROUP_BY_TYPES = 'DICT33_STATISTIC_GROUP_BY_TYPES',
  DICT34_STATISTIC_PROFILES = 'DICT34_STATISTIC_PROFILES',
  DICT35_ORDER_POSITIONS_SORTING_KINDS = 'DICT35_ORDER_POSITIONS_SORTING_KINDS',
  DICT36_PRODUCTION_REPORT_SORTING_KINDS = 'DICT36_PRODUCTION_REPORT_SORTING_KINDS',
  DICT37_TASK_GROUP_TYPES = 'DICT37_TASK_GROUP_TYPES',
  DICT38_TASK_TYPES = 'DICT38_TASK_TYPES',
  DICT39_CURRENCIES = 'DICT39_CURRENCIES',
  DICT40_PRODUCTION_CUSTOMER_SORTING_KINDS = 'DICT40_PRODUCTION_CUSTOMER_SORTING_KINDS',
  DICT41_SPECIAL_PRICES_TYPES = 'DICT41_SPECIAL_PRICES_TYPES',
  DICT42_PRINTING_SERVICE_TASK_STATES = 'DICT42_PRINTING_SERVICE_TASK_STATES',
  DICT43_PRINTING_SERVICE_TASK_INITIATORS = 'DICT43_PRINTING_SERVICE_TASK_INITIATORS'
}

export enum C_Direct_Debit_Banks {
  B1_NO_BANK = 'B1_NO_BANK',
  B2_BANK1_WITH_DTA = 'B2_BANK1_WITH_DTA',
  B3_BANK2_WITH_DTA = 'B3_BANK2_WITH_DTA',
  B4_MANUAL = 'B4_MANUAL'
}

export enum C_Discounts_And_Prices_Kind {
  DNP1_DISCOUNT_WAWI_PRICE_CASH = 'DNP1_DISCOUNT_WAWI_PRICE_CASH',
  DNP2_DISCOUNT_WAWI_PRICE_WAWI = 'DNP2_DISCOUNT_WAWI_PRICE_WAWI',
  DNP3_NO_DISCOUNT_PRICE_CASH = 'DNP3_NO_DISCOUNT_PRICE_CASH',
  DNP4_DISCOUNT_CASH_PRICE_WAWI = 'DNP4_DISCOUNT_CASH_PRICE_WAWI',
  DNP5_DISCOUNT_CASH_PRICE_CASH = 'DNP5_DISCOUNT_CASH_PRICE_CASH',
  DNP6_DISCOUNT_SPECIAL_PRICE_CASH = 'DNP6_DISCOUNT_SPECIAL_PRICE_CASH'
}

export enum C_Discount_Kind {
  DK1_NO_DISCOUNT = 'DK1_NO_DISCOUNT',
  DK2_ALL_ARTICLES = 'DK2_ALL_ARTICLES',
  DK3_ARTICLE_GROUPS = 'DK3_ARTICLE_GROUPS',
  DK4_PRICE_REDUCE = 'DK4_PRICE_REDUCE',
  DK5_QUANTITY_DISCOUNT = 'DK5_QUANTITY_DISCOUNT',
  DK6_QUANTITY_DISCOUNT_GROUPS = 'DK6_QUANTITY_DISCOUNT_GROUPS'
}

export enum C_Email_Msg_Doctype {
  EML_INVOICE = 'EML_INVOICE',
  EML_OFFER = 'EML_OFFER',
  EML_ORDER = 'EML_ORDER',
  EML_REMINDER_OF_INVOICE = 'EML_REMINDER_OF_INVOICE'
}

export enum C_Email_Msg_State {
  EMS0_NOT_SENT = 'EMS0_NOT_SENT',
  EMS2_SENT = 'EMS2_SENT'
}

export enum C_Email_Tracking_Event_Type {
  EVT_BOUNCE_PERMANENT = 'EVT_BOUNCE_PERMANENT',
  EVT_BOUNCE_TRANSIENT = 'EVT_BOUNCE_TRANSIENT',
  EVT_BOUNCE_UNDETERMINED = 'EVT_BOUNCE_UNDETERMINED',
  EVT_COMPLAINT = 'EVT_COMPLAINT',
  EVT_DELIVERY = 'EVT_DELIVERY',
  EVT_SEND = 'EVT_SEND',
  EVT_UNKNOWN = 'EVT_UNKNOWN'
}

export enum C_E_Invoice_Field_Warning {
  EFW1_INCORRECT_VALUE = 'EFW1_INCORRECT_VALUE',
  EFW2_MISSING_VALUE = 'EFW2_MISSING_VALUE'
}

export enum C_E_Invoice_Format {
  EIF0_NO_E_INVOICE = 'EIF0_NO_E_INVOICE',
  EIF1_PDF_XML_XRECHNUNG_PROFILE = 'EIF1_PDF_XML_XRECHNUNG_PROFILE',
  EIF2_XML_XRECHNUNG_PROFILE = 'EIF2_XML_XRECHNUNG_PROFILE',
  EIF3_PDF_XML_ZUGFERD_PROFILE = 'EIF3_PDF_XML_ZUGFERD_PROFILE'
}

export enum C_Freezer_Condition {
  FC1_MINUS_18 = 'FC1_MINUS_18',
  FC2_PLUS_5 = 'FC2_PLUS_5'
}

export enum C_Global_Error_Code {
  GEC10_INVALID_GQL_DATA = 'GEC10_INVALID_GQL_DATA',
  GEC11_INVALID_DATABASE_DATA = 'GEC11_INVALID_DATABASE_DATA',
  GEC20_NO_DATA = 'GEC20_NO_DATA',
  GEC30_BAD_USER_INPUT = 'GEC30_BAD_USER_INPUT',
  GEC40_DELETING_RECORD_IN_USE = 'GEC40_DELETING_RECORD_IN_USE',
  GEC41_DELETE_PROHIBITED = 'GEC41_DELETE_PROHIBITED',
  GEC42_DEACTIVATING_BY_EMPTY_NAME_RECORD_IN_USE = 'GEC42_DEACTIVATING_BY_EMPTY_NAME_RECORD_IN_USE',
  GEC43_DEACTIVATING_BY_EMPTY_NAME_PROHIBITED = 'GEC43_DEACTIVATING_BY_EMPTY_NAME_PROHIBITED',
  GEC44_DELETE_USER_HAS_CUSTOMERS = 'GEC44_DELETE_USER_HAS_CUSTOMERS',
  GEC50_DB_IS_IN_UPDATING_PROCCES = 'GEC50_DB_IS_IN_UPDATING_PROCCES',
  GEC51_EMPTY_HISTORY_USER_ID = 'GEC51_EMPTY_HISTORY_USER_ID',
  GEC52_ERROR_IN_STORED_PROCEDURE = 'GEC52_ERROR_IN_STORED_PROCEDURE',
  GEC60_BAKERY2B_USER_ALREADY_CONNECTED_TO_OTHER_COMPANY = 'GEC60_BAKERY2B_USER_ALREADY_CONNECTED_TO_OTHER_COMPANY',
  GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY = 'GEC61_BAKERY2B_USER_ALREADY_CONNECTED_TO_THIS_COMPANY',
  GEC62_BAKERY2B_USER_IS_DEACTIVATED = 'GEC62_BAKERY2B_USER_IS_DEACTIVATED',
  GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER = 'GEC63_BAKERY2B_USER_ALREADY_LINKED_TO_THIS_CUSTOMER',
  GEC64_BAKERY2B_INVITE_API_ERROR = 'GEC64_BAKERY2B_INVITE_API_ERROR',
  GEC65_BAKERY2B_USER_NOT_CONNECTED_TO_COMPANY = 'GEC65_BAKERY2B_USER_NOT_CONNECTED_TO_COMPANY',
  GEC66_BAKERY2B_USER_NOT_ACTIVE_MEMBER_OF_COMPANY = 'GEC66_BAKERY2B_USER_NOT_ACTIVE_MEMBER_OF_COMPANY',
  GEC70_FORBIDDEN = 'GEC70_FORBIDDEN',
  GEC71_ORDER_DATE_LOCKED = 'GEC71_ORDER_DATE_LOCKED',
  GEC72_MULTI_ORDER_NOT_ALLOWED = 'GEC72_MULTI_ORDER_NOT_ALLOWED',
  GEC73_ORDER_SAVE_FAILED = 'GEC73_ORDER_SAVE_FAILED',
  GEC74_DROPSHIP_CUSTOMER_NOT_LINKED = 'GEC74_DROPSHIP_CUSTOMER_NOT_LINKED',
  GEC75_DROPSHIP_ARTICLES_NOT_AVAILABLE = 'GEC75_DROPSHIP_ARTICLES_NOT_AVAILABLE',
  GEC76_DROPSHIP_ORDER_NUMBER_RANGE_FULL = 'GEC76_DROPSHIP_ORDER_NUMBER_RANGE_FULL',
  GEC77_DROPSHIP_ORDER_NOT_FOUND_IN_SUPPLIER = 'GEC77_DROPSHIP_ORDER_NOT_FOUND_IN_SUPPLIER'
}

export enum C_Group_By_Type {
  GBT1_ARTICLE = 'GBT1_ARTICLE',
  GBT2_CUSTOMER_ARTICLE = 'GBT2_CUSTOMER_ARTICLE',
  GBT3_ARTICLE_CUSTOMER = 'GBT3_ARTICLE_CUSTOMER',
  GBT4_DATE_ARTICLE = 'GBT4_DATE_ARTICLE',
  GBT5_ARTICLE_DATE = 'GBT5_ARTICLE_DATE',
  GBT6_ARTICLE_DATE_CUSTOMER = 'GBT6_ARTICLE_DATE_CUSTOMER',
  GBT7_ARTICLE_DATE_RANGE_DETAIL = 'GBT7_ARTICLE_DATE_RANGE_DETAIL',
  GBT8_ARTICLE_DATE_RANGE_DETAIL_TURNOVER = 'GBT8_ARTICLE_DATE_RANGE_DETAIL_TURNOVER',
  GBT9_DOUGH = 'GBT9_DOUGH',
  GBT10_RAW_MATERIAL = 'GBT10_RAW_MATERIAL'
}

export enum C_History_Form_Types {
  HFT1_CONFIGURATION = 'HFT1_CONFIGURATION',
  HFT2_CUSTOMER = 'HFT2_CUSTOMER',
  HFT3_ARTICLE = 'HFT3_ARTICLE',
  HFT4_PRODUCTION = 'HFT4_PRODUCTION',
  HFT5_ORDER = 'HFT5_ORDER',
  HFT6_INVOICE = 'HFT6_INVOICE',
  HFT7_TEMPORDER = 'HFT7_TEMPORDER',
  HFT8_CUSTOMER_SPECIAL_PRICES_AND_DISCOUNTS = 'HFT8_CUSTOMER_SPECIAL_PRICES_AND_DISCOUNTS',
  HFT9_OFFER = 'HFT9_OFFER',
  HFT10_GROUPTASK = 'HFT10_GROUPTASK',
  HFT11_TEMPOFFER = 'HFT11_TEMPOFFER',
  HFT12_EMPTYORDER = 'HFT12_EMPTYORDER'
}

export enum C_History_Operations {
  HSO1_NEW_RECORD_WAS_ADDED = 'HSO1_NEW_RECORD_WAS_ADDED',
  HSO2_RECORD_WAS_EDITED = 'HSO2_RECORD_WAS_EDITED',
  HSO3_RECORD_WAS_DELETED = 'HSO3_RECORD_WAS_DELETED',
  HSO4_CHILD_RECORD_WAS_DELETED = 'HSO4_CHILD_RECORD_WAS_DELETED',
  HSO5_RECORD_WAS_COPIED = 'HSO5_RECORD_WAS_COPIED',
  HSO6_RECORD_WAS_RESTORED = 'HSO6_RECORD_WAS_RESTORED',
  HSO7_PDF_WAS_GENERATED = 'HSO7_PDF_WAS_GENERATED'
}

export enum C_History_Pdf_Doctype {
  PDF_INVOICE = 'PDF_INVOICE',
  PDF_OFFER = 'PDF_OFFER',
  PDF_ORDER = 'PDF_ORDER'
}

export enum C_Hs_App {
  CASH_ASSIST = 'CASH_ASSIST',
  RESTAURANT_MANAGER = 'RESTAURANT_MANAGER',
  REZEPT_ASSIST = 'REZEPT_ASSIST',
  RUN_MY_RESTO = 'RUN_MY_RESTO',
  SMART_PICKING = 'SMART_PICKING',
  WAWI_ASSIST = 'WAWI_ASSIST'
}

export enum C_Incoming_Orders_Source {
  IOS0_bakery2b = 'IOS0_bakery2b',
  IOS1_CashAssistDirect = 'IOS1_CashAssistDirect'
}

export enum C_Invite_Operation_Status {
  IOS_INVITE_NOT_SENT = 'IOS_INVITE_NOT_SENT',
  IOS_INVITE_SENT = 'IOS_INVITE_SENT'
}

export enum C_Invoice_Deletion_Possibility {
  IDP0_POSSIBLE = 'IDP0_POSSIBLE',
  IDP1_PROHIBITED_BECAUSE_OF_NON_CASH_PAYMENT = 'IDP1_PROHIBITED_BECAUSE_OF_NON_CASH_PAYMENT',
  IDP2_PROHIBITED_BECAUSE_OF_PAY_NET_PAYMENT = 'IDP2_PROHIBITED_BECAUSE_OF_PAY_NET_PAYMENT'
}

export enum C_Invoice_Export_Pdfs_Status {
  SCS_ERROR = 'SCS_ERROR',
  SCS_LOADING = 'SCS_LOADING',
  SCS_SUCCESS = 'SCS_SUCCESS'
}

export enum C_Invoice_Interval {
  II1_MONTHLY = 'II1_MONTHLY',
  II2_MONTHLY2 = 'II2_MONTHLY2',
  II3_MONTHLY3 = 'II3_MONTHLY3',
  II4_MONTHLY4 = 'II4_MONTHLY4',
  II5_HALF_MONTHLY = 'II5_HALF_MONTHLY',
  II6_HALF_WEEKLY = 'II6_HALF_WEEKLY',
  II7_MANUAL = 'II7_MANUAL',
  II8_DIRECT_CASH = 'II8_DIRECT_CASH',
  II9_DIRECT_DEBITOR = 'II9_DIRECT_DEBITOR',
  II10_NO_INVOICE_INTERNAL = 'II10_NO_INVOICE_INTERNAL'
}

export enum C_Kg_Representation {
  KGR1_1_IS_1 = 'KGR1_1_IS_1',
  KGR2_1000_IS_1 = 'KGR2_1000_IS_1'
}

export enum C_Language {
  L1_ENGLISH = 'L1_ENGLISH',
  L2_GERMAN = 'L2_GERMAN',
  L3_FRENCH = 'L3_FRENCH',
  L4_ITALIAN = 'L4_ITALIAN'
}

export enum C_New_Orders_Filter_Mode {
  ACCEPTED_OFFERS = 'ACCEPTED_OFFERS',
  ACTIVE_CUSTOMERS = 'ACTIVE_CUSTOMERS',
  CUSTOMER = 'CUSTOMER',
  CUSTOMERS_WITH_NO_ORDERS = 'CUSTOMERS_WITH_NO_ORDERS',
  DAILY_CUSTOMERS = 'DAILY_CUSTOMERS',
  INACTIVE_CUSTOMERS = 'INACTIVE_CUSTOMERS'
}

export enum C_New_Order_Selection_Mode {
  DEFAULT_ORDER_OF_CUSTOMER = 'DEFAULT_ORDER_OF_CUSTOMER',
  FROM_ACCEPTED_OFFER = 'FROM_ACCEPTED_OFFER',
  FROM_DRAFT_ORDER = 'FROM_DRAFT_ORDER',
  FROM_LAST_ORDER = 'FROM_LAST_ORDER',
  FROM_ORDER_BY_NUMBER = 'FROM_ORDER_BY_NUMBER',
  FROM_ORDER_ON_CHOSEN_DATE = 'FROM_ORDER_ON_CHOSEN_DATE'
}

export enum C_Offers_Filter_Mode {
  ACCEPTED_OFFERS = 'ACCEPTED_OFFERS',
  ACTIVE_CUSTOMERS = 'ACTIVE_CUSTOMERS',
  ADDITIONAL_OFFERS = 'ADDITIONAL_OFFERS',
  DECLINED_OFFERS = 'DECLINED_OFFERS',
  INACTIVE_CUSTOMERS = 'INACTIVE_CUSTOMERS',
  OPEN_OFFERS = 'OPEN_OFFERS'
}

export enum C_Offer_Error_Code {
  OEC1_EMPTY_ORDER = 'OEC1_EMPTY_ORDER',
  OEC2_EMPTY_POSITIONS = 'OEC2_EMPTY_POSITIONS',
  OEC3_QUANTITY_PER_LOT = 'OEC3_QUANTITY_PER_LOT',
  OECm1_SQL_ERROR = 'OECm1_SQL_ERROR',
  OECm2_INVALID_PARAMETERS = 'OECm2_INVALID_PARAMETERS'
}

export enum C_Offer_Selection_Mode {
  DEFAULT_ORDER_OF_CUSTOMER = 'DEFAULT_ORDER_OF_CUSTOMER',
  FROM_DRAFT_OFFER_BY_ID = 'FROM_DRAFT_OFFER_BY_ID',
  FROM_LAST_OFFER = 'FROM_LAST_OFFER',
  FROM_OFFER_BY_ID = 'FROM_OFFER_BY_ID',
  FROM_OFFER_BY_NUMBER = 'FROM_OFFER_BY_NUMBER',
  FROM_OFFER_ON_CHOSEN_DATE = 'FROM_OFFER_ON_CHOSEN_DATE'
}

export enum C_Order_Error_Code {
  OEC1_EMPTY_ORDER = 'OEC1_EMPTY_ORDER',
  OEC2_EMPTY_POSITIONS = 'OEC2_EMPTY_POSITIONS',
  OEC3_QUANTITY_PER_LOT = 'OEC3_QUANTITY_PER_LOT',
  OEC4_MIN_MAX = 'OEC4_MIN_MAX',
  OEC5_SPLITTING = 'OEC5_SPLITTING',
  OEC6_NOT_ENOUGH_DAYS_TO_PRODUCE = 'OEC6_NOT_ENOUGH_DAYS_TO_PRODUCE',
  OEC7_TOUR_IS_EMPTY_BUT_NEEDED = 'OEC7_TOUR_IS_EMPTY_BUT_NEEDED',
  OEC8_INVALID_ORDER_POSITIONS_IDS = 'OEC8_INVALID_ORDER_POSITIONS_IDS',
  OECm1_SQL_ERROR = 'OECm1_SQL_ERROR',
  OECm2_INVALID_PARAMETERS = 'OECm2_INVALID_PARAMETERS'
}

export enum C_Order_Positions_Sorting_Kind {
  OPS1_ARTICLE_NO = 'OPS1_ARTICLE_NO',
  OPS2_DESCRIPTION = 'OPS2_DESCRIPTION',
  OPS3_ORIGINAL = 'OPS3_ORIGINAL'
}

export enum C_Order_Type {
  OT1_ORDER = 'OT1_ORDER',
  OT2_ADDITIONAL_ORDER = 'OT2_ADDITIONAL_ORDER',
  OT3_PICKING_LIST = 'OT3_PICKING_LIST',
  OT4_RETURN = 'OT4_RETURN',
  OT5_CREDIT_ORDER = 'OT5_CREDIT_ORDER',
  OT6_SPECIAL_ORDER = 'OT6_SPECIAL_ORDER',
  OT7_INTERNET_ORDER = 'OT7_INTERNET_ORDER',
  OT8_HOGASHOP = 'OT8_HOGASHOP',
  OT9_CATERING = 'OT9_CATERING',
  OT11_CASHASSIST_ORDER = 'OT11_CASHASSIST_ORDER',
  OT12_CASHASSIST_REDISCOUNT = 'OT12_CASHASSIST_REDISCOUNT',
  OT13_CASHASSIST_OUTPUT = 'OT13_CASHASSIST_OUTPUT',
  OT14_CASHASSIST_RETURN = 'OT14_CASHASSIST_RETURN',
  OT15_CASHASSIST_TRANSFER = 'OT15_CASHASSIST_TRANSFER',
  OT16_CASHASSIST_ADDITIONAL_ORDER = 'OT16_CASHASSIST_ADDITIONAL_ORDER',
  OT20_CASHASSIST_CUSTOMER_ORDER = 'OT20_CASHASSIST_CUSTOMER_ORDER',
  OT21_CASHASSIST_INVOICE = 'OT21_CASHASSIST_INVOICE',
  OT22_CASHASSIST_CREDIT_CUSTOMER = 'OT22_CASHASSIST_CREDIT_CUSTOMER'
}

export enum C_Payments_Filter_Mode {
  CURRENT_MONTH = 'CURRENT_MONTH',
  CUSTOMER = 'CUSTOMER',
  DATE_RANGE = 'DATE_RANGE',
  INVOICES_DATE_RANGE = 'INVOICES_DATE_RANGE',
  INVOICES_NO_RANGE = 'INVOICES_NO_RANGE',
  LAST_MONTH = 'LAST_MONTH'
}

export enum C_Printed_Reports_Kind {
  BAKING_LISTS = 'BAKING_LISTS',
  CROSSTABLE_REPORTS = 'CROSSTABLE_REPORTS',
  DELIVERY_NOTES_A4 = 'DELIVERY_NOTES_A4',
  DELIVERY_NOTES_A5 = 'DELIVERY_NOTES_A5',
  FORWARDING_LISTS = 'FORWARDING_LISTS',
  INVOICES = 'INVOICES',
  INVOICE_PAYMENT_SLIP = 'INVOICE_PAYMENT_SLIP',
  INVOICE_SUMMARY = 'INVOICE_SUMMARY',
  OFFERS = 'OFFERS'
}

export enum C_Printing_Service_Task_Initiator {
  PSTI1_WAWI_AUTOMATION = 'PSTI1_WAWI_AUTOMATION',
  PSTI2_CASHASSIST_ORDERS_IMPORT = 'PSTI2_CASHASSIST_ORDERS_IMPORT',
  PSTI3_B2B_ORDERS_IMPORT = 'PSTI3_B2B_ORDERS_IMPORT',
  PSTI4_WAWI = 'PSTI4_WAWI'
}

export enum C_Printing_Service_Task_State {
  PSTS1_NOT_STARTED = 'PSTS1_NOT_STARTED',
  PSTS2_READY = 'PSTS2_READY',
  PSTS3_ERROR_BUILDING_STAGE = 'PSTS3_ERROR_BUILDING_STAGE',
  PSTS4_ERROR_PRINTING_STAGE = 'PSTS4_ERROR_PRINTING_STAGE',
  PSTS5_IN_PROGRESS = 'PSTS5_IN_PROGRESS',
  PSTS6_CANCELLED_BY_USER = 'PSTS6_CANCELLED_BY_USER',
  PSTS7_GENERATED_TOO_MANY_PAGES = 'PSTS7_GENERATED_TOO_MANY_PAGES'
}

export enum C_Procurement_Product_Kind {
  PPK0_NOT_AVAILABLE = 'PPK0_NOT_AVAILABLE',
  PPK1_MERCHANDISE_ARTICLE = 'PPK1_MERCHANDISE_ARTICLE',
  PPK2_OWN_PRODUCED_ARTICLE = 'PPK2_OWN_PRODUCED_ARTICLE',
  PPK3_RAW_MATERIAL = 'PPK3_RAW_MATERIAL'
}

export enum C_Production_Article_Sorting_Kind {
  PASK1_DOUGH_ARTICLE_NO = 'PASK1_DOUGH_ARTICLE_NO',
  PASK2_ARTICLE_NO = 'PASK2_ARTICLE_NO',
  PASK3_DESCRIPTION = 'PASK3_DESCRIPTION',
  PASK4_GROUP_ARTICLE_NO = 'PASK4_GROUP_ARTICLE_NO',
  PASK5_GROUP_DESCRIPTION = 'PASK5_GROUP_DESCRIPTION',
  PASK6_CUSTOMER_NO_DELIVERY_NO_ARTICLE_NO = 'PASK6_CUSTOMER_NO_DELIVERY_NO_ARTICLE_NO',
  PASK7_ARTICLE_NO_SETUP_STATION = 'PASK7_ARTICLE_NO_SETUP_STATION',
  PASK8_DELIVERY_TIME = 'PASK8_DELIVERY_TIME'
}

export enum C_Production_Customer_Sorting_Kind {
  PCSK1_CUSTOMER_NO = 'PCSK1_CUSTOMER_NO',
  PCSK2_CUSTOMER_NAME = 'PCSK2_CUSTOMER_NAME'
}

export enum C_Report {
  R0_USER_REPORT = 'R0_USER_REPORT',
  R1_BAKING_LIST_2_COLUMNS = 'R1_BAKING_LIST_2_COLUMNS',
  R3_ADDRESS_LIST_A4_LANDSCAPE = 'R3_ADDRESS_LIST_A4_LANDSCAPE',
  R4_FACTSHEET = 'R4_FACTSHEET',
  R5_PHONES_LIST = 'R5_PHONES_LIST',
  R6_ARTICLE_LIST = 'R6_ARTICLE_LIST',
  R7_WEEKLY_ORDERING_LIST = 'R7_WEEKLY_ORDERING_LIST',
  R8_DELIVERY_NOTE_A4_WITH_PRICE = 'R8_DELIVERY_NOTE_A4_WITH_PRICE',
  R9_INVOICE_A4 = 'R9_INVOICE_A4',
  R10_CUSTOMERS_DEBT_NOTIFIER = 'R10_CUSTOMERS_DEBT_NOTIFIER',
  R11_CROSSTABLE_REPORT_A4_LANDSCAPE = 'R11_CROSSTABLE_REPORT_A4_LANDSCAPE',
  R12_LABEL = 'R12_LABEL',
  R14_BAKING_LIST_WITH_RECIPE_2_COLUMNS = 'R14_BAKING_LIST_WITH_RECIPE_2_COLUMNS',
  R15_FORWARDING_LIST_CUSTOMER_ARTICLES = 'R15_FORWARDING_LIST_CUSTOMER_ARTICLES',
  R16_DELIVERY_NOTE_A4_WITHOUT_PRICE = 'R16_DELIVERY_NOTE_A4_WITHOUT_PRICE',
  R17_INVOICE_SUMMARY = 'R17_INVOICE_SUMMARY',
  R18_INVOICE_PAYMENTSLIP = 'R18_INVOICE_PAYMENTSLIP',
  R19_INVOICE_A4_DETAILED = 'R19_INVOICE_A4_DETAILED',
  R20_FORWARDING_LIST_ARTICLE_CUSTOMERS = 'R20_FORWARDING_LIST_ARTICLE_CUSTOMERS',
  R21_INVOICE_JOURNAL = 'R21_INVOICE_JOURNAL',
  R22_BESR_IMPORT_JOURNAL_A4_LANDSCAPE = 'R22_BESR_IMPORT_JOURNAL_A4_LANDSCAPE',
  R23_DEBITOR_JOURNAL_A4_LANDSCAPE = 'R23_DEBITOR_JOURNAL_A4_LANDSCAPE',
  R24_PAYMENT_JOURNAL_A4_LANDSCAPE = 'R24_PAYMENT_JOURNAL_A4_LANDSCAPE',
  R25_BAKING_LIST_2_COLUMNS_COMBINED = 'R25_BAKING_LIST_2_COLUMNS_COMBINED',
  R26_BAKING_LIST_WITH_RECIPE_A4 = 'R26_BAKING_LIST_WITH_RECIPE_A4',
  R27_BAKING_LIST_WITH_RECIPE_A5 = 'R27_BAKING_LIST_WITH_RECIPE_A5',
  R28_WEEKLY_ORDERING_LIST_BLANK_QUANTITY = 'R28_WEEKLY_ORDERING_LIST_BLANK_QUANTITY',
  R29_DELIVERY_NOTE_A5_LANDSCAPE_WITH_PRICE = 'R29_DELIVERY_NOTE_A5_LANDSCAPE_WITH_PRICE',
  R30_DELIVERY_NOTE_A5_LANDSCAPE_WITHOUT_PRICE = 'R30_DELIVERY_NOTE_A5_LANDSCAPE_WITHOUT_PRICE',
  R31_INVOICE_A4_ARTICLE_GROUPING = 'R31_INVOICE_A4_ARTICLE_GROUPING',
  R32_TOURLIST = 'R32_TOURLIST',
  R33_PRICE_LIST_FOR_CUSTOMER = 'R33_PRICE_LIST_FOR_CUSTOMER',
  R34_BAKING_LIST_A4 = 'R34_BAKING_LIST_A4',
  R35_EXTENDED_PAYMENT_JOURNAL = 'R35_EXTENDED_PAYMENT_JOURNAL',
  R36_ARTICLE_LIST_ALL_PRICE_CATEGORIES = 'R36_ARTICLE_LIST_ALL_PRICE_CATEGORIES',
  R37_OFFER_A4 = 'R37_OFFER_A4',
  R38_OFFER_A4_ARTICLE_GROUPING = 'R38_OFFER_A4_ARTICLE_GROUPING',
  R39_INVOICE_A4_CUSTOMER_GROUPING = 'R39_INVOICE_A4_CUSTOMER_GROUPING',
  R40_DELIVERY_NOTE_A4_OVERVIEW = 'R40_DELIVERY_NOTE_A4_OVERVIEW',
  R41_BAKING_LIST_A4_DETAILED = 'R41_BAKING_LIST_A4_DETAILED',
  R42_FORWARDING_LIST_CUSTOMER_ARTICLES_ONE_PER_PAGE = 'R42_FORWARDING_LIST_CUSTOMER_ARTICLES_ONE_PER_PAGE',
  R43_DELIVERY_NOTE_A4_WITH_PRICE_AND_DISCOUNT = 'R43_DELIVERY_NOTE_A4_WITH_PRICE_AND_DISCOUNT',
  R44_DELIVERY_NOTE_A5_LANDSCAPE_WITH_PRICE_AND_DISCOUNT = 'R44_DELIVERY_NOTE_A5_LANDSCAPE_WITH_PRICE_AND_DISCOUNT',
  R45_SHIPPING_LABEL_ADDRESS_ONLY = 'R45_SHIPPING_LABEL_ADDRESS_ONLY',
  R46_SHIPPING_LABEL_FOR_ORDERED_ARTICLE = 'R46_SHIPPING_LABEL_FOR_ORDERED_ARTICLE',
  R47_WEEKLY_ORDERINGLIST_BLANK_QUANTITY_BLANK_DATE = 'R47_WEEKLY_ORDERINGLIST_BLANK_QUANTITY_BLANK_DATE',
  R48_OFFER_A4_WITH_IMAGES = 'R48_OFFER_A4_WITH_IMAGES',
  R49_BAKING_LIST_2_COLUMNS_SMART_SCALE = 'R49_BAKING_LIST_2_COLUMNS_SMART_SCALE',
  R50_ARTICLE_LIST_WITH_IMAGES = 'R50_ARTICLE_LIST_WITH_IMAGES',
  R51_DELIVERY_NOTES_IN_PRODUCTION = 'R51_DELIVERY_NOTES_IN_PRODUCTION',
  R52_DELIVERY_OVERVIEW = 'R52_DELIVERY_OVERVIEW',
  R53_PROCUREMENT_ORDER_A4 = 'R53_PROCUREMENT_ORDER_A4',
  R54_PROCUREMENT_PROJECT_A4 = 'R54_PROCUREMENT_PROJECT_A4',
  R55_DELIVERY_NOTE_A4_WITH_PRICE_AND_ORIGIN = 'R55_DELIVERY_NOTE_A4_WITH_PRICE_AND_ORIGIN',
  R56_BAKING_LIST_VERSIONS_DIFFERENCE = 'R56_BAKING_LIST_VERSIONS_DIFFERENCE',
  R57_BAKING_LIST_RAWMATERIALS_2_COLUMNS = 'R57_BAKING_LIST_RAWMATERIALS_2_COLUMNS',
  R58_BAKING_LIST_VERSIONS_DIFFERENCE_WITH_RECIPE = 'R58_BAKING_LIST_VERSIONS_DIFFERENCE_WITH_RECIPE',
  R59_INVOICE_PAYMENTSLIP_WITH_QR = 'R59_INVOICE_PAYMENTSLIP_WITH_QR',
  R60_STOCK_LIST = 'R60_STOCK_LIST',
  R61_STOCK_VALUE = 'R61_STOCK_VALUE',
  R62_DELIVERY_NOTE_PARTIAL_DELIVERY_A4_WITH_PRICE = 'R62_DELIVERY_NOTE_PARTIAL_DELIVERY_A4_WITH_PRICE',
  R63_PROCUREMENT_SUPPLIER_GOODS_A4 = 'R63_PROCUREMENT_SUPPLIER_GOODS_A4',
  R64_CUSTOMERS_DEBT_NOTIFIER_WITH_INVOICE_AND_PAYMENTSLIP = 'R64_CUSTOMERS_DEBT_NOTIFIER_WITH_INVOICE_AND_PAYMENTSLIP',
  R65_CROSSTABLE_REPORT_A4_PORTRAIT = 'R65_CROSSTABLE_REPORT_A4_PORTRAIT',
  R66_BAKING_LIST_FOR_CAKES_AND_PIES = 'R66_BAKING_LIST_FOR_CAKES_AND_PIES',
  R67_CUSTOMER_PAYMENT_INFO_OVERVIEW = 'R67_CUSTOMER_PAYMENT_INFO_OVERVIEW',
  R68_FORWARDING_LIST_ARTICLE_CUSTOMERS_VERSIONS_DIFFERENCE = 'R68_FORWARDING_LIST_ARTICLE_CUSTOMERS_VERSIONS_DIFFERENCE',
  R_NOT_TO_PRINT = 'R_NOT_TO_PRINT'
}

export enum C_Report_Error_Code {
  CUSTOMER_SETTING_DO_NOT_PRINT = 'CUSTOMER_SETTING_DO_NOT_PRINT',
  NO_DATA_FOR_REPORT = 'NO_DATA_FOR_REPORT',
  PDF_IS_NOT_GENERATED = 'PDF_IS_NOT_GENERATED',
  REPORT_NOT_CONNECTED_TO_PRINTER = 'REPORT_NOT_CONNECTED_TO_PRINTER'
}

export enum C_Report_Group {
  RG1_PRODUCTION_PRODUCTION = 'RG1_PRODUCTION_PRODUCTION',
  RG2_CUSTOMER = 'RG2_CUSTOMER',
  RG3_ARTICLE = 'RG3_ARTICLE',
  RG4_DEFAULT_ORDER = 'RG4_DEFAULT_ORDER',
  RG5_ORDER = 'RG5_ORDER',
  RG6_INVOICE = 'RG6_INVOICE',
  RG7_DEBITOR = 'RG7_DEBITOR',
  RG8_PRODUCTION_FORWARDING_LISTS = 'RG8_PRODUCTION_FORWARDING_LISTS',
  RG9_PRODUCTION_CROSSTABLE = 'RG9_PRODUCTION_CROSSTABLE',
  RG10_OFFER = 'RG10_OFFER',
  RG11_PRODUCTION_SMARTSCALE = 'RG11_PRODUCTION_SMARTSCALE',
  RG12_PROCUREMENT = 'RG12_PROCUREMENT',
  RG13_PROCUREMENT_GOODS = 'RG13_PROCUREMENT_GOODS',
  RG14_PROCUREMENT_SUPPLIERS = 'RG14_PROCUREMENT_SUPPLIERS'
}

export enum C_Rounding_Method {
  RM1_NOT_USED = 'RM1_NOT_USED',
  RM2_TO_0_05 = 'RM2_TO_0_05',
  RM3_TO_0_01 = 'RM3_TO_0_01',
  RM4_TO_0_001 = 'RM4_TO_0_001',
  RM5_TO_0_1 = 'RM5_TO_0_1'
}

export enum C_S3_Bucket {
  S3B_CONSOLE = 'S3B_CONSOLE',
  S3B_MAIN_HISTORY_PRINTOUTS = 'S3B_MAIN_HISTORY_PRINTOUTS',
  S3B_MAIN_TEMP = 'S3B_MAIN_TEMP',
  S3B_WAWI_DEV = 'S3B_WAWI_DEV',
  S3B_WAWI_PROD = 'S3B_WAWI_PROD'
}

export enum C_Sale_Unit {
  SU1_PIECE = 'SU1_PIECE',
  SU2_100G = 'SU2_100G',
  SU3_1000G = 'SU3_1000G',
  SU4_PIECE_AND_WEIGTH = 'SU4_PIECE_AND_WEIGTH',
  SU5_OPEN_AMOUNT = 'SU5_OPEN_AMOUNT',
  SU6_OPEN_AMOUNT_MINUS = 'SU6_OPEN_AMOUNT_MINUS'
}

export enum C_Save_Operation_Status {
  SOS0_DATA_UNCHANGED = 'SOS0_DATA_UNCHANGED',
  SOS1_DATA_CHANGED = 'SOS1_DATA_CHANGED'
}

export enum C_Special_Price_Type {
  SP1_PRICE = 'SP1_PRICE',
  SP2_DISCOUNT = 'SP2_DISCOUNT',
  SP3_PRICE_AND_DISCOUNT = 'SP3_PRICE_AND_DISCOUNT',
  SP4_PRICE_IF_QUANTITY_MORE = 'SP4_PRICE_IF_QUANTITY_MORE',
  SP5_DISCOUNT_IF_QUANTITY_MORE = 'SP5_DISCOUNT_IF_QUANTITY_MORE',
  SP6_PRICE_AND_DISCOUNT_IF_QUANTITY_MORE = 'SP6_PRICE_AND_DISCOUNT_IF_QUANTITY_MORE'
}

export enum C_Statistic_Calc_Status {
  SCS_ERROR = 'SCS_ERROR',
  SCS_LOADING = 'SCS_LOADING',
  SCS_SUCCESS = 'SCS_SUCCESS'
}

export enum C_Statistic_Group_By_Type {
  SGRP1_ARTICLE = 'SGRP1_ARTICLE',
  SGRP2_CUSTOMER_ARTICLE = 'SGRP2_CUSTOMER_ARTICLE',
  SGRP3_ARTICLE_CUSTOMER = 'SGRP3_ARTICLE_CUSTOMER',
  SGRP4_DATE_ARTICLE = 'SGRP4_DATE_ARTICLE',
  SGRP5_ARTICLE_DATE = 'SGRP5_ARTICLE_DATE',
  SGRP6_ARTICLE_DATE_CUSTOMER = 'SGRP6_ARTICLE_DATE_CUSTOMER',
  SGRP7_ARTICLE_DATE_RANGE_DETAIL = 'SGRP7_ARTICLE_DATE_RANGE_DETAIL',
  SGRP8_ARTICLE_DATE_RANGE_DETAIL_TURNOVER = 'SGRP8_ARTICLE_DATE_RANGE_DETAIL_TURNOVER'
}

export enum C_Statistic_Period_Type {
  SPT_DAY = 'SPT_DAY',
  SPT_MONTH = 'SPT_MONTH',
  SPT_YEAR = 'SPT_YEAR'
}

export enum C_Task_Group_Type {
  TG1_ACTIONS_AUTOMATION = 'TG1_ACTIONS_AUTOMATION',
  TG2_REPORTS_AUTOMATION = 'TG2_REPORTS_AUTOMATION'
}

export enum C_Task_Type {
  TT1_HOGASHOP_EXPORT_ARTICLES = 'TT1_HOGASHOP_EXPORT_ARTICLES',
  TT2_HOGASHOP_EXPORT_PRICES = 'TT2_HOGASHOP_EXPORT_PRICES',
  TT3_HOGASHOP_IMPORT_ORDERS = 'TT3_HOGASHOP_IMPORT_ORDERS',
  TT4_REIMPORT_DEFAULT_ORDERS = 'TT4_REIMPORT_DEFAULT_ORDERS',
  TT5_PRINT_PRODUCTION_REPORT = 'TT5_PRINT_PRODUCTION_REPORT',
  TT6_EXPORT_FOR_WEBSHOP = 'TT6_EXPORT_FOR_WEBSHOP',
  TT7_TOOLBOX_IMPORT = 'TT7_TOOLBOX_IMPORT',
  TT8_TOOLBOX_EXPORT = 'TT8_TOOLBOX_EXPORT',
  TT9_CUSTOMERS_IMPORT = 'TT9_CUSTOMERS_IMPORT'
}

export enum C_Tax_System {
  TAX1_INCLUDED_VAT = 'TAX1_INCLUDED_VAT',
  TAX2_EXCLUDED_VAT = 'TAX2_EXCLUDED_VAT',
  TAX3_NO_VAT = 'TAX3_NO_VAT',
  TAX4_INDIVIDUAL_FOR_CUSTOMER = 'TAX4_INDIVIDUAL_FOR_CUSTOMER'
}

export enum C_Vat_Code {
  VT1_NORMAL = 'VT1_NORMAL',
  VT2_REDUCED = 'VT2_REDUCED',
  VT3_SPECIAL1 = 'VT3_SPECIAL1',
  VT4_SPECIAL2 = 'VT4_SPECIAL2',
  VT5_ZERO = 'VT5_ZERO'
}

export enum C_Virtual_Position {
  VP1_PAGE_BREAK = 'VP1_PAGE_BREAK',
  VP2_DELIVERY_COST = 'VP2_DELIVERY_COST',
  VP3_GROUP_HEADER = 'VP3_GROUP_HEADER'
}

export enum C_Weigth_Fraction_Type {
  WFT0_G_100G = 'WFT0_G_100G',
  WFT1_MG_100G = 'WFT1_MG_100G',
  WFT2_G_1OZ = 'WFT2_G_1OZ',
  WFT3_G_1LB = 'WFT3_G_1LB',
  WFT4_KCAL_100G = 'WFT4_KCAL_100G',
  WFT5_KJ_100G = 'WFT5_KJ_100G',
  WFT6_CAL_100G = 'WFT6_CAL_100G',
  WFT7_MG_1OZ = 'WFT7_MG_1OZ',
  WFT8_MUG_100G = 'WFT8_MUG_100G',
  WFT9_NG_100G = 'WFT9_NG_100G',
  WFT10_KCAL_1OZ = 'WFT10_KCAL_1OZ',
  WFT11_KJ_1OZ = 'WFT11_KJ_1OZ',
  WFT12_CAL_1OZ = 'WFT12_CAL_1OZ',
  WFT13_KCAL_1LB = 'WFT13_KCAL_1LB',
  WFT14_KJ_1LB = 'WFT14_KJ_1LB',
  WFT15_CAL_1LB = 'WFT15_CAL_1LB'
}

export enum C_Win_Report_Task_Status {
  WRTS1_NOT_STARTED = 'WRTS1_NOT_STARTED',
  WRTS2_READY = 'WRTS2_READY',
  WRTS3_ERROR_BUILDING = 'WRTS3_ERROR_BUILDING',
  WRTS4_ERROR_PRINTING = 'WRTS4_ERROR_PRINTING',
  WRTS5_IN_PROGRESS = 'WRTS5_IN_PROGRESS',
  WRTS6_CANCELLED_BY_USER = 'WRTS6_CANCELLED_BY_USER',
  WRTS7_ERROR_PUBLISH = 'WRTS7_ERROR_PUBLISH',
  WRTS8_ERROR_CONNECTION_TO_DB = 'WRTS8_ERROR_CONNECTION_TO_DB',
  WRTS9_ERROR_CREATING_PDF = 'WRTS9_ERROR_CREATING_PDF',
  WRTS10_ERROR_CREATING_ADAPTED_PDF = 'WRTS10_ERROR_CREATING_ADAPTED_PDF',
  WRTS11_ERROR_READING_TASK_PARAMS = 'WRTS11_ERROR_READING_TASK_PARAMS',
  WRTS12_NO_PDF_CREATING_PROCEDURE = 'WRTS12_NO_PDF_CREATING_PROCEDURE',
  WRTS13_SETTING_NO_PRINT_REPORT = 'WRTS13_SETTING_NO_PRINT_REPORT',
  WRTS14_GENERATED_TOO_MANY_PAGES = 'WRTS14_GENERATED_TOO_MANY_PAGES',
  WRTS15_NO_DATA_FOR_REPORT = 'WRTS15_NO_DATA_FOR_REPORT'
}

export enum C_Xls_File_Processing_Status {
  SCS_ERROR = 'SCS_ERROR',
  SCS_LOADING = 'SCS_LOADING',
  SCS_SUCCESS = 'SCS_SUCCESS'
}

export enum C_Zenprod_Environment {
  ZE_PRODUCTION = 'ZE_PRODUCTION',
  ZE_TEST = 'ZE_TEST'
}

export type CreateProductionReportParamsInput = {
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
  productionPrintListID: Scalars['Int']['input'];
};

export type CursorsParams = {
  /** Number of records to include after cursor */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Number of records to include before cursor */
  before?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum Dict_Linked_Records_Fields {
  ARTICLE_NO = 'ARTICLE_NO',
  CUSTOMER_NO = 'CUSTOMER_NO',
  DATE = 'DATE',
  DELIVERY_NOTE_NO = 'DELIVERY_NOTE_NO',
  INVOICE_NO = 'INVOICE_NO',
  NAME = 'NAME',
  OFFER_NO = 'OFFER_NO',
  PRICE = 'PRICE',
  PROFILE_ID = 'PROFILE_ID'
}

export enum Dict_Linked_Records_Names {
  ARTICLES = 'ARTICLES',
  CUSTOMERS = 'CUSTOMERS',
  CUSTOMER_PROFILES = 'CUSTOMER_PROFILES',
  DRAFT_OFFERS = 'DRAFT_OFFERS',
  DRAFT_ORDERS = 'DRAFT_ORDERS',
  INVOICES = 'INVOICES',
  OFFERS = 'OFFERS',
  ORDERS = 'ORDERS',
  PRODUCTION_REPORTS = 'PRODUCTION_REPORTS',
  PROFILES = 'PROFILES'
}

export type DateTimeIntervalInput = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EmailAttachmentInput = {
  fileName: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FullDateIntervalInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type FullDateTimeIntervalInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type ListB2B_ArticlesForStandardOrderInput = {
  customerId: Scalars['ID']['input'];
  filter?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<C_Language>;
  listExisted: Array<Scalars['ID']['input']>;
  pageIndex: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type ListQueryArgs = {
  /** Parameters for cursor pagination */
  cursors?: InputMaybe<CursorsParams>;
  /** Force update ignoring cached mod_ver */
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mod_ver?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<SearchParams>;
  sort?: InputMaybe<Array<SortParams>>;
};

export enum Order_Offer_Warning_Types {
  MIN_MAX = 'MIN_MAX',
  NOT_ENOUGH_DAYS_TO_PRODUCE = 'NOT_ENOUGH_DAYS_TO_PRODUCE',
  QUANTITY_PER_LOT = 'QUANTITY_PER_LOT',
  SPLITTING = 'SPLITTING'
}

export enum Order_Offer_Warning_Type_Fields {
  AMOUNT_AFTER_SPLITTING = 'AMOUNT_AFTER_SPLITTING',
  ARTICLE = 'ARTICLE',
  DAYS_TO_PRODUCE = 'DAYS_TO_PRODUCE',
  QUANTITY = 'QUANTITY',
  QUANTITY_MAX = 'QUANTITY_MAX',
  QUANTITY_MIN = 'QUANTITY_MIN',
  QUANTITY_PER_LOT = 'QUANTITY_PER_LOT'
}

export type PrintProductionReportParamsInput = {
  onDate: Scalars['Date']['input'];
  pdfUrl: Scalars['String']['input'];
  productionPrintListId: Scalars['ID']['input'];
};

export type R6_ArticleListInput = {
  articlesIds: Array<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  priceCategory?: InputMaybe<Scalars['ID']['input']>;
  priceValidOn: Scalars['Date']['input'];
};

export type R36_ArticleListAllPriceCategoriesInput = {
  articlesIds: Array<Scalars['ID']['input']>;
  priceValidOn: Scalars['Date']['input'];
};

export type R50_ArticleListWithImageInput = {
  articlesIds: Array<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  priceCategory?: InputMaybe<Scalars['ID']['input']>;
  priceValidOn: Scalars['Date']['input'];
};

export type RangeIds = {
  from: Scalars['ID']['input'];
  to: Scalars['ID']['input'];
};

export type RangeNumbersInput = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

export type SaveB2B_CustomerStandardOrderInput = {
  customerId: Scalars['ID']['input'];
  orderData: Array<SaveStandardOrderPositionInput>;
};

export type SaveStandardOrderPositionInput = {
  amountFri?: InputMaybe<Scalars['Float']['input']>;
  amountMon?: InputMaybe<Scalars['Float']['input']>;
  amountSat?: InputMaybe<Scalars['Float']['input']>;
  amountSun?: InputMaybe<Scalars['Float']['input']>;
  amountThu?: InputMaybe<Scalars['Float']['input']>;
  amountTue?: InputMaybe<Scalars['Float']['input']>;
  amountWed?: InputMaybe<Scalars['Float']['input']>;
  articleId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type SearchParams = {
  columns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  string?: InputMaybe<Scalars['String']['input']>;
};

export type SendMultipleEmailsInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to: Array<Scalars['String']['input']>;
};

export type SendSingleEmailInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type SortParams = {
  field: Scalars['String']['input'];
  order?: InputMaybe<SortOrder>;
};

export type StdOrderQuantitiesInput = {
  qtyFri: Scalars['Int']['input'];
  qtyMon: Scalars['Int']['input'];
  qtySat: Scalars['Int']['input'];
  qtySun: Scalars['Int']['input'];
  qtyThu: Scalars['Int']['input'];
  qtyTue: Scalars['Int']['input'];
  qtyWed: Scalars['Int']['input'];
};

export type TimeIntervalInput = {
  from?: InputMaybe<Scalars['Time']['input']>;
  to?: InputMaybe<Scalars['Time']['input']>;
};

export type Wa_AiContentTranslationInput = {
  contentType: C_Content_Translation_Type;
  originalContent: Scalars['String']['input'];
  targetLanguages: Array<Scalars['ID']['input']>;
};

export type Wa_AddCustomerConnectedWithBakery2BClientInput = {
  customerId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type Wa_ArticleAssortimentGroupCheckedStateInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_ArticleCloudPrintersCheckedStateInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_ArticleCustomWeekDaysAndDeliveryPeriodInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isDeliveredFri: Scalars['Boolean']['input'];
  isDeliveredMon: Scalars['Boolean']['input'];
  isDeliveredSat: Scalars['Boolean']['input'];
  isDeliveredSun: Scalars['Boolean']['input'];
  isDeliveredThu: Scalars['Boolean']['input'];
  isDeliveredTue: Scalars['Boolean']['input'];
  isDeliveredWed: Scalars['Boolean']['input'];
  isRepeatYearly: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_ArticleDeliveryPeriodsSettingsInput = {
  articleCustomWeekDaysAndDeliveryPeriods: Array<Wa_ArticleCustomWeekDaysAndDeliveryPeriodInput>;
  articleRegularDeliveryPeriods: Array<Wa_ArticleRegularDeliveryPeriodInput>;
  articleVacations: Array<Wa_ArticleVacationInput>;
};

export type Wa_ArticleFilter = {
  articleListId?: InputMaybe<Scalars['ID']['input']>;
  assortimentGroupId?: InputMaybe<Scalars['ID']['input']>;
  cashAssistArticleGroupId?: InputMaybe<Scalars['ID']['input']>;
  cashAssistTemplateId?: InputMaybe<Scalars['ID']['input']>;
  discountGroupId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  marketingGroupId?: InputMaybe<Scalars['ID']['input']>;
  productionGroupId?: InputMaybe<Scalars['ID']['input']>;
  shippingPointId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_ArticleImportDataInput = {
  articleNo: Scalars['String']['input'];
  availabilityInProcurementKindId?: InputMaybe<C_Procurement_Product_Kind>;
  caProductGroupId?: InputMaybe<Scalars['String']['input']>;
  caTemplateId?: InputMaybe<Scalars['String']['input']>;
  caVisibilityStatusId?: InputMaybe<C_Ca_Visibility_Status>;
  consumersInformation?: InputMaybe<Scalars['String']['input']>;
  consumersStorageInfo?: InputMaybe<Scalars['String']['input']>;
  countOfSheetsPerCuttingMachine?: InputMaybe<Scalars['Int']['input']>;
  countPerSheetOfCuttingMachine?: InputMaybe<Scalars['Int']['input']>;
  daysShelfLife?: InputMaybe<Scalars['Int']['input']>;
  daysToConsume?: InputMaybe<Scalars['Int']['input']>;
  daysToProduce?: InputMaybe<Scalars['Int']['input']>;
  daysToSell?: InputMaybe<Scalars['Int']['input']>;
  declaration?: InputMaybe<Scalars['String']['input']>;
  declarationTranslations?: InputMaybe<Array<Wa_ArticleImportTranslatedContentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionTranslations?: InputMaybe<Array<Wa_ArticleImportTranslatedContentInput>>;
  discountGroupId?: InputMaybe<Scalars['ID']['input']>;
  doughSplittingDough1Amount?: InputMaybe<Scalars['Float']['input']>;
  doughWeightBeforeBaking?: InputMaybe<Scalars['Float']['input']>;
  eanCode?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredFri?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredMon?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSun?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredThu?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredTue?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredWed?: InputMaybe<Scalars['Boolean']['input']>;
  isDough?: InputMaybe<Scalars['Boolean']['input']>;
  isDoughSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  isEanCodeManagedByCA?: InputMaybe<Scalars['Boolean']['input']>;
  isNoDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  isNotifyOnOrderStage?: InputMaybe<Scalars['Boolean']['input']>;
  isProductionQuantityRounding?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnProductionPrintLists?: InputMaybe<Scalars['Boolean']['input']>;
  isStoreInCoolPlace?: InputMaybe<Scalars['Boolean']['input']>;
  marketingGroupId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  price1?: InputMaybe<Scalars['Float']['input']>;
  price2?: InputMaybe<Scalars['Float']['input']>;
  price3?: InputMaybe<Scalars['Float']['input']>;
  price4?: InputMaybe<Scalars['Float']['input']>;
  price5?: InputMaybe<Scalars['Float']['input']>;
  price6?: InputMaybe<Scalars['Float']['input']>;
  price7?: InputMaybe<Scalars['Float']['input']>;
  price8?: InputMaybe<Scalars['Float']['input']>;
  price9?: InputMaybe<Scalars['Float']['input']>;
  price10?: InputMaybe<Scalars['Float']['input']>;
  productionGroupId?: InputMaybe<Scalars['ID']['input']>;
  productionQuantityRoundTo?: InputMaybe<Scalars['Int']['input']>;
  quantityPerLot?: InputMaybe<Scalars['Float']['input']>;
  roundLitersTo?: InputMaybe<Scalars['Float']['input']>;
  saleUnitId?: InputMaybe<C_Sale_Unit>;
  sellingWeight?: InputMaybe<Scalars['Int']['input']>;
  shippingPointId?: InputMaybe<Scalars['ID']['input']>;
  shippingWeight?: InputMaybe<Scalars['Int']['input']>;
  storagePlace?: InputMaybe<Scalars['String']['input']>;
  vatCode?: InputMaybe<C_Vat_Code>;
  weightOfLiterOfDough?: InputMaybe<Scalars['Float']['input']>;
  willReplacedWithProductionCalc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_ArticleImportTranslatedContentInput = {
  content: Scalars['String']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  languageTag?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_ArticleListCheckedStateInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_ArticleListInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_ArticlePricesByCustomer = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  fromQuantity?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  specialDiscount?: InputMaybe<Scalars['Float']['input']>;
  specialIsNoDiscount: Scalars['Boolean']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  specialPriceType: C_Special_Price_Type;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_ArticleProductionCalculationItemInput = {
  addedArticleId: Scalars['ID']['input'];
  multiplier: Scalars['Float']['input'];
};

export type Wa_ArticleRegularDeliveryPeriodInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isRepeatYearly: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_ArticleResellerPrices = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ArticleSpecialPricesGridItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price1?: InputMaybe<Scalars['Float']['input']>;
  price2?: InputMaybe<Scalars['Float']['input']>;
  price3?: InputMaybe<Scalars['Float']['input']>;
  price4?: InputMaybe<Scalars['Float']['input']>;
  price5?: InputMaybe<Scalars['Float']['input']>;
  price6?: InputMaybe<Scalars['Float']['input']>;
  price7?: InputMaybe<Scalars['Float']['input']>;
  price8?: InputMaybe<Scalars['Float']['input']>;
  price9?: InputMaybe<Scalars['Float']['input']>;
  price10?: InputMaybe<Scalars['Float']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_ArticleStdPriceInput = {
  articleId: Scalars['ID']['input'];
  priceCategory: Scalars['Int']['input'];
};

export type Wa_ArticleVacationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_ArticlesFieldForCheck = {
  articleNo?: InputMaybe<Scalars['String']['input']>;
  productionRecipeId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_AssortimentGroupInput = {
  name: Scalars['String']['input'];
};

export type Wa_BesrInfoInputs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  cashDiscountAmount?: InputMaybe<Scalars['Float']['input']>;
  creditDate?: InputMaybe<Scalars['Date']['input']>;
  customerInfo?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  fibuAccountNo?: InputMaybe<Scalars['String']['input']>;
  flagBookAfter?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiceNo?: InputMaybe<Scalars['Int']['input']>;
  isOk: Scalars['Boolean']['input'];
  mikrofilmNo?: InputMaybe<Scalars['String']['input']>;
  postedAmount?: InputMaybe<Scalars['Float']['input']>;
  priceForDeposit?: InputMaybe<Scalars['Float']['input']>;
  processingDate?: InputMaybe<Scalars['Date']['input']>;
  refNo?: InputMaybe<Scalars['String']['input']>;
  residualAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_Bakery2bStatisticInput = {
  fromDate: Scalars['Date']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_BankInput = {
  bankBIC?: InputMaybe<Scalars['String']['input']>;
  bankLocation?: InputMaybe<Scalars['String']['input']>;
  customerLocation?: InputMaybe<Scalars['String']['input']>;
  customerName1?: InputMaybe<Scalars['String']['input']>;
  customerName2?: InputMaybe<Scalars['String']['input']>;
  customerStreet?: InputMaybe<Scalars['String']['input']>;
  fibuAccount?: InputMaybe<Scalars['String']['input']>;
  flagBookingAfter?: InputMaybe<C_Booking_Type>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  memberNo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pcAccount?: InputMaybe<Scalars['String']['input']>;
  qrIBAN?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CloudPrinterInput = {
  name: Scalars['String']['input'];
  serialNo: Scalars['String']['input'];
};

export type Wa_ConnectBakery2bUserInput = {
  customerId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderAddNewItem?: InputMaybe<Scalars['Boolean']['input']>;
  orderNoDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  orderShowPrice?: InputMaybe<Scalars['Boolean']['input']>;
  standardOrderEdit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_CreateArticleInput = {
  articleImage?: InputMaybe<Scalars['String']['input']>;
  articleNo: Scalars['String']['input'];
  articlePricesByCustomers?: InputMaybe<Array<Wa_ArticlePricesByCustomer>>;
  articleResellerPrices?: InputMaybe<Array<Wa_ArticleResellerPrices>>;
  articleSpecialPrices?: InputMaybe<Array<Wa_ArticleSpecialPricesGridItemInput>>;
  description: Scalars['String']['input'];
  discountGroupId?: InputMaybe<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
  isNoDiscount: Scalars['Boolean']['input'];
  isNotifyOnOrderStage: Scalars['Boolean']['input'];
  marketingGroupId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  price1?: InputMaybe<Scalars['Float']['input']>;
  price2?: InputMaybe<Scalars['Float']['input']>;
  price3?: InputMaybe<Scalars['Float']['input']>;
  price4?: InputMaybe<Scalars['Float']['input']>;
  price5?: InputMaybe<Scalars['Float']['input']>;
  price6?: InputMaybe<Scalars['Float']['input']>;
  price7?: InputMaybe<Scalars['Float']['input']>;
  price8?: InputMaybe<Scalars['Float']['input']>;
  price9?: InputMaybe<Scalars['Float']['input']>;
  price10?: InputMaybe<Scalars['Float']['input']>;
  productionGroupId?: InputMaybe<Scalars['ID']['input']>;
  quantityPerLot?: InputMaybe<Scalars['Float']['input']>;
  saleUnitId: C_Sale_Unit;
  shippingPointId?: InputMaybe<Scalars['ID']['input']>;
  vatCode: C_Vat_Code;
};

export type Wa_CreateArticleSpecialPricesInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  saveToDate: Scalars['Date']['input'];
  specialPrices: Array<Wa_SpecialPricesInput>;
};

export type Wa_CreateCustomerInput = {
  addition?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAddressKindId: C_Customer_Address_Kind;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerNo: Scalars['String']['input'];
  deliveryAddressAddition?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCity?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCountry?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressGln?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressPostBox?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSalutation?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteGroupId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailForInvoice?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  invoiceNoteTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  isActive: Scalars['Boolean']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderNoteTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  phoneBusiness?: InputMaybe<Scalars['String']['input']>;
  phoneBusiness2?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phonePrivate?: InputMaybe<Scalars['String']['input']>;
  postBox?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CreateInvoiceInputs = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  isPaidByCash: Scalars['Boolean']['input'];
  linkText?: InputMaybe<Scalars['ID']['input']>;
  manuallySelectedOrdersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  note?: InputMaybe<Scalars['String']['input']>;
  note2?: InputMaybe<Scalars['String']['input']>;
  ordersEndDate: Scalars['Date']['input'];
  ordersStartDate: Scalars['Date']['input'];
};

export type Wa_CreateOfferInputs = {
  creationOptions: Wa_OfferModificationOptionsInputs;
  customerId: Scalars['ID']['input'];
  draftOfferIdToDelete?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerForDate: Scalars['Date']['input'];
  positions: Array<Wa_OfferPositionInputs>;
};

export type Wa_CreateOneTimeCustomerInput = {
  addition?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  correspondenceLanguage?: InputMaybe<C_Correspondence_Language>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAddressKindId?: InputMaybe<C_Customer_Address_Kind>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  deliveryAddressAddition?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCity?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCountry?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressGln?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressPostBox?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSalutation?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressZipCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailForInvoice?: InputMaybe<Scalars['String']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  invoicingIntervalId: C_Invoice_Interval;
  name: Scalars['String']['input'];
  orderReportId: C_Report;
  paymentPeriod?: InputMaybe<Scalars['Int']['input']>;
  phoneBusiness?: InputMaybe<Scalars['String']['input']>;
  postBox?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subCompanyId?: InputMaybe<Scalars['ID']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CreateOrderInputs = {
  creationOptions: Wa_OrderModificationOptions;
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  draftOrderIdToDelete?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  note2?: InputMaybe<Scalars['String']['input']>;
  notePlainText?: InputMaybe<Scalars['String']['input']>;
  orderType: C_Order_Type;
  positions: Array<Wa_OrderPositionInputs>;
  referenceOrderNo?: InputMaybe<Scalars['String']['input']>;
  specialAddress?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_CreateProductionPrintListInput = {
  addDaysForPreProduction?: InputMaybe<Scalars['Int']['input']>;
  articlesSortingKindId: C_Production_Article_Sorting_Kind;
  crosstableEasyModeSplitNoFilter?: InputMaybe<Scalars['String']['input']>;
  customersSortingKindId?: InputMaybe<C_Production_Customer_Sorting_Kind>;
  isActive: Scalars['Boolean']['input'];
  isAvailableFri: Scalars['Boolean']['input'];
  isAvailableMon: Scalars['Boolean']['input'];
  isAvailableSat: Scalars['Boolean']['input'];
  isAvailableSun: Scalars['Boolean']['input'];
  isAvailableThu: Scalars['Boolean']['input'];
  isAvailableTue: Scalars['Boolean']['input'];
  isAvailableWed: Scalars['Boolean']['input'];
  isCrosstableEasyMode: Scalars['Boolean']['input'];
  isHighlightArticlesFromProductionCalc: Scalars['Boolean']['input'];
  isNeedSignatureOnForwardingList: Scalars['Boolean']['input'];
  isOnlyPositionsWithIndividualText: Scalars['Boolean']['input'];
  isPrintDeliveryNotesForTourplan: Scalars['Boolean']['input'];
  isShowDeliverySplitting: Scalars['Boolean']['input'];
  isShowIndividualTexts: Scalars['Boolean']['input'];
  isShowProductionDescription: Scalars['Boolean']['input'];
  isShowSemiProductsDetails: Scalars['Boolean']['input'];
  isSplitDoughBeforePrint: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  reportId: C_Report;
  tourplanDay?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_CreatedInvoicesGridFilter = {
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerListId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  emailState?: InputMaybe<C_Email_Msg_State>;
  filterBy: C_Created_Invoices_Filter_Mode;
  invoicesNoRange?: InputMaybe<RangeNumbersInput>;
  withDeleted: Scalars['Boolean']['input'];
};

export type Wa_CreatedOrdersGridFilter = {
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  customerListId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  deliveryNotesRange?: InputMaybe<RangeNumbersInput>;
  emailState?: InputMaybe<C_Email_Msg_State>;
  filterBy: C_Created_Orders_Filter_Mode;
  orderType?: InputMaybe<C_Order_Type>;
  withDeleted: Scalars['Boolean']['input'];
};

export type Wa_CustomerAssortimentGroupCheckedStateInput = {
  checked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CustomerCustomWeekDaysAndDeliveryPeriodInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isDeliveredFri: Scalars['Boolean']['input'];
  isDeliveredMon: Scalars['Boolean']['input'];
  isDeliveredSat: Scalars['Boolean']['input'];
  isDeliveredSun: Scalars['Boolean']['input'];
  isDeliveredThu: Scalars['Boolean']['input'];
  isDeliveredTue: Scalars['Boolean']['input'];
  isDeliveredWed: Scalars['Boolean']['input'];
  isRepeatYearly: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_CustomerDefOrderReportInput = {
  customerId: Scalars['ID']['input'];
  doIncludeAllArticles: Scalars['Boolean']['input'];
  periodStart: Scalars['Date']['input'];
};

export type Wa_CustomerDeliveryPeriodsSettingsInput = {
  customerCustomWeekDaysAndDeliveryPeriods: Array<Wa_CustomerCustomWeekDaysAndDeliveryPeriodInput>;
  customerRegularDeliveryPeriods: Array<Wa_CustomerRegularDeliveryPeriodInput>;
  customerVacations: Array<Wa_CustomerVacationInput>;
};

export type Wa_CustomerFieldsForCheck = {
  bank1MandatNo?: InputMaybe<Scalars['String']['input']>;
  bank2MandatNo?: InputMaybe<Scalars['String']['input']>;
  customerNo?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CustomerFilter = {
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerListId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_CustomerGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CustomerImportDataInput = {
  addition?: InputMaybe<Scalars['String']['input']>;
  bank1AccountNo?: InputMaybe<Scalars['String']['input']>;
  bank1BIC?: InputMaybe<Scalars['String']['input']>;
  bank1BIN?: InputMaybe<Scalars['String']['input']>;
  bank1IBAN?: InputMaybe<Scalars['String']['input']>;
  bank1MandatNo?: InputMaybe<Scalars['String']['input']>;
  bank1MandatSignatureDate?: InputMaybe<Scalars['Date']['input']>;
  bank1Name?: InputMaybe<Scalars['String']['input']>;
  bank2AccountNo?: InputMaybe<Scalars['String']['input']>;
  bank2BIC?: InputMaybe<Scalars['String']['input']>;
  bank2BIN?: InputMaybe<Scalars['String']['input']>;
  bank2IBAN?: InputMaybe<Scalars['String']['input']>;
  bank2MandatNo?: InputMaybe<Scalars['String']['input']>;
  bank2MandatSignatureDate?: InputMaybe<Scalars['Date']['input']>;
  bank2Name?: InputMaybe<Scalars['String']['input']>;
  besrBankId?: InputMaybe<Scalars['ID']['input']>;
  caPriceAndDiscountSourceId?: InputMaybe<C_Discounts_And_Prices_Kind>;
  caSpecialDiscount?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAddressKindId?: InputMaybe<C_Customer_Address_Kind>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerNo?: InputMaybe<Scalars['String']['input']>;
  debitorStatus?: InputMaybe<C_Debitor_Status>;
  debtorAccount?: InputMaybe<Scalars['Int']['input']>;
  defaultNoteInInvoice?: InputMaybe<Scalars['String']['input']>;
  defaultNoteInInvoice2?: InputMaybe<Scalars['String']['input']>;
  defaultNoteInOrder?: InputMaybe<Scalars['String']['input']>;
  defaultNoteInOrder2?: InputMaybe<Scalars['String']['input']>;
  defaultOrderSourceId?: InputMaybe<C_Customer_Def_Order_Source>;
  deliveryAddressAddition?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCity?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCountry?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressPostBox?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSalutation?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteCopies?: InputMaybe<Scalars['Int']['input']>;
  deliveryNoteGroupId?: InputMaybe<Scalars['ID']['input']>;
  deliverySplittingPartsCount?: InputMaybe<Scalars['Int']['input']>;
  directDebitBankId?: InputMaybe<C_Direct_Debit_Banks>;
  discountKindId?: InputMaybe<C_Discount_Kind>;
  discountOnGroup1?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup2?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup3?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup4?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup5?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup6?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup7?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup8?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup9?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup10?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup11?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup12?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup13?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup14?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup15?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup16?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup17?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup18?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup19?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup20?: InputMaybe<Scalars['Float']['input']>;
  distributionHigherLimit?: InputMaybe<Scalars['Int']['input']>;
  distributionLowerLimit?: InputMaybe<Scalars['Int']['input']>;
  eBillAccount?: InputMaybe<Scalars['String']['input']>;
  eInvoiceFormat?: InputMaybe<C_E_Invoice_Format>;
  eInvoiceRoutingAddress?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailForInvoice?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  individualPaymentTerms?: InputMaybe<Scalars['String']['input']>;
  informationTip?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  invoiceCopies?: InputMaybe<Scalars['Int']['input']>;
  invoicePaymentSlipReportId?: InputMaybe<C_Report>;
  invoiceReportId?: InputMaybe<C_Report>;
  invoiceSummaryReportId?: InputMaybe<C_Report>;
  invoicingIntervalId?: InputMaybe<C_Invoice_Interval>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedAutoOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysInTourplan?: InputMaybe<Scalars['Boolean']['input']>;
  isCashAssistCreditCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredFri?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredMon?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSun?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredThu?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredTue?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredWed?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliverySplitting?: InputMaybe<Scalars['Boolean']['input']>;
  isFlexibleOrders?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerReportId?: InputMaybe<C_Report>;
  orderReportId?: InputMaybe<C_Report>;
  paymentPeriod?: InputMaybe<Scalars['Int']['input']>;
  phoneBusiness?: InputMaybe<Scalars['String']['input']>;
  phoneBusiness2?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phonePrivate?: InputMaybe<Scalars['String']['input']>;
  postBox?: InputMaybe<Scalars['String']['input']>;
  priceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  quantityDiscountSettingId?: InputMaybe<Scalars['ID']['input']>;
  returnLimit?: InputMaybe<Scalars['Float']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  skonto?: InputMaybe<Scalars['Float']['input']>;
  skontoPeriod?: InputMaybe<Scalars['Int']['input']>;
  slipReferenceNo?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  taxSystemId?: InputMaybe<C_Tax_System>;
  tourDepartureTime?: InputMaybe<Scalars['String']['input']>;
  tourPosition?: InputMaybe<Scalars['Int']['input']>;
  tourPreparationArea?: InputMaybe<Scalars['String']['input']>;
  tourSatDepartureTime?: InputMaybe<Scalars['String']['input']>;
  tourSatPosition?: InputMaybe<Scalars['Int']['input']>;
  tourSatPreparationArea?: InputMaybe<Scalars['String']['input']>;
  tourSunDepartureTime?: InputMaybe<Scalars['String']['input']>;
  tourSunPosition?: InputMaybe<Scalars['Int']['input']>;
  tourSunPreparationArea?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
  tourplanNote?: InputMaybe<Scalars['String']['input']>;
  tourplanSatId?: InputMaybe<Scalars['ID']['input']>;
  tourplanSunId?: InputMaybe<Scalars['ID']['input']>;
  transportSectorId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CustomerListCheckedStateInput = {
  checked: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CustomerListInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_CustomerProfileInput = {
  besrBankId?: InputMaybe<Scalars['ID']['input']>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  customerDeliveryPeriodsSettings?: InputMaybe<Wa_CustomerDeliveryPeriodsSettingsInput>;
  debitorStatus?: InputMaybe<C_Debitor_Status>;
  debtorAccount?: InputMaybe<Scalars['Int']['input']>;
  discountKindId?: InputMaybe<C_Discount_Kind>;
  discountOnGroup1?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup2?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup3?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup4?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup5?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup6?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup7?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup8?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup9?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup10?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup11?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup12?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup13?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup14?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup15?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup16?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup17?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup18?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup19?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup20?: InputMaybe<Scalars['Float']['input']>;
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentSlipReportId?: InputMaybe<C_Report>;
  invoiceReportId?: InputMaybe<C_Report>;
  invoiceSummaryReportId?: InputMaybe<C_Report>;
  invoicingIntervalId?: InputMaybe<C_Invoice_Interval>;
  isDeliveredFri?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredMon?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSun?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredThu?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredTue?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredWed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orderReportId?: InputMaybe<C_Report>;
  paymentPeriod?: InputMaybe<Scalars['Int']['input']>;
  priceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  quantityDiscountSettingId?: InputMaybe<Scalars['ID']['input']>;
  skonto?: InputMaybe<Scalars['Float']['input']>;
  skontoPeriod?: InputMaybe<Scalars['Int']['input']>;
  slipReferenceNo?: InputMaybe<Scalars['String']['input']>;
  taxSystemId?: InputMaybe<C_Tax_System>;
};

export type Wa_CustomerRegularDeliveryPeriodInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  isRepeatYearly: Scalars['Boolean']['input'];
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_CustomerResellerPricesGridItemInput = {
  articleId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_CustomerSpecialPricesGridItemInput = {
  articleId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  fromQuantity?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  specialDiscount?: InputMaybe<Scalars['Float']['input']>;
  specialIsNoDiscount: Scalars['Boolean']['input'];
  specialPrice?: InputMaybe<Scalars['Float']['input']>;
  specialPriceType: C_Special_Price_Type;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_CustomerVacationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Wa_CustomersForCreatingOrdersGridFilter = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['Date']['input'];
  deliveryNoteGroupId?: InputMaybe<Scalars['ID']['input']>;
  filterBy: C_New_Orders_Filter_Mode;
  orderType: C_Order_Type;
};

export type Wa_CustomersForNewInvoicesGridFilter = {
  customersActiveState: Scalars['Boolean']['input'];
  deliveryNoteGroupId?: InputMaybe<Scalars['ID']['input']>;
  invoicingIntervalId?: InputMaybe<C_Invoice_Interval>;
  ordersEndDate: Scalars['Date']['input'];
  ordersStartDate: Scalars['Date']['input'];
  showEmailService: Scalars['Boolean']['input'];
  showMailDelivery: Scalars['Boolean']['input'];
};

export type Wa_DebitorReportParamsInput = {
  customerId: Scalars['ID']['input'];
  invoicesList: Array<Scalars['ID']['input']>;
  paymentsTill: Scalars['Date']['input'];
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
  reminderTextId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_DebtReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reminderText?: InputMaybe<Scalars['String']['input']>;
  reminderTextTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
};

export type Wa_DefaultOrderPositionByArticleInput = {
  canChangeInOrders: Scalars['Boolean']['input'];
  customerId: Scalars['ID']['input'];
  fridaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  itemSortPos?: InputMaybe<Scalars['Int']['input']>;
  mondaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  saturdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  sundaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  thursdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  tuesdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  wednesdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
};

export type Wa_DefaultOrderPositionInput = {
  articleId: Scalars['ID']['input'];
  canChangeInOrders: Scalars['Boolean']['input'];
  fridaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  itemSortPos: Scalars['Int']['input'];
  mondaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  saturdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  sundaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  thursdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  tuesdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
  wednesdaySettings: Wa_DefaultOrderPositionWeekDaySettingsInput;
};

export type Wa_DefaultOrderPositionSplittingPresetInput = {
  fridaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
  mondaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
  saturdaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
  sundaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
  thursdaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
  tuesdaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
  wednesdaySettings: Wa_DefaultOrderPositionWeekDaySplittingPresetInput;
};

export type Wa_DefaultOrderPositionWeekDaySettingsInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  quantityMax?: InputMaybe<Scalars['Float']['input']>;
  quantityMin?: InputMaybe<Scalars['Float']['input']>;
  splittingPartsPreset: Array<Scalars['String']['input']>;
};

export type Wa_DefaultOrderPositionWeekDaySplittingPresetInput = {
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splittingPartsPreset: Array<Scalars['String']['input']>;
};

export type Wa_DeleteCustomerConnectedWithBakery2BClientInput = {
  customerId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
};

export type Wa_DeleteInvoiceInputs = {
  attachedOrdersAction: C_Attached_Orders_Action;
  deletingReason: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  paymentsToDeleteIds: Array<Scalars['ID']['input']>;
};

export type Wa_DeliveryNoteGroupInput = {
  name: Scalars['String']['input'];
};

export type Wa_DiscountGroupInput = {
  name: Scalars['String']['input'];
};

export type Wa_DraftOfferInputs = {
  customerId: Scalars['ID']['input'];
  draftOfferId?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerForDate: Scalars['Date']['input'];
  positions: Array<Wa_OfferPositionInputs>;
};

export type Wa_DraftOrderInputs = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  draftOrderId?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  note2?: InputMaybe<Scalars['String']['input']>;
  positions: Array<Wa_OrderPositionInputs>;
  referenceOrderNo?: InputMaybe<Scalars['String']['input']>;
  specialAddress?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_ExportAbacusInvoicesInputs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};

export type Wa_ExportAbacusPaymentsInputs = {
  paymentIds: Array<Scalars['ID']['input']>;
  skipAlreadyExported?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_ExportDatevInvoicesInputs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};

export type Wa_ExportSepaInvoicesInputs = {
  invoiceIds: Array<Scalars['ID']['input']>;
};

export type Wa_FileOfDocumentInput = {
  s3Bucket: C_S3_Bucket;
  s3Key: Scalars['String']['input'];
};

export type Wa_FilterDate = {
  date?: InputMaybe<Scalars['String']['input']>;
  secondDate?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_FontDescriptionInput = {
  family: Scalars['String']['input'];
  size: Scalars['Int']['input'];
  style?: InputMaybe<Wa_FontStyleInput>;
};

export type Wa_FontStyleInput = {
  isBold: Scalars['Boolean']['input'];
  isItalic: Scalars['Boolean']['input'];
  isUnderline: Scalars['Boolean']['input'];
};

export type Wa_GeneralFilter = {
  column?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_GetReportInput = {
  docType: C_History_Pdf_Doctype;
  documentId: Scalars['ID']['input'];
};

export type Wa_InitInvoiceExportPdfsInputs = {
  invoiceExport: Scalars['Boolean']['input'];
  invoiceIds: Array<Scalars['ID']['input']>;
  invoicePaymentslipExport: Scalars['Boolean']['input'];
  invoiceSummaryExport: Scalars['Boolean']['input'];
};

export type Wa_InitProdStatisticInputs = {
  articleList?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerList?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  groupBy: C_Group_By_Type;
  subCompaniesList?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Wa_ListReportsInput = {
  docsType: C_History_Pdf_Doctype;
  documentsIds: Array<Scalars['ID']['input']>;
  mergeFiles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_MarketingGroupInput = {
  name: Scalars['String']['input'];
};

export type Wa_MergePdfInput = {
  s3Bucket: C_S3_Bucket;
  s3Key: Scalars['String']['input'];
};

export type Wa_MultiSaveArticleInput = {
  articleListsCheckedState?: InputMaybe<Array<Wa_ArticleListCheckedStateInput>>;
  availabilityInProcurementKindId?: InputMaybe<C_Procurement_Product_Kind>;
  caProductGroupId?: InputMaybe<Scalars['ID']['input']>;
  caTemplateId?: InputMaybe<Scalars['ID']['input']>;
  caVisibilityStatusId?: InputMaybe<C_Ca_Visibility_Status>;
  discountGroupId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEanCodeManagedByCA?: InputMaybe<Scalars['Boolean']['input']>;
  isNoDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  isNotifyOnOrderStage?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnProductionPrintLists?: InputMaybe<Scalars['Boolean']['input']>;
  marketingGroupId?: InputMaybe<Scalars['ID']['input']>;
  price1?: InputMaybe<Scalars['Float']['input']>;
  price2?: InputMaybe<Scalars['Float']['input']>;
  price3?: InputMaybe<Scalars['Float']['input']>;
  price4?: InputMaybe<Scalars['Float']['input']>;
  price5?: InputMaybe<Scalars['Float']['input']>;
  price6?: InputMaybe<Scalars['Float']['input']>;
  price7?: InputMaybe<Scalars['Float']['input']>;
  price8?: InputMaybe<Scalars['Float']['input']>;
  price9?: InputMaybe<Scalars['Float']['input']>;
  price10?: InputMaybe<Scalars['Float']['input']>;
  productionGroupId?: InputMaybe<Scalars['ID']['input']>;
  quantityPerLot?: InputMaybe<Scalars['Float']['input']>;
  saleUnitId?: InputMaybe<C_Sale_Unit>;
  shippingPointId?: InputMaybe<Scalars['ID']['input']>;
  vatCode?: InputMaybe<C_Vat_Code>;
};

export type Wa_MultiSaveCustomerInput = {
  caPriceAndDiscountSourceId?: InputMaybe<C_Discounts_And_Prices_Kind>;
  caSpecialDiscount?: InputMaybe<Scalars['Float']['input']>;
  correspondenceLanguage?: InputMaybe<C_Correspondence_Language>;
  customerAddressKindId?: InputMaybe<C_Customer_Address_Kind>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerListsCheckedState?: InputMaybe<Array<Wa_CustomerListCheckedStateInput>>;
  debitorStatus?: InputMaybe<C_Debitor_Status>;
  defaultOrderSourceId?: InputMaybe<C_Customer_Def_Order_Source>;
  deliveryNoteGroupId?: InputMaybe<Scalars['ID']['input']>;
  eInvoiceFormat?: InputMaybe<C_E_Invoice_Format>;
  ids: Array<Scalars['ID']['input']>;
  invoiceCopies?: InputMaybe<Scalars['Int']['input']>;
  invoicePaymentSlipReportId?: InputMaybe<C_Report>;
  invoiceReportId?: InputMaybe<C_Report>;
  invoiceSummaryReportId?: InputMaybe<C_Report>;
  invoicingIntervalId?: InputMaybe<C_Invoice_Interval>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedAutoOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isCashAssistCreditCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  isFlexibleOrders?: InputMaybe<Scalars['Boolean']['input']>;
  offerReportId?: InputMaybe<C_Report>;
  orderReportId?: InputMaybe<C_Report>;
  paymentPeriod?: InputMaybe<Scalars['Int']['input']>;
  priceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  returnLimit?: InputMaybe<Scalars['Float']['input']>;
  skonto?: InputMaybe<Scalars['Float']['input']>;
  skontoPeriod?: InputMaybe<Scalars['Float']['input']>;
  taxSystemId?: InputMaybe<C_Tax_System>;
};

export type Wa_MultipleOrdersPositionInputs = {
  positionId: Scalars['ID']['input'];
  quantity: Scalars['Float']['input'];
};

export type Wa_OfferDataInputs = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  draftOfferId?: InputMaybe<Scalars['String']['input']>;
  mode: C_Offer_Selection_Mode;
  offerForDate?: InputMaybe<Scalars['Date']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  offerNo?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_OfferModificationOptionsInputs = {
  ignoreQuantityPerLotProblems: Scalars['Boolean']['input'];
};

export type Wa_OfferPositionInputs = {
  articleId?: InputMaybe<Scalars['ID']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  indTextDeliveryNote?: InputMaybe<Scalars['String']['input']>;
  indTextProduction?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
  vatCode?: InputMaybe<C_Vat_Code>;
  virtualPositionId?: InputMaybe<C_Virtual_Position>;
};

export type Wa_OffersGridFilter = {
  date?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  emailState?: InputMaybe<C_Email_Msg_State>;
  filterBy: C_Offers_Filter_Mode;
};

export type Wa_OrderAndArticleInputs = {
  articleId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  orderDate: Scalars['Date']['input'];
  quantity: Scalars['Float']['input'];
  vatCode: C_Vat_Code;
};

export type Wa_OrderDataForNewOrderInputs = {
  acceptedOfferId?: InputMaybe<Scalars['ID']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  draftOrderId?: InputMaybe<Scalars['ID']['input']>;
  mode: C_New_Order_Selection_Mode;
  onDate: Scalars['Date']['input'];
  orderType: C_Order_Type;
  sourceOrderDate?: InputMaybe<Scalars['Date']['input']>;
  sourceOrderNo?: InputMaybe<Scalars['Int']['input']>;
};

export type Wa_OrderModificationOptions = {
  ignoreDaysToProduce: Scalars['Boolean']['input'];
  ignoreMinMaxProblems: Scalars['Boolean']['input'];
  ignoreQuantityPerLotProblems: Scalars['Boolean']['input'];
  ignoreSplittingProblems: Scalars['Boolean']['input'];
};

export type Wa_OrderPositionInputs = {
  articleId?: InputMaybe<Scalars['ID']['input']>;
  correctionValue?: InputMaybe<Scalars['Float']['input']>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  indTextDeliveryNote?: InputMaybe<Scalars['String']['input']>;
  indTextProduction?: InputMaybe<Scalars['String']['input']>;
  positionId?: InputMaybe<Scalars['ID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Float']['input'];
  splittingPartsPreset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  total?: InputMaybe<Scalars['Float']['input']>;
  vatCode: C_Vat_Code;
  virtualPositionId?: InputMaybe<C_Virtual_Position>;
};

export type Wa_OrderTypesFilterInProductionReportsCheckedStateInput = {
  checked: Scalars['Boolean']['input'];
  id: C_Order_Type;
};

export type Wa_OverviewInput = {
  deliveryNoteGroupId?: InputMaybe<Scalars['Int']['input']>;
  periodEnd: Scalars['Date']['input'];
  periodStart: Scalars['Date']['input'];
};

export type Wa_PaymentForInvoiceInputs = {
  accountNo?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['ID']['input'];
  paymentDate: Scalars['Date']['input'];
  receiptNo?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_PaymentsGridFilter = {
  customerId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  filterBy: C_Payments_Filter_Mode;
  invoicesNoRange?: InputMaybe<RangeNumbersInput>;
};

export type Wa_PdfFileOfInvoiceInput = {
  invoiceId: Scalars['ID']['input'];
  pdfFile: Wa_FileOfDocumentInput;
};

export type Wa_PriceCategoryInput = {
  name: Scalars['String']['input'];
  vat: C_Tax_System;
};

export type Wa_PriceCategoryMappingBetweenWaAndCaInput = {
  caCategoryId: Scalars['ID']['input'];
  caCategoryIsCafe: Scalars['Boolean']['input'];
  waCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_PriceRateForWeightInput = {
  price: Scalars['Float']['input'];
  weight: Scalars['Int']['input'];
};

export type Wa_ProcurementProductsGridFilter = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  procurementProductKindId?: InputMaybe<C_Procurement_Product_Kind>;
  storageLocationId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_ProducedArticlesQuantityInput = {
  producedQuantity?: InputMaybe<Scalars['Float']['input']>;
  recordId: Scalars['ID']['input'];
};

export type Wa_ProductionGroupInput = {
  name: Scalars['String']['input'];
};

export type Wa_ProductionPrintJobsGridFilter = {
  fromDate: Scalars['Date']['input'];
  groupId?: InputMaybe<Scalars['ID']['input']>;
  printListsActiveState?: InputMaybe<Scalars['Boolean']['input']>;
  reportGroupIds: Array<C_Report_Group>;
  toDate: Scalars['Date']['input'];
};

export type Wa_ProductionPrintListCrosstableDataInput = {
  categoryCustomFilterDelivery?: InputMaybe<Scalars['String']['input']>;
  categoryCustomerId?: InputMaybe<Scalars['ID']['input']>;
  categoryCustomerListId?: InputMaybe<Scalars['ID']['input']>;
  categoryFilterCustomer?: InputMaybe<Scalars['String']['input']>;
  categoryFilterDeliveryType?: InputMaybe<C_Order_Type>;
  categoryFilterSplitNo?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['ID']['input'];
  categoryName: Scalars['String']['input'];
};

export type Wa_ProductionPrintListFilterCheckedStateInput = {
  checked: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type Wa_ProductionPrintListGroupInput = {
  name: Scalars['String']['input'];
};

export type Wa_ProductionPrintListOrderFilterCheckedStateInput = {
  checked: Scalars['Boolean']['input'];
  id: C_Order_Type;
};

export type Wa_ProductionPrintListTourplanDataInput = {
  categoryFilter?: InputMaybe<Array<Wa_ProductionPrintListFilterCheckedStateInput>>;
  categoryId: Scalars['ID']['input'];
  categoryName: Scalars['String']['input'];
};

export type Wa_ProductionPrintListsGridFilter = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  printListsActiveState?: InputMaybe<Scalars['Boolean']['input']>;
  reportGroupIds: Array<C_Report_Group>;
};

export type Wa_ProductionReportDiffOrderedAndProducedInput = {
  dateOfLiveData: Scalars['Date']['input'];
  productionPrintListId: Scalars['ID']['input'];
};

export type Wa_ProductionReportDiffVersionsInput = {
  productionPrintListId: Scalars['ID']['input'];
  versionOfDataId1: Scalars['ID']['input'];
  versionOfDataId2: Scalars['ID']['input'];
};

export type Wa_ProductionReportFromVersionInput = {
  productionPrintListId: Scalars['ID']['input'];
  versionOfDataId: Scalars['ID']['input'];
};

export type Wa_QuantityDiscountInput = {
  discountValues?: InputMaybe<Array<Wa_QuantityDiscountValueInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_QuantityDiscountValueInput = {
  discountOnAllGroups?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup1?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup2?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup3?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup4?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup5?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup6?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup7?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup8?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup9?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup10?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup11?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup12?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup13?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup14?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup15?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup16?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup17?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup18?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup19?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup20?: InputMaybe<Scalars['Float']['input']>;
  fromAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReCalcOrdersInputs = {
  customerIds: Array<Scalars['ID']['input']>;
  fromDate: Scalars['Date']['input'];
  isOnlyCAOrders: Scalars['Boolean']['input'];
  isRefreshPrices: Scalars['Boolean']['input'];
  isRefreshTaxesAndDiscounts: Scalars['Boolean']['input'];
  toDate: Scalars['Date']['input'];
};

export type Wa_ReportConfigArticlePricelistInput = {
  address?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  footerText?: InputMaybe<Wa_ReportFooterObjectWithFormattedTextInput>;
  letterhead?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  logo1Page?: InputMaybe<Wa_ReportImageInput>;
  logoFrom2ndPage?: InputMaybe<Wa_ReportImageInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  pageNumbering?: InputMaybe<Wa_ReportFooterObjectInput>;
  printedAt?: InputMaybe<Wa_ReportFooterObjectInput>;
};

export type Wa_ReportConfigDebtReminderInput = {
  address?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  bankInformation?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  createdBy?: InputMaybe<Wa_ReportFooterObjectInput>;
  footerImage?: InputMaybe<Wa_ReportFooterImageInput>;
  footerText?: InputMaybe<Wa_ReportFooterObjectWithFormattedTextInput>;
  letterhead?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  logo?: InputMaybe<Wa_ReportImageInput>;
  pageBgImage?: InputMaybe<Wa_ReportPageBgImageInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  pageNumbering?: InputMaybe<Wa_ReportFooterObjectInput>;
  printedAt?: InputMaybe<Wa_ReportFooterObjectInput>;
};

export type Wa_ReportConfigDeliveryNoteA4Input = {
  companyVatNo?: InputMaybe<Wa_ReportObjectVisibilityInput>;
  createdBy?: InputMaybe<Wa_ReportFooterObjectInput>;
  deliveryAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  footerImage?: InputMaybe<Wa_ReportFooterImageInput>;
  footerText?: InputMaybe<Wa_ReportFooterObjectWithFormattedTextInput>;
  invoiceAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  letterhead?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  logo?: InputMaybe<Wa_ReportImageInput>;
  pageBgImage?: InputMaybe<Wa_ReportPageBgImageInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  pageNumbering?: InputMaybe<Wa_ReportFooterObjectInput>;
  phoneNumber?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  printedAt?: InputMaybe<Wa_ReportFooterObjectInput>;
  receiversSignature?: InputMaybe<Wa_ReportObjectInput>;
  sellerPerson?: InputMaybe<Wa_ReportObjectInput>;
};

export type Wa_ReportConfigDeliveryNoteA5Input = {
  companyVatNo?: InputMaybe<Wa_ReportObjectVisibilityInput>;
  createdBy?: InputMaybe<Wa_ReportFooterObjectInput>;
  deliveryAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  footerImage?: InputMaybe<Wa_ReportFooterImageInput>;
  footerText?: InputMaybe<Wa_ReportFooterObjectWithFormattedTextInput>;
  invoiceAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  letterhead?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  logo?: InputMaybe<Wa_ReportImageInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  pageNumbering?: InputMaybe<Wa_ReportFooterObjectInput>;
  phoneNumber?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  printedAt?: InputMaybe<Wa_ReportFooterObjectInput>;
};

export type Wa_ReportConfigInvoiceInput = {
  bankInformation?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  companyVatNo?: InputMaybe<Wa_ReportObjectVisibilityInput>;
  createdBy?: InputMaybe<Wa_ReportFooterObjectInput>;
  deliveryAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  footerImage?: InputMaybe<Wa_ReportFooterImageInput>;
  footerText?: InputMaybe<Wa_ReportFooterObjectWithFormattedTextInput>;
  invoiceAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  invoiceAddressFrom2ndPage?: InputMaybe<Wa_ReportObjectInput>;
  letterhead?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  logo1Page?: InputMaybe<Wa_ReportImageInput>;
  logoFrom2ndPage?: InputMaybe<Wa_ReportImageInput>;
  pageBgImage?: InputMaybe<Wa_ReportPageBgImageInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  pageNumbering?: InputMaybe<Wa_ReportFooterObjectInput>;
  printedAt?: InputMaybe<Wa_ReportFooterObjectInput>;
  reasonForDeletion?: InputMaybe<Wa_ReportObjectInput>;
};

export type Wa_ReportConfigOfferInput = {
  companyVatNo?: InputMaybe<Wa_ReportObjectVisibilityInput>;
  createdBy?: InputMaybe<Wa_ReportFooterObjectInput>;
  deliveryAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  footerText?: InputMaybe<Wa_ReportFooterObjectWithFormattedTextInput>;
  invoiceAddress?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  letterhead?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  logo?: InputMaybe<Wa_ReportImageInput>;
  pageBgImage?: InputMaybe<Wa_ReportPageBgImageInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  pageNumbering?: InputMaybe<Wa_ReportFooterObjectInput>;
  phoneNumber?: InputMaybe<Wa_ReportObjectWithCustomFontInput>;
  printedAt?: InputMaybe<Wa_ReportFooterObjectInput>;
};

export type Wa_ReportConfigPaymentSlipInput = {
  customText?: InputMaybe<Wa_ReportObjectWithFormattedTextInput>;
  pageMargins?: InputMaybe<Wa_ReportPageMarginsInput>;
  picture?: InputMaybe<Wa_ReportImageInput>;
};

export type Wa_ReportFooterImageInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportFooterObjectInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportFooterObjectWithFormattedTextInput = {
  formattedText?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportImageInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportObjectInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportObjectVisibilityInput = {
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_ReportObjectWithCustomFontInput = {
  fontOverride?: InputMaybe<Wa_FontDescriptionInput>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportObjectWithFormattedTextInput = {
  formattedText?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportPageBgImageInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_ReportPageMarginsInput = {
  bottom?: InputMaybe<Scalars['Float']['input']>;
  left?: InputMaybe<Scalars['Float']['input']>;
  top?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_ReportsConfigurationInput = {
  articlePricelist?: InputMaybe<Wa_ReportConfigArticlePricelistInput>;
  debtReminder?: InputMaybe<Wa_ReportConfigDebtReminderInput>;
  deliveryNoteA4?: InputMaybe<Wa_ReportConfigDeliveryNoteA4Input>;
  deliveryNoteA5?: InputMaybe<Wa_ReportConfigDeliveryNoteA5Input>;
  invoice?: InputMaybe<Wa_ReportConfigInvoiceInput>;
  offer?: InputMaybe<Wa_ReportConfigOfferInput>;
  paymentSlip?: InputMaybe<Wa_ReportConfigPaymentSlipInput>;
  subCompanyId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_SaveArticleInput = {
  articleAssortimentGroupsCheckedState?: InputMaybe<Array<Wa_ArticleAssortimentGroupCheckedStateInput>>;
  articleCloudPrintersCheckedState?: InputMaybe<Array<Wa_ArticleCloudPrintersCheckedStateInput>>;
  articleDeliveryPeriodsSettings?: InputMaybe<Wa_ArticleDeliveryPeriodsSettingsInput>;
  articleImage?: InputMaybe<Scalars['String']['input']>;
  articleListsCheckedState?: InputMaybe<Array<Wa_ArticleListCheckedStateInput>>;
  articleNo?: InputMaybe<Scalars['String']['input']>;
  articlePricesByCustomers?: InputMaybe<Array<Wa_ArticlePricesByCustomer>>;
  articleProductionCalculation?: InputMaybe<Array<Wa_ArticleProductionCalculationItemInput>>;
  articleResellerPrices?: InputMaybe<Array<Wa_ArticleResellerPrices>>;
  articleSpecialPrices?: InputMaybe<Array<Wa_ArticleSpecialPricesGridItemInput>>;
  availabilityInProcurementKindId?: InputMaybe<C_Procurement_Product_Kind>;
  caProductGroupId?: InputMaybe<Scalars['ID']['input']>;
  caTemplateId?: InputMaybe<Scalars['ID']['input']>;
  caVisibilityStatusId?: InputMaybe<C_Ca_Visibility_Status>;
  consumersInformation?: InputMaybe<Scalars['String']['input']>;
  consumersStorageInfo?: InputMaybe<Scalars['String']['input']>;
  countOfSheetsPerCuttingMachine?: InputMaybe<Scalars['Int']['input']>;
  countPerSheetOfCuttingMachine?: InputMaybe<Scalars['Int']['input']>;
  customLabelDescription?: InputMaybe<Scalars['String']['input']>;
  customLabelDescriptionTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  daysShelfLife?: InputMaybe<Scalars['Int']['input']>;
  daysToConsume?: InputMaybe<Scalars['Int']['input']>;
  daysToMoveTill?: InputMaybe<Scalars['Int']['input']>;
  daysToProduce?: InputMaybe<Scalars['Int']['input']>;
  daysToSell?: InputMaybe<Scalars['Int']['input']>;
  declaration?: InputMaybe<Scalars['String']['input']>;
  declarationTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  discountGroupId?: InputMaybe<Scalars['ID']['input']>;
  doughArticleId?: InputMaybe<Scalars['ID']['input']>;
  doughSplittingDough1Amount?: InputMaybe<Scalars['Float']['input']>;
  doughSplittingDough2Amount?: InputMaybe<Scalars['Float']['input']>;
  doughWeightBeforeBaking?: InputMaybe<Scalars['Float']['input']>;
  eanCode?: InputMaybe<Scalars['String']['input']>;
  fractionArticleId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredFri?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredMon?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSun?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredThu?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredTue?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredWed?: InputMaybe<Scalars['Boolean']['input']>;
  isDough?: InputMaybe<Scalars['Boolean']['input']>;
  isDoughSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  isEanCodeManagedByCA?: InputMaybe<Scalars['Boolean']['input']>;
  isFractionArticle?: InputMaybe<Scalars['Boolean']['input']>;
  isNoDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  isNotifyOnOrderStage?: InputMaybe<Scalars['Boolean']['input']>;
  isProductionQuantityRounding?: InputMaybe<Scalars['Boolean']['input']>;
  isRoundFractionArticleAmount?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnProductionPrintLists?: InputMaybe<Scalars['Boolean']['input']>;
  isStoreInCoolPlace?: InputMaybe<Scalars['Boolean']['input']>;
  labelRecipeId?: InputMaybe<Scalars['ID']['input']>;
  marketingGroupId?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  numberOfPartsOfFractionArticle?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  price1?: InputMaybe<Scalars['Float']['input']>;
  price2?: InputMaybe<Scalars['Float']['input']>;
  price3?: InputMaybe<Scalars['Float']['input']>;
  price4?: InputMaybe<Scalars['Float']['input']>;
  price5?: InputMaybe<Scalars['Float']['input']>;
  price6?: InputMaybe<Scalars['Float']['input']>;
  price7?: InputMaybe<Scalars['Float']['input']>;
  price8?: InputMaybe<Scalars['Float']['input']>;
  price9?: InputMaybe<Scalars['Float']['input']>;
  price10?: InputMaybe<Scalars['Float']['input']>;
  productionGroupId?: InputMaybe<Scalars['ID']['input']>;
  productionQuantityRoundTo?: InputMaybe<Scalars['Int']['input']>;
  productionRecipeId?: InputMaybe<Scalars['ID']['input']>;
  quantityPerLot?: InputMaybe<Scalars['Float']['input']>;
  roundLitersTo?: InputMaybe<Scalars['Float']['input']>;
  saleUnitId?: InputMaybe<C_Sale_Unit>;
  sellingWeight?: InputMaybe<Scalars['Int']['input']>;
  shippingPointId?: InputMaybe<Scalars['ID']['input']>;
  shippingWeight?: InputMaybe<Scalars['Int']['input']>;
  storagePlace?: InputMaybe<Scalars['String']['input']>;
  usedPartOfFractionArticle?: InputMaybe<Scalars['Int']['input']>;
  vatCode?: InputMaybe<C_Vat_Code>;
  weeklyDefaultOrderByArticle?: InputMaybe<Array<Wa_DefaultOrderPositionByArticleInput>>;
  weightOfLiterOfDough?: InputMaybe<Scalars['Float']['input']>;
  willReplacedWithProductionCalc?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_SaveBakery2bClientInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  orderAddNewItem: Scalars['Boolean']['input'];
  orderNoDelivery: Scalars['Boolean']['input'];
  orderShowPrice: Scalars['Boolean']['input'];
  standardOrderEdit: Scalars['Boolean']['input'];
};

export type Wa_SaveBakery2bSettings = {
  allowZeroOrders?: InputMaybe<Scalars['Boolean']['input']>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  emailForOrderNotifications?: InputMaybe<Scalars['String']['input']>;
  isMultiOrders?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<C_Bakery2B_Language>;
  mainCurrency?: InputMaybe<C_Bakery2B_Currency>;
  menuBgColor?: InputMaybe<C_Bakery2B_Menu_Color>;
  menuBgImg?: InputMaybe<Scalars['String']['input']>;
  orderFutureDays?: InputMaybe<Scalars['Int']['input']>;
  orderMinimalValue?: InputMaybe<Scalars['Int']['input']>;
  profileLogo?: InputMaybe<Scalars['String']['input']>;
  showTotalColumn?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  useNewSite?: InputMaybe<Scalars['Boolean']['input']>;
  useWholeNumbers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_SaveConfigInput = {
  actualInvoiceNo?: InputMaybe<Scalars['Int']['input']>;
  actualOfferNo?: InputMaybe<Scalars['Int']['input']>;
  actualOrderNo?: InputMaybe<Scalars['Int']['input']>;
  alternativeLanguageId?: InputMaybe<C_Language>;
  autoCustomerNoCounter?: InputMaybe<Scalars['Int']['input']>;
  autoCustomerNoPrefix?: InputMaybe<Scalars['String']['input']>;
  bankAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankBIC?: InputMaybe<Scalars['String']['input']>;
  bankBIN?: InputMaybe<Scalars['String']['input']>;
  bankIBAN?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  besrFormatId?: InputMaybe<C_Besr_Format>;
  canForbidIncomingOrdersCAdirect?: InputMaybe<Scalars['Boolean']['input']>;
  canWorkWithVersionsInProduction?: InputMaybe<Scalars['Boolean']['input']>;
  cloudConnectionHash?: InputMaybe<Scalars['String']['input']>;
  companyAddition?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyFax?: InputMaybe<Scalars['String']['input']>;
  companyGLN?: InputMaybe<Scalars['String']['input']>;
  companyLanguageID?: InputMaybe<C_Language>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNameInReports?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  companySalutation?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatNo?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<C_Country>;
  creditorIdNumber?: InputMaybe<Scalars['String']['input']>;
  customEmailTextForDebtor?: InputMaybe<Scalars['String']['input']>;
  customEmailTextForInvoice?: InputMaybe<Scalars['String']['input']>;
  customEmailTextForOffer?: InputMaybe<Scalars['String']['input']>;
  customEmailTextForOrder?: InputMaybe<Scalars['String']['input']>;
  debtReminderEmailTextTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  decimalPlacesCount?: InputMaybe<Scalars['Int']['input']>;
  defaultFontOfNoteInOrder?: InputMaybe<Scalars['String']['input']>;
  downloadPathForPrintingService?: InputMaybe<Scalars['String']['input']>;
  farmyApiCustomerId?: InputMaybe<Scalars['Int']['input']>;
  farmyApiToken?: InputMaybe<Scalars['String']['input']>;
  fibuClient?: InputMaybe<Scalars['Int']['input']>;
  fibuVatCodeNormal?: InputMaybe<Scalars['String']['input']>;
  fibuVatCodeReduced?: InputMaybe<Scalars['String']['input']>;
  fibuVatCodeWithoutVAT?: InputMaybe<Scalars['String']['input']>;
  globalTaxSystemId?: InputMaybe<C_Tax_System>;
  hogaShopHost?: InputMaybe<Scalars['String']['input']>;
  hogaShopPassword?: InputMaybe<Scalars['String']['input']>;
  hogaShopPath?: InputMaybe<Scalars['String']['input']>;
  hogaShopUser?: InputMaybe<Scalars['String']['input']>;
  invoiceEmailTextTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  isAddPaymentSlipToInvoiceReportPDF?: InputMaybe<Scalars['Boolean']['input']>;
  isAddSummaryToInvoiceReportPDF?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowSameEANForMultipleArticles?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoCustomerNo?: InputMaybe<Scalars['Boolean']['input']>;
  isBakery2bActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isCACustomerAutoPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isCAFilialAutoPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isCAOrderExportActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCAReturnAutoPrint?: InputMaybe<Scalars['Boolean']['input']>;
  isDatevCommitment?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultEmailTextForDebtor?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultEmailTextForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultEmailTextForOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultEmailTextForOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryNotePicturesDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnFri?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnMon?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnSat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnSun?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnThu?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnTue?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveryOnWed?: InputMaybe<Scalars['Boolean']['input']>;
  isDoughInLitersInProductionReports?: InputMaybe<Scalars['Boolean']['input']>;
  isEditUsualOrdersInBakery2b?: InputMaybe<Scalars['Boolean']['input']>;
  isGotoNextDeliveryDay?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoicePicturesDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPossibleToUseAnotherLngSettings?: InputMaybe<Scalars['Boolean']['input']>;
  isShippingFunctionActivated?: InputMaybe<Scalars['Boolean']['input']>;
  isShowRASemiproductsDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isShowShippingPointsInArticle?: InputMaybe<Scalars['Boolean']['input']>;
  isShowSplittedAmountInLiters?: InputMaybe<Scalars['Boolean']['input']>;
  isSupportTLS12?: InputMaybe<Scalars['Boolean']['input']>;
  isTotalsUpdatesNotMoreNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  isUseBillNoAsOrderNo?: InputMaybe<Scalars['Boolean']['input']>;
  isUseNET?: InputMaybe<Scalars['Boolean']['input']>;
  isUsePriceCategoryAhead?: InputMaybe<Scalars['Boolean']['input']>;
  isUsePrintingServiceForToolboxImport?: InputMaybe<Scalars['Boolean']['input']>;
  isUseProcurementLogicInProductionReports?: InputMaybe<Scalars['Boolean']['input']>;
  isWebOrdersAutoPrint?: InputMaybe<Scalars['Boolean']['input']>;
  kiloAmountRepresentationId?: InputMaybe<C_Kg_Representation>;
  offerEmailTextTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  oneTimeCustomerDefaultSettingsId?: InputMaybe<Scalars['ID']['input']>;
  operationCostCenter?: InputMaybe<Scalars['Int']['input']>;
  orderEmailTextTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  orderPositionsSortingKindId?: InputMaybe<C_Order_Positions_Sorting_Kind>;
  orderTypesFilterInProductionReportsCheckedState?: InputMaybe<Array<Wa_OrderTypesFilterInProductionReportsCheckedStateInput>>;
  printingServiceComputerGUID?: InputMaybe<Scalars['String']['input']>;
  printingServiceComputerName?: InputMaybe<Scalars['String']['input']>;
  printingServiceLastActivity?: InputMaybe<Scalars['Date']['input']>;
  richMemoFont?: InputMaybe<Scalars['String']['input']>;
  roundingArticlePricesMethodId?: InputMaybe<C_Rounding_Method>;
  roundingTotalPricesMethodId?: InputMaybe<C_Rounding_Method>;
  smtpPassword?: InputMaybe<Scalars['String']['input']>;
  smtpPort?: InputMaybe<Scalars['Int']['input']>;
  smtpReceiverAddress?: InputMaybe<Scalars['String']['input']>;
  smtpSenderAddress?: InputMaybe<Scalars['String']['input']>;
  smtpServer?: InputMaybe<Scalars['String']['input']>;
  smtpUseSSL?: InputMaybe<Scalars['Boolean']['input']>;
  smtpUser?: InputMaybe<Scalars['String']['input']>;
  standardBankId?: InputMaybe<Scalars['ID']['input']>;
  toolboxExportArticleListsFilterCheckedState?: InputMaybe<Array<Scalars['ID']['input']>>;
  toolboxImportPathForPrintingService?: InputMaybe<Scalars['String']['input']>;
  toolboxStandardDeliveryNo?: InputMaybe<Scalars['Int']['input']>;
  uploadPathForPrintingService?: InputMaybe<Scalars['String']['input']>;
  useTourSettingForEveryOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Wa_SaveCustomerInput = {
  addition?: InputMaybe<Scalars['String']['input']>;
  bank1AccountNo?: InputMaybe<Scalars['String']['input']>;
  bank1BIC?: InputMaybe<Scalars['String']['input']>;
  bank1BIN?: InputMaybe<Scalars['String']['input']>;
  bank1IBAN?: InputMaybe<Scalars['String']['input']>;
  bank1MandatNo?: InputMaybe<Scalars['String']['input']>;
  bank1MandatSignatureDate?: InputMaybe<Scalars['Date']['input']>;
  bank1Name?: InputMaybe<Scalars['String']['input']>;
  bank2AccountNo?: InputMaybe<Scalars['String']['input']>;
  bank2BIC?: InputMaybe<Scalars['String']['input']>;
  bank2BIN?: InputMaybe<Scalars['String']['input']>;
  bank2IBAN?: InputMaybe<Scalars['String']['input']>;
  bank2MandatNo?: InputMaybe<Scalars['String']['input']>;
  bank2MandatSignatureDate?: InputMaybe<Scalars['Date']['input']>;
  bank2Name?: InputMaybe<Scalars['String']['input']>;
  besrBankId?: InputMaybe<Scalars['ID']['input']>;
  caPriceAndDiscountSourceId?: InputMaybe<C_Discounts_And_Prices_Kind>;
  caSpecialDiscount?: InputMaybe<Scalars['Float']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  collectiveInvoicingToCustomerId?: InputMaybe<Scalars['ID']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  correspondenceLanguage?: InputMaybe<C_Correspondence_Language>;
  costCenter?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAddressKindId?: InputMaybe<C_Customer_Address_Kind>;
  customerAssortimentGroupsCheckedState?: InputMaybe<Array<Wa_CustomerAssortimentGroupCheckedStateInput>>;
  customerDeliveryPeriodsSettings?: InputMaybe<Wa_CustomerDeliveryPeriodsSettingsInput>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  customerListsCheckedState?: InputMaybe<Array<Wa_CustomerListCheckedStateInput>>;
  customerNo?: InputMaybe<Scalars['String']['input']>;
  customerResellerPrices?: InputMaybe<Array<Wa_CustomerResellerPricesGridItemInput>>;
  customerSpecialPrices?: InputMaybe<Array<Wa_CustomerSpecialPricesGridItemInput>>;
  customerWeeklyDefaultOrder?: InputMaybe<Array<Wa_DefaultOrderPositionInput>>;
  debitorStatus?: InputMaybe<C_Debitor_Status>;
  debtorAccount?: InputMaybe<Scalars['Int']['input']>;
  defaultNoteInInvoice?: InputMaybe<Scalars['String']['input']>;
  defaultNoteInInvoice2?: InputMaybe<Scalars['String']['input']>;
  defaultNoteInOrder?: InputMaybe<Scalars['String']['input']>;
  defaultNoteInOrder2?: InputMaybe<Scalars['String']['input']>;
  defaultOrderOverrideFromCustomerId?: InputMaybe<Scalars['ID']['input']>;
  defaultOrderSourceId?: InputMaybe<C_Customer_Def_Order_Source>;
  deliveryAddressAddition?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCity?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCountry?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressGln?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressPostBox?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSalutation?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressZipCode?: InputMaybe<Scalars['String']['input']>;
  deliveryNoteCopies?: InputMaybe<Scalars['Int']['input']>;
  deliveryNoteGroupId?: InputMaybe<Scalars['ID']['input']>;
  deliverySplittingPartsCount?: InputMaybe<Scalars['Int']['input']>;
  directDebitBankId?: InputMaybe<C_Direct_Debit_Banks>;
  discountKindId?: InputMaybe<C_Discount_Kind>;
  discountOnGroup1?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup2?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup3?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup4?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup5?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup6?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup7?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup8?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup9?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup10?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup11?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup12?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup13?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup14?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup15?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup16?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup17?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup18?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup19?: InputMaybe<Scalars['Float']['input']>;
  discountOnGroup20?: InputMaybe<Scalars['Float']['input']>;
  distributionHigherLimit?: InputMaybe<Scalars['Int']['input']>;
  distributionLowerLimit?: InputMaybe<Scalars['Int']['input']>;
  eBillAccount?: InputMaybe<Scalars['String']['input']>;
  eInvoiceFormat?: InputMaybe<C_E_Invoice_Format>;
  eInvoiceRoutingAddress?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailForInvoice?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  incomeAccount?: InputMaybe<Scalars['String']['input']>;
  individualPaymentTerms?: InputMaybe<Scalars['String']['input']>;
  informationTip?: InputMaybe<Scalars['String']['input']>;
  internalName?: InputMaybe<Scalars['String']['input']>;
  invoiceCopies?: InputMaybe<Scalars['Int']['input']>;
  invoiceNoteTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  invoicePaymentSlipReportId?: InputMaybe<C_Report>;
  invoiceReportId?: InputMaybe<C_Report>;
  invoiceSummaryReportId?: InputMaybe<C_Report>;
  invoicingIntervalId?: InputMaybe<C_Invoice_Interval>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowedAutoOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isAlwaysInTourplan?: InputMaybe<Scalars['Boolean']['input']>;
  isCashAssistCreditCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredFri?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredMon?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSat?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredSun?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredThu?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredTue?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliveredWed?: InputMaybe<Scalars['Boolean']['input']>;
  isDeliverySplitting?: InputMaybe<Scalars['Boolean']['input']>;
  isFlexibleOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isOneTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerReportId?: InputMaybe<C_Report>;
  orderNoteTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
  orderReportId?: InputMaybe<C_Report>;
  paymentPeriod?: InputMaybe<Scalars['Int']['input']>;
  phoneBusiness?: InputMaybe<Scalars['String']['input']>;
  phoneBusiness2?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phonePrivate?: InputMaybe<Scalars['String']['input']>;
  postBox?: InputMaybe<Scalars['String']['input']>;
  priceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  quantityDiscountSettingId?: InputMaybe<Scalars['ID']['input']>;
  returnLimit?: InputMaybe<Scalars['Float']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  skonto?: InputMaybe<Scalars['Float']['input']>;
  skontoPeriod?: InputMaybe<Scalars['Float']['input']>;
  slipReferenceNo?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subCompanyId?: InputMaybe<Scalars['ID']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  taxSystemId?: InputMaybe<C_Tax_System>;
  tourDepartureTime?: InputMaybe<Scalars['String']['input']>;
  tourPosition?: InputMaybe<Scalars['Int']['input']>;
  tourPreparationArea?: InputMaybe<Scalars['String']['input']>;
  tourSatDepartureTime?: InputMaybe<Scalars['String']['input']>;
  tourSatPosition?: InputMaybe<Scalars['Int']['input']>;
  tourSatPreparationArea?: InputMaybe<Scalars['String']['input']>;
  tourSunDepartureTime?: InputMaybe<Scalars['String']['input']>;
  tourSunPosition?: InputMaybe<Scalars['Int']['input']>;
  tourSunPreparationArea?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
  tourplanNote?: InputMaybe<Scalars['String']['input']>;
  tourplanSatId?: InputMaybe<Scalars['ID']['input']>;
  tourplanSunId?: InputMaybe<Scalars['ID']['input']>;
  transportSectorId?: InputMaybe<Scalars['ID']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_SaveDoughSplittingInfoOnDateInput = {
  id: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
  part1?: InputMaybe<Scalars['Float']['input']>;
  part2?: InputMaybe<Scalars['Float']['input']>;
  part3?: InputMaybe<Scalars['Float']['input']>;
  part4?: InputMaybe<Scalars['Float']['input']>;
  part5?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_SaveOfferInputs = {
  linkText?: InputMaybe<Scalars['ID']['input']>;
  modificationOptions: Wa_OfferModificationOptionsInputs;
  note?: InputMaybe<Scalars['String']['input']>;
  offerForDate: Scalars['Date']['input'];
  offerId: Scalars['ID']['input'];
  positions: Array<Wa_OfferPositionInputs>;
  validUntilDate: Scalars['Date']['input'];
};

export type Wa_SaveOneTimeCustomerInput = {
  addition?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  correspondenceLanguage?: InputMaybe<C_Correspondence_Language>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerAddressKindId?: InputMaybe<C_Customer_Address_Kind>;
  customerGroupId?: InputMaybe<Scalars['ID']['input']>;
  deliveryAddressAddition?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCity?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressCountry?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressGln?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressName?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressPostBox?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressSalutation?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressStreet?: InputMaybe<Scalars['String']['input']>;
  deliveryAddressZipCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailForInvoice?: InputMaybe<Scalars['String']['input']>;
  gln?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invoicingIntervalId: C_Invoice_Interval;
  isOneTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  orderReportId: C_Report;
  paymentPeriod?: InputMaybe<Scalars['Int']['input']>;
  phoneBusiness?: InputMaybe<Scalars['String']['input']>;
  postBox?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subCompanyId?: InputMaybe<Scalars['ID']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_SaveOrderInputs = {
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  deliveryTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  linkText?: InputMaybe<Scalars['ID']['input']>;
  modificationOptions: Wa_OrderModificationOptions;
  note?: InputMaybe<Scalars['String']['input']>;
  note2?: InputMaybe<Scalars['String']['input']>;
  notePlainText?: InputMaybe<Scalars['String']['input']>;
  orderType: C_Order_Type;
  positions: Array<Wa_OrderPositionInputs>;
  referenceOrderNo?: InputMaybe<Scalars['String']['input']>;
  specialAddress?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_SavePositionsInMultiOrdersInputs = {
  id: Scalars['ID']['input'];
  modificationOptions: Wa_OrderModificationOptions;
  positions: Array<Wa_MultipleOrdersPositionInputs>;
};

export type Wa_SaveProcurementProductInput = {
  id: Scalars['ID']['input'];
  storageLocationId?: InputMaybe<Scalars['ID']['input']>;
  storageMax?: InputMaybe<Scalars['Float']['input']>;
  storageMin?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_SaveProductionPrintListInput = {
  addDaysForPreProduction?: InputMaybe<Scalars['Int']['input']>;
  articleListsFilter?: InputMaybe<Array<Wa_ProductionPrintListFilterCheckedStateInput>>;
  articlesSortingKindId?: InputMaybe<C_Production_Article_Sorting_Kind>;
  crosstableConfigurationData?: InputMaybe<Array<Wa_ProductionPrintListCrosstableDataInput>>;
  crosstableEasyModeSplitNoFilter?: InputMaybe<Scalars['String']['input']>;
  customerListsFilter?: InputMaybe<Array<Wa_ProductionPrintListFilterCheckedStateInput>>;
  customersSortingKindId?: InputMaybe<C_Production_Customer_Sorting_Kind>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableFri?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableMon?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableSat?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableSun?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableThu?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableTue?: InputMaybe<Scalars['Boolean']['input']>;
  isAvailableWed?: InputMaybe<Scalars['Boolean']['input']>;
  isCrosstableEasyMode?: InputMaybe<Scalars['Boolean']['input']>;
  isHighlightArticlesFromProductionCalc?: InputMaybe<Scalars['Boolean']['input']>;
  isNeedSignatureOnForwardingList?: InputMaybe<Scalars['Boolean']['input']>;
  isOnlyPositionsWithIndividualText?: InputMaybe<Scalars['Boolean']['input']>;
  isPrintDeliveryNotesForTourplan?: InputMaybe<Scalars['Boolean']['input']>;
  isShowDeliverySplitting?: InputMaybe<Scalars['Boolean']['input']>;
  isShowIndividualTexts?: InputMaybe<Scalars['Boolean']['input']>;
  isShowProductionDescription?: InputMaybe<Scalars['Boolean']['input']>;
  isShowSemiProductsDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isSplitDoughBeforePrint?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderTypesFilter?: InputMaybe<Array<Wa_ProductionPrintListOrderFilterCheckedStateInput>>;
  reportId?: InputMaybe<C_Report>;
  tourplanConfigurationData?: InputMaybe<Array<Wa_ProductionPrintListTourplanDataInput>>;
  tourplanDay?: InputMaybe<Scalars['String']['input']>;
  tourplanId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_SaveReportPrinterMappingsInput = {
  printedReportsKindId: C_Printed_Reports_Kind;
  printerId?: InputMaybe<Scalars['ID']['input']>;
};

export type Wa_SendReminderOfInvoiceEmailInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to: Array<Scalars['String']['input']>;
};

export type Wa_SendStockListToCloudPrinterInput = {
  printerSerialNo: Scalars['String']['input'];
  procurementProductKind?: InputMaybe<Scalars['String']['input']>;
  stockList: Array<Wa_StockListInput>;
  storageLocation?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_ShippingPointInput = {
  name: Scalars['String']['input'];
};

export type Wa_SpecialDateInput = {
  date: Scalars['Date']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  replacingDate: Scalars['Date']['input'];
};

export type Wa_SpecialPricesInput = {
  articleId: Scalars['ID']['input'];
  specialPrice1?: InputMaybe<Scalars['Float']['input']>;
  specialPrice2?: InputMaybe<Scalars['Float']['input']>;
  specialPrice3?: InputMaybe<Scalars['Float']['input']>;
  specialPrice4?: InputMaybe<Scalars['Float']['input']>;
  specialPrice5?: InputMaybe<Scalars['Float']['input']>;
  specialPrice6?: InputMaybe<Scalars['Float']['input']>;
  specialPrice7?: InputMaybe<Scalars['Float']['input']>;
  specialPrice8?: InputMaybe<Scalars['Float']['input']>;
  specialPrice9?: InputMaybe<Scalars['Float']['input']>;
  specialPrice10?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_StockListInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  productNo?: InputMaybe<Scalars['String']['input']>;
  storageActual?: InputMaybe<Scalars['Float']['input']>;
};

export type Wa_StorageLocationInput = {
  name: Scalars['String']['input'];
};

export type Wa_SubCompanyInput = {
  bankAccountNo?: InputMaybe<Scalars['String']['input']>;
  bankBIC?: InputMaybe<Scalars['String']['input']>;
  bankBIN?: InputMaybe<Scalars['String']['input']>;
  bankIBAN?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  companyAddition?: InputMaybe<Scalars['String']['input']>;
  companyCity?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyFax?: InputMaybe<Scalars['String']['input']>;
  companyGLN?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['String']['input']>;
  companySalutation?: InputMaybe<Scalars['String']['input']>;
  companyStreet?: InputMaybe<Scalars['String']['input']>;
  companyVatNo?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  companyZipCode?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<C_Country>;
  creditorIdNumber?: InputMaybe<Scalars['String']['input']>;
};

export type Wa_TextBlockInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDefaultForInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultForOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isDefaultForOrder?: InputMaybe<Scalars['Boolean']['input']>;
  textBlock?: InputMaybe<Scalars['String']['input']>;
  textBlockTranslations?: InputMaybe<Array<Wa_TranslatedContentInput>>;
};

export type Wa_TourplanInput = {
  name: Scalars['String']['input'];
};

export type Wa_TranslatedContentInput = {
  content: Scalars['String']['input'];
  languageId: Scalars['ID']['input'];
};

export type Wa_TranslationLanguageInput = {
  name: Scalars['String']['input'];
};

export type Wa_TransportSectorInput = {
  isPriceRateFixed?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priceRateFixed?: InputMaybe<Scalars['Float']['input']>;
  priceRatesForWeight?: InputMaybe<Array<Wa_PriceRateForWeightInput>>;
};

export type Wa_InitOrderStatisticInputs = {
  articlesList?: InputMaybe<Array<Scalars['ID']['input']>>;
  customersList?: InputMaybe<Array<Scalars['ID']['input']>>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  groupBy: C_Group_By_Type;
  orderTypesList?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCompaniesList?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WeekDaysAvailabilityInput = {
  friday?: InputMaybe<Scalars['Boolean']['input']>;
  monday?: InputMaybe<Scalars['Boolean']['input']>;
  saturday?: InputMaybe<Scalars['Boolean']['input']>;
  sunday?: InputMaybe<Scalars['Boolean']['input']>;
  thursday?: InputMaybe<Scalars['Boolean']['input']>;
  tuesday?: InputMaybe<Scalars['Boolean']['input']>;
  wednesday?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListWa_ArticlesQueryVariables = Exact<{
  filter?: InputMaybe<Wa_ArticleFilter>;
}>;


export type ListWa_ArticlesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_Articles: Array<{ __typename?: 'WA_ArticleGridItem', id: string, description?: string | null, articleNo?: string | null, isFractionArticle: boolean, isDough: boolean }> } | null };

export type GetArticleProductionTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleProductionTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', id: string, daysToProduce?: number | null, productionRecipeId?: string | null, isDough: boolean, doughWeightBeforeBaking?: number | null, doughArticleId?: string | null, countPerSheetOfCuttingMachine?: number | null, countOfSheetsPerCuttingMachine?: number | null, isShowOnProductionPrintLists: boolean, isDoughSplitting?: boolean | null, doughSplittingDough1Amount?: number | null, weightOfLiterOfDough?: number | null, roundLitersTo?: number | null, isFractionArticle?: boolean | null, fractionArticleId?: number | null, usedPartOfFractionArticle?: number | null, numberOfPartsOfFractionArticle?: number | null, isRoundFractionArticleAmount?: boolean | null, willReplacedWithProductionCalc: boolean, isProductionQuantityRounding: boolean, productionQuantityRoundTo?: number | null, articleDoughDataFromRA?: { __typename?: 'WA_ArticleDoughDataFromRA', id?: string | null, intermediateWeight?: number | null } | null, articleProductionCalculation: Array<{ __typename?: 'WA_ArticleProductionCalculationItem', id: string, addedArticleDescription?: string | null, addedArticleNo?: string | null, addedArticleId: string, multiplier: number }>, articleProductionCalculationDependencies: { __typename?: 'WA_ArticleProductionCalculationDependencies', whichArticlesThisUses?: Array<{ __typename?: 'WA_DependencyItem', articleNo?: string | null, description?: string | null, addedArticleNo?: string | null, addedDescription?: string | null, multiplier: number, level?: number | null } | null> | null, whichArticlesUseThis?: Array<{ __typename?: 'WA_DependencyItem', articleNo?: string | null, description?: string | null, addedArticleNo?: string | null, addedDescription?: string | null, multiplier: number, level?: number | null } | null> | null, circularChain?: Array<{ __typename?: 'WA_DependencyChainItem', articleId: string, articleNo?: string | null, description?: string | null } | null> | null, articlesLeadingToCircularDependency?: Array<{ __typename?: 'WA_DependencyChainItem', articleId: string, articleNo?: string | null, description?: string | null } | null> | null }, articleCloudPrintersCheckedState: Array<{ __typename?: 'WA_ArticleCloudPrintersCheckedState', id: string, checked?: boolean | null, label?: string | null }> } } | null };

export type GetArticleProductionCalculationDependenciesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleProductionCalculationDependenciesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', articleProductionCalculationDependencies: { __typename?: 'WA_ArticleProductionCalculationDependencies', whichArticlesThisUses?: Array<{ __typename?: 'WA_DependencyItem', articleNo?: string | null, description?: string | null, addedArticleNo?: string | null, addedDescription?: string | null, multiplier: number, level?: number | null } | null> | null, whichArticlesUseThis?: Array<{ __typename?: 'WA_DependencyItem', articleNo?: string | null, description?: string | null, addedArticleNo?: string | null, addedDescription?: string | null, multiplier: number, level?: number | null } | null> | null, circularChain?: Array<{ __typename?: 'WA_DependencyChainItem', articleId: string, articleNo?: string | null, description?: string | null } | null> | null } } } | null };

export type GetArticleCashAssitTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleCashAssitTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', caVisibilityStatusId: C_Ca_Visibility_Status, caProductGroupId?: string | null, caTemplateId?: string | null } } | null };

export type GetArticleLabelDataFromRaQueryVariables = Exact<{
  recipeId: Scalars['ID']['input'];
}>;


export type GetArticleLabelDataFromRaQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ArticleLabelDataFromRA: { __typename?: 'WA_ArticleLabelDataFromRA', id?: string | null, autoDeclaration?: string | null, declaration?: string | null, isAutoDeclaration: boolean, consumersInformation?: string | null, consumersStorageInfo?: string | null, daysToSell?: number | null, daysToConsume?: number | null, daysShelfLife?: number | null, isStoreInCoolPlace: boolean, productOutputWeight?: number | null, sellingPoints?: string | null, sellingPointsFreezer?: C_Freezer_Condition | null, sellingWeight?: number | null } } | null };

export type GetArticlePostTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticlePostTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', id: string, shippingWeight?: number | null } } | null };

export type GetArticleLabelTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleLabelTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', customLabelDescription?: string | null, origin?: string | null, eanCode?: string | null, isEanCodeManagedByCA: boolean, declaration?: string | null, isStoreInCoolPlace: boolean, storagePlace?: string | null, consumersStorageInfo?: string | null, sellingWeight?: number | null, consumersInformation?: string | null, daysToSell?: number | null, daysToConsume?: number | null, daysShelfLife?: number | null, articleLabelDataFromRA?: { __typename?: 'WA_ArticleLabelDataFromRA', id?: string | null, autoDeclaration?: string | null, declaration?: string | null, isAutoDeclaration: boolean, isStoreInCoolPlace: boolean, daysToSell?: number | null, daysToConsume?: number | null, productOutputWeight?: number | null, consumersInformation?: string | null, consumersStorageInfo?: string | null, sellingPoints?: string | null, sellingWeight?: number | null, daysShelfLife?: number | null, sellingPointsFreezer?: C_Freezer_Condition | null } | null, declarationTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }>, customLabelDescriptionTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type GetArticleGeneralTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleGeneralTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', id: string, description?: string | null, note?: string | null, isNotifyOnOrderStage: boolean, articleNo?: string | null, isActive: boolean, articleImage?: string | null, discountGroupId?: string | null, productionGroupId?: string | null, marketingGroupId?: string | null, saleUnitId: C_Sale_Unit, quantityPerLot?: number | null, vatCode: C_Vat_Code, isNoDiscount?: boolean | null, shippingPointId?: string | null, price1?: number | null, price2?: number | null, price3?: number | null, price4?: number | null, price5?: number | null, price6?: number | null, price7?: number | null, price8?: number | null, price9?: number | null, price10?: number | null, articleSpecialPrices: Array<{ __typename?: 'WA_ArticleSpecialPricesGridItem', id: string, fromDate?: any | null, toDate?: any | null, isActual: boolean, price1?: number | null, price2?: number | null, price3?: number | null, price5?: number | null, price4?: number | null, price6?: number | null, price7?: number | null, price8?: number | null, price9?: number | null, price10?: number | null, description?: string | null }>, articleResellerPrices: Array<{ __typename?: 'WA_CustomerResellerPricesGridItem', id: string, price?: number | null, customerId: string, customerNo?: string | null, customerName?: string | null, comment?: string | null }>, articlePricesByCustomers: Array<{ __typename?: 'WA_CustomerSpecialPricesGridItem', id: string, specialPrice?: number | null, specialPriceType: C_Special_Price_Type, specialDiscount?: number | null, customerId: string, customerName?: string | null, customerNo?: string | null, fromDate?: any | null, toDate?: any | null, fromQuantity?: number | null, specialIsNoDiscount: boolean, comment?: string | null }>, descriptionTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type GetArticleListsTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleListsTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', id: string, articleListsCheckedState: Array<{ __typename?: 'WA_ArticleListCheckedState', id: string, checked?: boolean | null, label?: string | null }> } } | null };

export type GetArticleAvailabilityTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleAvailabilityTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', availabilityInProcurementKindId?: C_Procurement_Product_Kind | null, isDeliveredMon: boolean, isDeliveredTue: boolean, isDeliveredWed: boolean, isDeliveredThu: boolean, isDeliveredFri: boolean, isDeliveredSat: boolean, isDeliveredSun: boolean, articleAssortimentGroupsCheckedState: Array<{ __typename?: 'WA_ArticleAssortimentGroupCheckedState', id: string, checked: boolean, label?: string | null }>, articleDeliveryPeriodsSettings: { __typename?: 'WA_ArticleDeliveryPeriodsSettings', articleRegularDeliveryPeriods: Array<{ __typename?: 'WA_ArticleRegularDeliveryPeriod', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null, isRepeatYearly: boolean }>, articleCustomWeekDaysAndDeliveryPeriods: Array<{ __typename?: 'WA_ArticleCustomWeekDaysAndDeliveryPeriod', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null, isDeliveredMon: boolean, isDeliveredTue: boolean, isDeliveredWed: boolean, isDeliveredThu: boolean, isDeliveredFri: boolean, isDeliveredSat: boolean, isDeliveredSun: boolean, isRepeatYearly: boolean }>, articleVacations: Array<{ __typename?: 'WA_ArticleVacation', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null }> } } } | null };

export type WeeklyDefaultOrderByArticleFragment = { __typename?: 'WA_DefaultOrderPositionByArticle', internalOrFullName?: string | null, customerNr?: string | null, canChangeInOrders: boolean, customerId: string, itemSortPos?: number | null, deliverySplittingPartsCount?: number | null, isActive: boolean, isDeliverySplitting: boolean, isMatchAssortmentGroup: boolean, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } };

export type GetDefaultOrderTabDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetDefaultOrderTabDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', id: string, weeklyDefaultOrderByArticle: Array<{ __typename?: 'WA_DefaultOrderPositionByArticle', internalOrFullName?: string | null, customerNr?: string | null, canChangeInOrders: boolean, customerId: string, itemSortPos?: number | null, deliverySplittingPartsCount?: number | null, isActive: boolean, isDeliverySplitting: boolean, isMatchAssortmentGroup: boolean, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } }> } } | null };

export type GetWeeklyDefaultOrderByArticleFromDateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetWeeklyDefaultOrderByArticleFromDateQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', id: string, weeklyDefaultOrderByArticle: Array<{ __typename?: 'WA_DefaultOrderPositionByArticle', internalOrFullName?: string | null, customerNr?: string | null, canChangeInOrders: boolean, customerId: string, itemSortPos?: number | null, deliverySplittingPartsCount?: number | null, isActive: boolean, isDeliverySplitting: boolean, isMatchAssortmentGroup: boolean, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } }> } } | null };

export type GetDataForNewDefaultOrderPositionByArticleQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type GetDataForNewDefaultOrderPositionByArticleQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_DataForNewDefaultOrderPositionByArticle: { __typename?: 'WA_DefaultOrderPositionByArticle', internalOrFullName?: string | null, customerNr?: string | null, canChangeInOrders: boolean, customerId: string, itemSortPos?: number | null, deliverySplittingPartsCount?: number | null, isActive: boolean, isDeliverySplitting: boolean, isMatchAssortmentGroup: boolean, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', date: any, isArticleAvailable: boolean, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } } } | null };

export type CreateArticleMutationVariables = Exact<{
  data: Wa_CreateArticleInput;
}>;


export type CreateArticleMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_Article: { __typename?: 'WA_ArticleGridItem', id: string, description?: string | null, articleNo?: string | null, isDough: boolean, isFractionArticle: boolean } } | null };

export type CopyArticleMutationVariables = Exact<{
  originalId: Scalars['ID']['input'];
  data: Wa_CreateArticleInput;
}>;


export type CopyArticleMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', copyWA_Article: { __typename?: 'WA_ArticleGridItem', id: string, description?: string | null, articleNo?: string | null, isDough: boolean, isFractionArticle: boolean } } | null };

export type SaveArticleDataMutationVariables = Exact<{
  dataToSave: Wa_SaveArticleInput;
}>;


export type SaveArticleDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveArticleData: { __typename?: 'WA_SaveArticleResult', status: C_Save_Operation_Status, updatedGridItem?: { __typename?: 'WA_ArticleGridItem', id: string, description?: string | null, articleNo?: string | null, isFractionArticle: boolean, isDough: boolean } | null } } | null };

export type SaveArticleProductionCalculationMutationVariables = Exact<{
  dataToSave: Wa_SaveArticleInput;
}>;


export type SaveArticleProductionCalculationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveArticleData: { __typename?: 'WA_SaveArticleResult', status: C_Save_Operation_Status, updatedArticleProductionCalculationDependencies?: { __typename?: 'WA_ArticleProductionCalculationDependencies', whichArticlesThisUses?: Array<{ __typename?: 'WA_DependencyItem', articleNo?: string | null, description?: string | null, addedArticleNo?: string | null, addedDescription?: string | null, multiplier: number, level?: number | null } | null> | null, whichArticlesUseThis?: Array<{ __typename?: 'WA_DependencyItem', articleNo?: string | null, description?: string | null, addedArticleNo?: string | null, addedDescription?: string | null, multiplier: number, level?: number | null } | null> | null, circularChain?: Array<{ __typename?: 'WA_DependencyChainItem', articleId: string, articleNo?: string | null, description?: string | null } | null> | null, articlesLeadingToCircularDependency?: Array<{ __typename?: 'WA_DependencyChainItem', articleId: string, articleNo?: string | null, description?: string | null } | null> | null } | null } } | null };

export type ValidateWa_ArticleFieldsQueryVariables = Exact<{
  fieldForCheck: Wa_ArticlesFieldForCheck;
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ValidateWa_ArticleFieldsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', validateWA_ArticleFields: { __typename?: 'WA_ArticlesValidatedFields', articleNo: boolean, productionRecipeId: boolean } } | null };

export type GetWa_ArticleDoughDataFromRaQueryVariables = Exact<{
  recipeId: Scalars['ID']['input'];
}>;


export type GetWa_ArticleDoughDataFromRaQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ArticleDoughDataFromRA: { __typename?: 'WA_ArticleDoughDataFromRA', id?: string | null, rMsTotalWeight?: number | null, nonTSLosses?: number | null, roundToInteger?: number | null, linkWeightMU?: number | null, intermediateWeight?: number | null } } | null };

export type GetArticleSpecialPricesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleSpecialPricesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', articleSpecialPrices: Array<{ __typename?: 'WA_ArticleSpecialPricesGridItem', id: string, fromDate?: any | null, toDate?: any | null, isActual: boolean, price1?: number | null, price2?: number | null, price3?: number | null, price5?: number | null, price4?: number | null, price6?: number | null, price7?: number | null, price8?: number | null, price9?: number | null, price10?: number | null, description?: string | null }> } } | null };

export type GetArticlePricesByCustomerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticlePricesByCustomerQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', articlePricesByCustomers: Array<{ __typename?: 'WA_CustomerSpecialPricesGridItem', id: string, specialPrice?: number | null, specialPriceType: C_Special_Price_Type, specialDiscount?: number | null, customerId: string, customerName?: string | null, customerNo?: string | null, fromDate?: any | null, toDate?: any | null, fromQuantity?: number | null, specialIsNoDiscount: boolean, comment?: string | null }> } } | null };

export type GetArticleResellerPriceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetArticleResellerPriceQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getArticleData: { __typename?: 'WA_Article', articleResellerPrices: Array<{ __typename?: 'WA_CustomerResellerPricesGridItem', id: string, price?: number | null, customerId: string, customerNo?: string | null, customerName?: string | null, comment?: string | null }> } } | null };

export type ListArticlesWithSpecialOrRegularPricesQueryVariables = Exact<{
  articleIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  onDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ListArticlesWithSpecialOrRegularPricesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ArticlesWithSpecialOrRegularPrices: Array<{ __typename?: 'WA_ArticleWithSpecialOrRegularPrices', id: string, articleNo?: string | null, description?: string | null, price1?: number | null, price2?: number | null, price3?: number | null, price4?: number | null, price5?: number | null, price6?: number | null, price7?: number | null, price8?: number | null, price9?: number | null, price10?: number | null, openPeriodsWithExistingSpecialPrice?: string | null }> } | null };

export type CreateArticleSpecialPricesMutationVariables = Exact<{
  data: Wa_CreateArticleSpecialPricesInput;
}>;


export type CreateArticleSpecialPricesMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_ArticleSpecialPrices: boolean } | null };

export type CustomersListQueryVariables = Exact<{
  filter?: InputMaybe<Wa_CustomerFilter>;
}>;


export type CustomersListQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_Customers: Array<{ __typename?: 'WA_CustomerGridItem', id: string, internalOrFullName?: string | null, customerNo?: string | null }> } | null };

export type MultiSaveArticleDataMutationVariables = Exact<{
  dataToSave: Wa_MultiSaveArticleInput;
}>;


export type MultiSaveArticleDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', multiSaveArticleData: { __typename?: 'WA_MultiSaveArticleResult', status: C_Save_Operation_Status } } | null };

export type ListCustomersQueryVariables = Exact<{
  filter?: InputMaybe<Wa_CustomerFilter>;
}>;


export type ListCustomersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_Customers: Array<{ __typename?: 'WA_CustomerGridItem', id: string, internalOrFullName?: string | null, customerNo?: string | null }> } | null };

export type GetCustomerDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', informationTip?: string | null, id: string, customerNo?: string | null, isActive: boolean, customerAddressKindId: C_Customer_Address_Kind, customerGroupId?: string | null, deliveryNoteGroupId?: string | null, salutation?: string | null, name?: string | null, surname?: string | null, internalName?: string | null, addition?: string | null, street?: string | null, postBox?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, gln?: string | null, deliveryAddressSalutation?: string | null, deliveryAddressName?: string | null, deliveryAddressAddition?: string | null, deliveryAddressStreet?: string | null, deliveryAddressPostBox?: string | null, deliveryAddressZipCode?: string | null, deliveryAddressCity?: string | null, deliveryAddressCountry?: string | null, deliveryAddressGln?: string | null, contactPerson?: string | null, phoneBusiness?: string | null, phoneBusiness2?: string | null, phonePrivate?: string | null, phoneMobile?: string | null, fax?: string | null, email?: string | null, emailForInvoice?: string | null, website?: string | null } } | null };

export type GetCustomerFormsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerFormsDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, informationTip?: string | null, correspondenceLanguage: C_Correspondence_Language, invoicePaymentSlipReportId: C_Report, invoiceReportId: C_Report, invoiceSummaryReportId: C_Report, orderReportId: C_Report, offerReportId: C_Report, deliveryNoteCopies?: number | null, invoiceCopies?: number | null, eBillAccount?: string | null, defaultNoteInOrder?: string | null, defaultNoteInOrder2?: string | null, defaultNoteInInvoice?: string | null, defaultNoteInInvoice2?: string | null, orderNoteTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }>, invoiceNoteTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type SaveCustomerDataMutationVariables = Exact<{
  data: Wa_SaveCustomerInput;
}>;


export type SaveCustomerDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveCustomerData: { __typename?: 'WA_SaveCustomerResult', status: C_Save_Operation_Status, updatedGridItem?: { __typename?: 'WA_CustomerGridItem', id: string, internalOrFullName?: string | null, customerNo?: string | null } | null } } | null };

export type ReCalcWa_OrdersMutationVariables = Exact<{
  params: Wa_ReCalcOrdersInputs;
}>;


export type ReCalcWa_OrdersMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', reCalcWA_Orders: boolean } | null };

export type CreateWa_CustomerMutationVariables = Exact<{
  data: Wa_CreateCustomerInput;
  customerProfileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateWa_CustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_Customer: { __typename?: 'WA_CustomerGridItem', id: string, internalOrFullName?: string | null, customerNo?: string | null } } | null };

export type CopyWa_CustomerMutationVariables = Exact<{
  originalId: Scalars['ID']['input'];
  data: Wa_CreateCustomerInput;
}>;


export type CopyWa_CustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', copyWA_Customer: { __typename?: 'WA_CustomerGridItem', id: string, internalOrFullName?: string | null, customerNo?: string | null } } | null };

export type GetCustomerListsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerListsDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, informationTip?: string | null, customerListsCheckedState: Array<{ __typename?: 'WA_CustomerListCheckedState', id: string, checked: boolean, label?: string | null }> } } | null };

export type GetCustomerAvailabilityDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerAvailabilityDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, informationTip?: string | null, isDeliveredSun: boolean, isDeliveredMon: boolean, isDeliveredTue: boolean, isDeliveredWed: boolean, isDeliveredThu: boolean, isDeliveredFri: boolean, isDeliveredSat: boolean, customerAssortimentGroupsCheckedState: Array<{ __typename?: 'WA_CustomerAssortimentGroupCheckedState', id: string, checked: boolean, label?: string | null }>, customerDeliveryPeriodsSettings: { __typename?: 'WA_CustomerDeliveryPeriodsSettings', customerRegularDeliveryPeriods: Array<{ __typename?: 'WA_CustomerRegularDeliveryPeriod', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null, isRepeatYearly: boolean }>, customerCustomWeekDaysAndDeliveryPeriods: Array<{ __typename?: 'WA_CustomerCustomWeekDaysAndDeliveryPeriod', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null, isDeliveredMon: boolean, isDeliveredThu: boolean, isDeliveredSun: boolean, isDeliveredSat: boolean, isDeliveredFri: boolean, isDeliveredTue: boolean, isDeliveredWed: boolean, isRepeatYearly: boolean }>, customerVacations: Array<{ __typename?: 'WA_CustomerVacation', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null }> } } } | null };

export type GetCustomerCashAssistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerCashAssistQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', informationTip?: string | null, id: string, caPriceAndDiscountSourceId: C_Discounts_And_Prices_Kind, isCashAssistCreditCustomer: boolean, caSpecialDiscount?: number | null } } | null };

export type GetCustomerTourQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerTourQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, informationTip?: string | null, tourplanNote?: string | null, tourplanId?: string | null, tourPreparationArea?: string | null, tourDepartureTime?: string | null, tourPosition?: number | null, tourplanSatId?: string | null, tourSatPreparationArea?: string | null, tourSatDepartureTime?: string | null, tourSatPosition?: number | null, tourplanSunId?: string | null, tourSunPreparationArea?: string | null, tourSunDepartureTime?: string | null, tourSunPosition?: number | null, isAlwaysInTourplan: boolean, transportSectorId?: string | null } } | null };

export type ValidateWa_CustomerFieldsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  fieldsForCheck: Wa_CustomerFieldsForCheck;
}>;


export type ValidateWa_CustomerFieldsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', validateWA_CustomerFields: { __typename?: 'WA_CustomerValidatedFields', customerNo: boolean, bank1MandatNo: boolean, bank2MandatNo: boolean } } | null };

export type GetCustomerEmailsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerEmailsDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, email?: string | null, emailForInvoice?: string | null, eInvoiceFormat: C_E_Invoice_Format, correspondenceLanguage: C_Correspondence_Language } } | null };

export type GetCustomerDefaultOrderDataQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetCustomerDefaultOrderDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', informationTip?: string | null, id: string, isDeliverySplitting: boolean, defaultOrderOverrideFromCustomerId?: string | null, defaultOrderSourceId: C_Customer_Def_Order_Source, isAllowedAutoOrder: boolean, deliverySplittingPartsCount?: number | null, distributionLowerLimit: number, distributionHigherLimit: number, customerWeeklyDefaultOrder: Array<{ __typename?: 'WA_DefaultOrderPosition', isActive: boolean, articleId: string, description?: string | null, articleNo?: string | null, itemSortPos?: number | null, isMatchAssortmentGroup: boolean, canChangeInOrders: boolean, articleInformation: C_Article_Weekly_Availability_Status, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } }> } } | null };

export type GetCustomerDefaultOrderFromDateQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type GetCustomerDefaultOrderFromDateQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, defaultOrderSourceId: C_Customer_Def_Order_Source, isAllowedAutoOrder: boolean, deliverySplittingPartsCount?: number | null, customerWeeklyDefaultOrder: Array<{ __typename?: 'WA_DefaultOrderPosition', isActive: boolean, articleId: string, description?: string | null, articleNo?: string | null, itemSortPos?: number | null, isMatchAssortmentGroup: boolean, canChangeInOrders: boolean, articleInformation: C_Article_Weekly_Availability_Status, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } }> } } | null };

export type GetDataForExistingDefaultOrderPositionQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type GetDataForExistingDefaultOrderPositionQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_DataForNewDefaultOrderPosition: { __typename?: 'WA_DefaultOrderPosition', isActive: boolean, articleId: string, description?: string | null, articleNo?: string | null, canChangeInOrders: boolean, isMatchAssortmentGroup: boolean, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean } } } | null };

export type GetDataForNewDefaultOrderPositionQueryVariables = Exact<{
  articleId: Scalars['ID']['input'];
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
}>;


export type GetDataForNewDefaultOrderPositionQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_DataForNewDefaultOrderPosition: { __typename?: 'WA_DefaultOrderPosition', isActive: boolean, articleId: string, description?: string | null, articleNo?: string | null, itemSortPos?: number | null, isMatchAssortmentGroup: boolean, canChangeInOrders: boolean, articleInformation: C_Article_Weekly_Availability_Status, mondaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, tuesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, wednesdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, thursdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, fridaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, saturdaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> }, sundaySettings: { __typename?: 'WA_DefaultOrderPositionWeekDaySettings', isArticleAvailable: boolean, date: any, quantity?: number | null, quantityMin?: number | null, quantityMax?: number | null, splittingPartsPreset: Array<string> } } } | null };

export type GetCustomerIndividualPricesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerIndividualPricesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', customerSpecialPrices: Array<{ __typename?: 'WA_CustomerSpecialPricesGridItem', fromDate?: any | null, toDate?: any | null, articleNo?: string | null, articleId: string, description?: string | null, regularPrice?: number | null, specialPrice?: number | null, specialDiscount?: number | null, specialIsNoDiscount: boolean, fromQuantity?: number | null, specialPriceType: C_Special_Price_Type, comment?: string | null, id: string }> } } | null };

export type GetCustomerResellerPricesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerResellerPricesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', customerResellerPrices: Array<{ __typename?: 'WA_CustomerResellerPricesGridItem', id: string, price?: number | null, articleId: string, articleNo?: string | null, description?: string | null, comment?: string | null }> } } | null };

export type GetCustomerBakery2bQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerBakery2bQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', bakery2bAccounts: Array<{ __typename?: 'WA_Bakery2bAccountInformation', id: string, email: string, name: string, note?: string | null, whyDeactivated?: string | null, isDeactivated: boolean, orderAddNewItem: boolean, orderShowPrice: boolean, orderNoDelivery: boolean, standardOrderEdit: boolean }> } } | null };

export type ConnectWa_Bakery2bUserWithWawiCustomerMutationVariables = Exact<{
  data: Wa_ConnectBakery2bUserInput;
}>;


export type ConnectWa_Bakery2bUserWithWawiCustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', connectWA_Bakery2bUserWithWawiCustomer: { __typename?: 'WA_Bakery2bAccountInformation', id: string, email: string, name: string, note?: string | null, whyDeactivated?: string | null, isDeactivated: boolean, orderAddNewItem: boolean, orderShowPrice: boolean, orderNoDelivery: boolean, standardOrderEdit: boolean } } | null };

export type DisconnectWa_Bakery2bAccountFromCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  bakery2BClientId: Scalars['ID']['input'];
}>;


export type DisconnectWa_Bakery2bAccountFromCustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', disconnectWA_Bakery2bAccountFromCustomer: boolean } | null };

export type GetCustomerConditionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerConditionsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', informationTip?: string | null, id: string, customerNo?: string | null, priceCategoryId: string, taxSystemId: C_Tax_System, discountKindId: C_Discount_Kind, quantityDiscountSettingId?: string | null, discountOnGroup1?: number | null, discountOnGroup2?: number | null, discountOnGroup3?: number | null, discountOnGroup4?: number | null, discountOnGroup5?: number | null, discountOnGroup6?: number | null, discountOnGroup7?: number | null, discountOnGroup8?: number | null, discountOnGroup9?: number | null, discountOnGroup10?: number | null, discountOnGroup11?: number | null, discountOnGroup12?: number | null, discountOnGroup13?: number | null, discountOnGroup14?: number | null, discountOnGroup15?: number | null, discountOnGroup16?: number | null, discountOnGroup17?: number | null, discountOnGroup18?: number | null, discountOnGroup19?: number | null, discountOnGroup20?: number | null, invoicingIntervalId: C_Invoice_Interval, debitorStatus: C_Debitor_Status, collectiveInvoicingToCustomerId?: string | null, returnLimit?: number | null, eInvoiceFormat: C_E_Invoice_Format, eInvoiceRoutingAddress?: string | null, paymentPeriod?: number | null, individualPaymentTerms?: string | null, skonto?: number | null, skontoPeriod?: number | null, besrBankId?: string | null, debtorAccount?: number | null, slipReferenceNo?: string | null, incomeAccount?: string | null, costCenter?: string | null, directDebitBankId?: C_Direct_Debit_Banks | null, bank1Name?: string | null, bank1BIN?: string | null, bank1AccountNo?: string | null, bank1IBAN?: string | null, bank1BIC?: string | null, bank1MandatNo?: string | null, bank1MandatSignatureDate?: any | null, bank2Name?: string | null, bank2BIN?: string | null, bank2AccountNo?: string | null, bank2IBAN?: string | null, bank2BIC?: string | null, bank2MandatNo?: string | null, bank2MandatSignatureDate?: any | null, subCompanyId?: string | null, customerSpecialPrices: Array<{ __typename?: 'WA_CustomerSpecialPricesGridItem', fromDate?: any | null, toDate?: any | null, articleNo?: string | null, articleId: string, description?: string | null, regularPrice?: number | null, specialPrice?: number | null, specialDiscount?: number | null, specialIsNoDiscount: boolean, fromQuantity?: number | null, specialPriceType: C_Special_Price_Type, comment?: string | null, id: string }>, customerResellerPrices: Array<{ __typename?: 'WA_CustomerResellerPricesGridItem', id: string, price?: number | null, articleId: string, articleNo?: string | null, description?: string | null, comment?: string | null }> } } | null };

export type GetDeliverySplittingPartsCalculationQueryVariables = Exact<{
  position: Wa_DefaultOrderPositionSplittingPresetInput;
}>;


export type GetDeliverySplittingPartsCalculationQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_DeliverySplittingPartsCalculation: { __typename?: 'WA_DefaultOrderPositionSplitting', mondayParts: Array<string>, tuesdayParts: Array<string>, wednesdayParts: Array<string>, thursdayParts: Array<string>, fridayParts: Array<string>, saturdayParts: Array<string>, sundayParts: Array<string> } } | null };

export type ArticleStdPriceQueryVariables = Exact<{
  stdPriceInput?: InputMaybe<Wa_ArticleStdPriceInput>;
}>;


export type ArticleStdPriceQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ArticleStdPrice: number } | null };

export type GetNewCustomerNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewCustomerNumberQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_NewCustomerNumber: string } | null };

export type MultiSaveCustomerDataMutationVariables = Exact<{
  dataToSave: Wa_MultiSaveCustomerInput;
}>;


export type MultiSaveCustomerDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', multiSaveCustomerData: { __typename?: 'WA_MultiSaveCustomerResult', status: C_Save_Operation_Status } } | null };

export type ListPaymentsInfoFileQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type ListPaymentsInfoFileQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_PaymentsInfoFromFile: { __typename?: 'WA_PaymentFilesProcessingOutput', processedFilesCount: number, okFiles: Array<string>, notOkFiles: Array<string>, paymentsInfo: Array<{ __typename?: 'WA_PaymentInfoFromFile', id?: number | null, transaktionsArt?: string | null, creditDate?: any | null, invoiceNo?: number | null, residualAmount?: number | null, invoiceDate?: any | null, customerId?: number | null, customerInfo?: string | null, amount?: number | null, cashDiscountAmount?: number | null, postedAmount?: number | null, fibuAccountNo?: string | null, isOk: boolean, errorMessage?: string | null, subscriberNo?: string | null, refNo?: string | null, taskReference?: string | null, teskDate?: any | null, processingDate?: any | null, creationDate?: any | null, priceForDeposit?: number | null, mikrofilmNo?: string | null, rejectCode?: string | null, postprocessingESR?: string | null, reserve?: string | null, totalAmount?: number | null, numberOfTransactions?: string | null, internalName?: string | null, flagBookAfter?: number | null }> } } | null };

export type CreateWa_PaymentsForInvoicesFromBesrInfoMutationVariables = Exact<{
  payments: Array<Wa_BesrInfoInputs> | Wa_BesrInfoInputs;
}>;


export type CreateWa_PaymentsForInvoicesFromBesrInfoMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_PaymentsForInvoicesFromBESRInfo: { __typename?: 'WA_BESRInfoProcessingOutput', processedCount: number, addedBESRCount: number, createdPaymentsCount: number, batchId: number } } | null };

export type OpenDebtsGridDataQueryVariables = Exact<{
  invoicesFromDate: Scalars['Date']['input'];
  invoicesToDate: Scalars['Date']['input'];
  paymentsUpToDate: Scalars['Date']['input'];
}>;


export type OpenDebtsGridDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OpenReceivables: Array<{ __typename?: 'WA_OpenReceivablesGridItem', invoiceId: string, invoiceDate: any, invoiceNo: number, customerId: string, customerNo?: string | null, internallOrFullName?: string | null, totalAmount: number, residualAmount: number, paymentDeadline: any, fullPaymentDate?: any | null, delayInDays?: number | null, remindersCount: number }> } | null };

export type ListPaymentsForInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type ListPaymentsForInvoiceQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_PaymentsForInvoice: Array<{ __typename?: 'WA_PaymentsForInvoiceGridItem', id: string, date: any, amount: number, accountNo?: string | null, receiptNo?: string | null, description?: string | null, isViaOverpayment: boolean }> } | null };

export type OverpaymentsAmountAvailableQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type OverpaymentsAmountAvailableQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OverpaymentsAmountAvailable: number } | null };

export type GetOpenReceivablesReminderQueryVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type GetOpenReceivablesReminderQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OpenReceivablesReminders: Array<any> } | null };

export type CreatePaymentForInvoiceMutationVariables = Exact<{
  paymentProps: Wa_PaymentForInvoiceInputs;
}>;


export type CreatePaymentForInvoiceMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_PaymentForInvoice: string } | null };

export type DeletePaymentForInvoiceMutationVariables = Exact<{
  paymentId: Scalars['ID']['input'];
}>;


export type DeletePaymentForInvoiceMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_PaymentForInvoice: boolean } | null };

export type CreatePaymentForInvoiceFromOverpaymentsMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type CreatePaymentForInvoiceFromOverpaymentsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_PaymentForInvoiceFromOverpayments: boolean } | null };

export type SendReminderOfInvoiceEmailMutationVariables = Exact<{
  emailParams: Wa_SendReminderOfInvoiceEmailInput;
  invoiceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendReminderOfInvoiceEmailMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', sendWA_ReminderOfInvoiceEmail: { __typename?: 'SendEmailResult', sentMessages: Array<{ __typename?: 'SentMessages', messageId: string }>, unsentMessages: Array<{ __typename?: 'UnsentMessages', recipient: string }> } } | null };

export type SaveOpenReceivablesRemindersMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
  remindersDetails: Array<InputMaybe<Scalars['DateTime']['input']>> | InputMaybe<Scalars['DateTime']['input']>;
}>;


export type SaveOpenReceivablesRemindersMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_OpenReceivablesReminders: boolean } | null };

export type ListPaymentsQueryVariables = Exact<{
  filter: Wa_PaymentsGridFilter;
}>;


export type ListPaymentsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_Payments: Array<{ __typename?: 'WA_PaymentsGridItem', id: string, date: any, invoiceNo: number, customerNo?: string | null, internalOrFullName?: string | null, amount: number, accountNo?: string | null, receiptNo?: string | null, description?: string | null }> } | null };

export type ExportAbacusWa_PaymentsMutationVariables = Exact<{
  params: Wa_ExportAbacusPaymentsInputs;
}>;


export type ExportAbacusWa_PaymentsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', exportAbacusWA_Payments: { __typename?: 'WA_ExportAbacusPaymentsResult', url: string } } | null };

export type ListWa_GlobalSearchResultsQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
}>;


export type ListWa_GlobalSearchResultsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_GlobalSearchResults: { __typename?: 'WA_GlobalSearchResults', articles: Array<{ __typename?: 'WA_GlobalSearchArticleGridItem', articleNo?: string | null, description?: string | null, id: string, isActive: boolean }>, customers: Array<{ __typename?: 'WA_GlobalSearchCustomerGridItem', customerNo?: string | null, id: string, internalOrFullName?: string | null, isActive: boolean }>, invoices: Array<{ __typename?: 'WA_GlobalSearchInvoiceGridItem', customerNo?: string | null, date: any, id: string, internalOrFullName?: string | null, invoiceNo: number, isDeleted: boolean, total?: number | null }>, orders: Array<{ __typename?: 'WA_GlobalSearchOrderGridItem', customerNo?: string | null, date: any, id: string, internalOrFullName?: string | null, isDeleted: boolean, orderNo: number, total?: number | null }> } } | null };

export type GetCustomerListQueryVariables = Exact<{
  filter: Wa_CustomersForNewInvoicesGridFilter;
}>;


export type GetCustomerListQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_CustomersForCreatingNewInvoices: Array<{ __typename?: 'WA_CustomersForNewInvoicesGridItem', customerId: string, customerNo?: string | null, internalOrFullName?: string | null, isEmailService: boolean }> } | null };

export type GetCustomerDetailsQueryVariables = Exact<{
  getCustomerDataId: Scalars['ID']['input'];
}>;


export type GetCustomerDetailsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', customerNo?: string | null, internalOrFullName?: string | null, informationTip?: string | null, address?: string | null, isEmailServiceForInvoice: boolean, defaultNoteInInvoice?: string | null, emailForInvoice?: string | null, transportSectorId?: string | null, correspondenceLanguage: C_Correspondence_Language, transportSector?: { __typename?: 'WA_TransportSector', name?: string | null, isPriceRateFixed?: boolean | null, priceRateFixed?: number | null } | null, invoiceNoteTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type GetCustomersDetailsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetCustomersDetailsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_CustomersDataForCreatingMultipleInvoices: Array<{ __typename?: 'WA_CustomerDataForCreatingInvoice', customerId: string, defaultNoteInInvoice?: string | null, defaultNoteInInvoice2?: string | null, emailForInvoice?: string | null }> } | null };

export type GetOrdersQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  ordersStartDate: Scalars['Date']['input'];
  ordersEndDate: Scalars['Date']['input'];
}>;


export type GetOrdersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OrdersForNewInvoice: Array<{ __typename?: 'WA_OrdersForInvoicesGridItem', orderId: string, orderDate: any, orderNo: string, orderTotal?: number | null, customerId: string, customerNo?: string | null, internalOrFullName?: string | null }> } | null };

export type GetOrderPositionsQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetOrderPositionsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OrderPositionsForNewInvoice: Array<{ __typename?: 'WA_OrderPositionsForInvoicesGridItem', orderPositionId: string, virtualPositionId?: C_Virtual_Position | null, articleNo?: string | null, quantity?: number | null, articleName?: string | null, price?: number | null, total?: number | null, discount?: number | null, taxName?: string | null, weight?: number | null, indTextDeliveryNote?: string | null }> } | null };

export type CreateInvoiceMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  ordersStartDate: Scalars['Date']['input'];
  ordersEndDate: Scalars['Date']['input'];
  manuallySelectedOrdersIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  note2?: InputMaybe<Scalars['String']['input']>;
  isPaidByCash: Scalars['Boolean']['input'];
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_Invoice: { __typename?: 'WA_CreateInvoiceResult', invoiceId: string, invoiceNo: number } } | null };

export type CheckEInvoiceFieldsQueryVariables = Exact<{
  customersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CheckEInvoiceFieldsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', validateWA_EInvoiceFields: Array<{ __typename?: 'WA_EInvoiceFieldWarning', businessTerm: string, eInvoiceFormat: C_E_Invoice_Format, fieldDetails: string, problemKind: C_E_Invoice_Field_Warning, value?: string | null }> } | null };

export type ListWa_CreatedInvoicesQueryVariables = Exact<{
  filter: Wa_CreatedInvoicesGridFilter;
}>;


export type ListWa_CreatedInvoicesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_CreatedInvoices: Array<{ __typename?: 'WA_CreatedInvoicesGridItem', invoiceId: string, invoiceDate: any, invoiceNo: number, invoiceTotal?: number | null, isDeleted: boolean, customerId: string, customerNo?: string | null, internalOrFullName?: string | null, isEmailService: boolean, isAutoBankDebit: boolean, isExported: boolean, correspondenceLanguage: C_Correspondence_Language }> } | null };

export type ValidateSepaWa_InvoicesQueryVariables = Exact<{
  invoiceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ValidateSepaWa_InvoicesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', validateSepaWA_Invoices: { __typename?: 'WA_InvoicesSepaValidation', hasConfigErrors: boolean, hasInvalidCustomers: boolean, invalidCustomers: Array<{ __typename?: 'WA_InvoiceSepaInvalidCustomers', customerId: string, customerNo?: string | null, internalOrFullName?: string | null }>, configErrors: { __typename?: 'WA_InvoiceSepaConfigErrors', creditorIdNumber: boolean, bankBIC: boolean, bankIBAN: boolean, name: boolean } } } | null };

export type ExportSepaWa_InvoicesMutationVariables = Exact<{
  params: Wa_ExportSepaInvoicesInputs;
}>;


export type ExportSepaWa_InvoicesMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', exportSepaWA_Invoices: { __typename?: 'WA_ExportSepaInvoicesResult', files: Array<{ __typename?: 'WA_SepaExportFile', fileName: string, url: string }> } } | null };

export type PrintWa_InvoiceReportsMutationVariables = Exact<{
  invoicesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PrintWa_InvoiceReportsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', printWA_InvoiceReports: { __typename?: 'PrintJobsCreationResult', countCreated: number, countErrors: number } } | null };

export type GetOrderPositionsForCreatedInvoiceQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
  isInvoiceDeleted: Scalars['Boolean']['input'];
}>;


export type GetOrderPositionsForCreatedInvoiceQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OrderPositionsForCreatedInvoice: Array<{ __typename?: 'WA_OrderPositionsForInvoicesGridItem', orderPositionId: string, virtualPositionId?: C_Virtual_Position | null, articleNo?: string | null, articleName?: string | null, quantity?: number | null, price?: number | null, total?: number | null, discount?: number | null, taxName?: string | null, weight?: number | null, indTextDeliveryNote?: string | null }> } | null };

export type GetOrdersForCreatedInvoiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrdersForCreatedInvoiceQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OrdersForCreatedInvoice: Array<{ __typename?: 'WA_OrdersForInvoicesGridItem', orderId: string, orderDate: any, orderNo: string, orderTotal?: number | null, customerId: string, customerNo?: string | null, internalOrFullName?: string | null }> } | null };

export type GetWa_InvoiceDeletingInfoQueryVariables = Exact<{
  getWaInvoiceDeletingInfoId: Scalars['ID']['input'];
}>;


export type GetWa_InvoiceDeletingInfoQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_InvoiceDeletingInfo: { __typename?: 'WA_InvoiceDeletingInfo', paymentsToDeleteIds: Array<string>, deletionPossibility: C_Invoice_Deletion_Possibility, attachedOrders: Array<{ __typename?: 'WA_InvoiceAttachedOrder', id: string, orderNo: number, date: any, total?: number | null }> } } | null };

export type GetInvoiceDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInvoiceDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getInvoiceData: { __typename?: 'WA_Invoice', id: string, isDeleted: boolean, linkText?: string | null, note?: string | null, datetimeOfLastEmail?: any | null, reasonForDeletion?: string | null } } | null };

export type DeleteWa_InvoiceMutationVariables = Exact<{
  deleteProps: Wa_DeleteInvoiceInputs;
}>;


export type DeleteWa_InvoiceMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_Invoice: boolean } | null };

export type ExportAbacusWa_InvoicesMutationVariables = Exact<{
  params: Wa_ExportAbacusInvoicesInputs;
}>;


export type ExportAbacusWa_InvoicesMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', exportAbacusWA_Invoices: { __typename?: 'WA_ExportAbacusInvoicesResult', url: string } } | null };

export type ExportDatevWa_InvoicesMutationVariables = Exact<{
  params: Wa_ExportDatevInvoicesInputs;
}>;


export type ExportDatevWa_InvoicesMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', exportDatevWA_Invoices: { __typename?: 'WA_ExportDatevInvoicesResult', url: string } } | null };

export type InitInvoiceExportPdfsMutationVariables = Exact<{
  params: Wa_InitInvoiceExportPdfsInputs;
}>;


export type InitInvoiceExportPdfsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', initWA_InvoiceExportPdfs: { __typename?: 'WA_InitInvoiceExportPdfs', jobId: string } } | null };

export type GetInvoiceExportPdfsInZipQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetInvoiceExportPdfsInZipQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_InvoiceExportPdfsInZip: { __typename?: 'WA_InvoiceExportPdfsInZip', status: C_Invoice_Export_Pdfs_Status, url?: string | null } } | null };

export type ListWa_PotentialAndCreatedOffersQueryVariables = Exact<{
  filter: Wa_OffersGridFilter;
}>;


export type ListWa_PotentialAndCreatedOffersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_PotentialAndCreatedOffers: Array<{ __typename?: 'WA_OffersGridItem', customerId: string, offerForDate?: any | null, offerNo?: number | null, customerNr?: string | null, internalOrFullName?: string | null, draftOfferId?: string | null, offerId?: string | null, isAccepted?: boolean | null, isDeclined?: boolean | null, offerTotal?: number | null, correspondenceLanguage?: C_Correspondence_Language | null }> } | null };

export type GetCustomerInfoForOfferQueryVariables = Exact<{
  getCustomerDataId: Scalars['ID']['input'];
}>;


export type GetCustomerInfoForOfferQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, customerNo?: string | null, internalOrFullName?: string | null, phoneBusiness?: string | null, phoneBusiness2?: string | null, phoneMobile?: string | null, phonePrivate?: string | null, fax?: string | null, email?: string | null, deliveryAddress?: string | null, informationTip?: string | null, discountKindId: C_Discount_Kind, isDeliverySplitting: boolean, deliverySplittingPartsCount?: number | null, correspondenceLanguage: C_Correspondence_Language, transportSectorId?: string | null, transportSector?: { __typename?: 'WA_TransportSector', isPriceRateFixed?: boolean | null, priceRateFixed?: number | null } | null } } | null };

export type GetOfferDataQueryVariables = Exact<{
  selectionProps: Wa_OfferDataInputs;
}>;


export type GetOfferDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OfferData: Array<{ __typename?: 'WA_OfferData', linkText?: string | null, note?: string | null, offerForDate?: any | null, validUntilDate?: any | null, datetimeOfLastEmail?: any | null, positions?: Array<{ __typename?: 'WA_OfferPositionsGridItem', virtualPositionId?: C_Virtual_Position | null, articleId?: string | null, articleNo?: string | null, description?: string | null, quantity?: number | null, price?: number | null, total?: number | null, discount?: number | null, vatCode?: C_Vat_Code | null, indTextDeliveryNote?: string | null, indTextProduction?: string | null, quantityPerLot?: number | null, saleUnit?: C_Sale_Unit | null } | null> | null, offerSourceInfo: { __typename?: 'WA_OfferSourceInfo', offerNo?: number | null, offerForDate?: any | null, offerTotal?: number | null } }> } | null };

export type CreateWa_DraftOfferMutationVariables = Exact<{
  draftOfferProps: Wa_DraftOfferInputs;
}>;


export type CreateWa_DraftOfferMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_DraftOffer: string } | null };

export type CreateWa_OfferMutationVariables = Exact<{
  offerProps: Wa_CreateOfferInputs;
}>;


export type CreateWa_OfferMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_Offer: { __typename?: 'WA_CreateOfferResult', offerId?: string | null, offerNo?: number | null } } | null };

export type PrintWa_OfferReportsMutationVariables = Exact<{
  offersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PrintWa_OfferReportsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', printWA_OfferReports: { __typename?: 'PrintJobsCreationResult', countCreated: number, countErrors: number } } | null };

export type SaveWa_OfferMutationVariables = Exact<{
  offerProps: Wa_SaveOfferInputs;
}>;


export type SaveWa_OfferMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_Offer: { __typename?: 'WA_OffersGridItem', customerId: string, offerForDate?: any | null, offerNo?: number | null, customerNr?: string | null, internalOrFullName?: string | null, draftOfferId?: string | null, offerId?: string | null, isAccepted?: boolean | null, isDeclined?: boolean | null, offerTotal?: number | null } } | null };

export type AcceptWa_OfferMutationVariables = Exact<{
  acceptWaOfferId: Scalars['ID']['input'];
}>;


export type AcceptWa_OfferMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', acceptWA_Offer: { __typename?: 'WA_OffersGridItem', customerId: string, offerForDate?: any | null, offerNo?: number | null, customerNr?: string | null, internalOrFullName?: string | null, draftOfferId?: string | null, offerId?: string | null, isAccepted?: boolean | null, isDeclined?: boolean | null, offerTotal?: number | null } } | null };

export type DeclineWa_OfferMutationVariables = Exact<{
  declineWaOfferId: Scalars['ID']['input'];
}>;


export type DeclineWa_OfferMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', declineWA_Offer: { __typename?: 'WA_OffersGridItem', customerId: string, offerForDate?: any | null, offerNo?: number | null, customerNr?: string | null, internalOrFullName?: string | null, draftOfferId?: string | null, offerId?: string | null, isAccepted?: boolean | null, isDeclined?: boolean | null, offerTotal?: number | null } } | null };

export type DeleteDraftOfferMutationVariables = Exact<{
  deleteWaDraftOfferId: Scalars['ID']['input'];
}>;


export type DeleteDraftOfferMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_DraftOffer: boolean } | null };

export type ListWa_CustomersForCreatingOrdersQueryVariables = Exact<{
  filter: Wa_CustomersForCreatingOrdersGridFilter;
}>;


export type ListWa_CustomersForCreatingOrdersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_CustomersForCreatingOrders: Array<{ __typename?: 'WA_CustomersForCreatingOrdersGridItem', customerId: string, customerNo?: string | null, internalOrFullName?: string | null, draftOrderId?: string | null, offerId?: string | null, offerNo?: number | null, isAllowedAutoOrder: boolean, isDeliveredOnDate: boolean, isNoOrderOnDate: boolean, hasOrderOnDate: boolean }> } | null };

export type GetCustomerInfoQueryVariables = Exact<{
  getCustomerDataId: Scalars['ID']['input'];
}>;


export type GetCustomerInfoQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, customerNo?: string | null, internalOrFullName?: string | null, phoneBusiness?: string | null, phoneBusiness2?: string | null, phoneMobile?: string | null, phonePrivate?: string | null, fax?: string | null, email?: string | null, deliveryAddress?: string | null, informationTip?: string | null, discountKindId: C_Discount_Kind, isDeliverySplitting: boolean, deliverySplittingPartsCount?: number | null, transportSectorId?: string | null, transportSector?: { __typename?: 'WA_TransportSector', name?: string | null, isPriceRateFixed?: boolean | null, priceRateFixed?: number | null } | null } } | null };

export type GetWa_OrderDataForNewOrderQueryVariables = Exact<{
  selectionProps: Wa_OrderDataForNewOrderInputs;
}>;


export type GetWa_OrderDataForNewOrderQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OrderDataForNewOrder: Array<{ __typename?: 'WA_OrderDataForNewOrder', deliveryTime?: string | null, tourplanId?: string | null, note?: string | null, note2?: string | null, linkText?: string | null, referenceOrderNo?: string | null, specialAddress?: string | null, orderSourceInfo: { __typename?: 'WA_OrderSourceInfo', orderNo?: number | null, orderDate?: any | null, orderTotal?: number | null }, positions: Array<{ __typename?: 'WA_OrderPositionsGridItem', virtualPositionId?: C_Virtual_Position | null, articleId?: string | null, articleNo?: string | null, description?: string | null, quantity?: number | null, price?: number | null, total?: number | null, discount?: number | null, vatCode: C_Vat_Code, indTextDeliveryNote?: string | null, indTextProduction?: string | null, splittingPartsPreset?: Array<string | null> | null, quantityPerLot?: number | null, minQuantity?: number | null, maxQuantity?: number | null, saleUnit?: C_Sale_Unit | null, weight?: number | null, isChangeable: boolean }> }> } | null };

export type ListWa_ExistingOrdersOfCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type ListWa_ExistingOrdersOfCustomerQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ExistingOrdersOfCustomer: Array<{ __typename?: 'WA_ExistingOrdersOfCustomer', orderNo: number, userName?: string | null, createDateTime?: any | null }> } | null };

export type GetProfileForOneTimeCustomerQueryVariables = Exact<{
  getDictWaCustomerProfileId: Scalars['ID']['input'];
}>;


export type GetProfileForOneTimeCustomerQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_CustomerProfile: { __typename?: 'WA_CustomerProfile', invoicingIntervalId: C_Invoice_Interval, paymentPeriod?: number | null, orderReportId: C_Report } } | null };

export type GetCustomerFieldsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerFieldsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, name?: string | null, address?: string | null, salutation?: string | null, addition?: string | null, street?: string | null, postBox?: string | null, city?: string | null, zipCode?: string | null, country?: string | null, gln?: string | null, email?: string | null, emailForInvoice?: string | null, phoneBusiness?: string | null, contactPerson?: string | null, orderReportId: C_Report, paymentPeriod?: number | null, invoicingIntervalId: C_Invoice_Interval, correspondenceLanguage: C_Correspondence_Language, customerAddressKindId: C_Customer_Address_Kind, customerGroupId?: string | null, surname?: string | null, deliveryAddressSalutation?: string | null, deliveryAddressName?: string | null, deliveryAddressAddition?: string | null, deliveryAddressStreet?: string | null, deliveryAddressPostBox?: string | null, deliveryAddressZipCode?: string | null, deliveryAddressCity?: string | null, deliveryAddressCountry?: string | null, deliveryAddressGln?: string | null } } | null };

export type DictWa_OneTimeCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_OneTimeCustomersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_OneTimeCustomers: Array<{ __typename?: 'WA_OneTimeCustomerDictItem', id: string, customerNo?: string | null, label?: string | null }> } | null };

export type CreateWa_DraftOrderMutationVariables = Exact<{
  draftOrderProps: Wa_DraftOrderInputs;
}>;


export type CreateWa_DraftOrderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_DraftOrder: string } | null };

export type DeleteWa_DraftOrderMutationVariables = Exact<{
  deleteWaDraftOrderId: Scalars['ID']['input'];
}>;


export type DeleteWa_DraftOrderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_DraftOrder: boolean } | null };

export type CreateWa_OrderMutationVariables = Exact<{
  orderProps: Wa_CreateOrderInputs;
}>;


export type CreateWa_OrderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_Order: { __typename?: 'WA_CreateOrderResult', orderId: string, orderNo: number } } | null };

export type CreateWa_AutomaticOrdersMutationVariables = Exact<{
  customersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type CreateWa_AutomaticOrdersMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_AutomaticOrders: { __typename?: 'WA_CreateAutoOrdersResult', ordersCount: number, affectedCustomersIds: Array<string> } } | null };

export type CreateWa_NoOrderForCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type CreateWa_NoOrderForCustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_NoOrderForCustomer: boolean } | null };

export type DeleteWa_NoOrderForCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type DeleteWa_NoOrderForCustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_NoOrderForCustomer: boolean } | null };

export type CreateWa_OneTimeCustomerMutationVariables = Exact<{
  data: Wa_CreateOneTimeCustomerInput;
  customerProfileId: Scalars['ID']['input'];
}>;


export type CreateWa_OneTimeCustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_OneTimeCustomer: { __typename?: 'WA_CustomersForCreatingOrdersGridItem', customerId: string, customerNo?: string | null, internalOrFullName?: string | null, draftOrderId?: string | null, offerId?: string | null, offerNo?: number | null, isAllowedAutoOrder: boolean, isDeliveredOnDate: boolean, isNoOrderOnDate: boolean, hasOrderOnDate: boolean } } | null };

export type SaveOneTimeCustomerDataMutationVariables = Exact<{
  dataToSave: Wa_SaveOneTimeCustomerInput;
}>;


export type SaveOneTimeCustomerDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveOneTimeCustomerData: { __typename?: 'WA_CustomersForCreatingOrdersGridItem', customerId: string, customerNo?: string | null, internalOrFullName?: string | null, draftOrderId?: string | null, offerId?: string | null, offerNo?: number | null, isAllowedAutoOrder: boolean, isDeliveredOnDate: boolean, isNoOrderOnDate: boolean, hasOrderOnDate: boolean } } | null };

export type ListWa_CreatedOrdersQueryVariables = Exact<{
  filter: Wa_CreatedOrdersGridFilter;
}>;


export type ListWa_CreatedOrdersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_CreatedOrders: Array<{ __typename?: 'WA_CreatedOrdersGridItem', orderId: string, orderDate: any, orderNo: number, orderTotal?: number | null, orderType: C_Order_Type, caOrderType?: string | null, customerId: string, customerNo?: string | null, internalOrFullName?: string | null, isDeleted: boolean, isInvoiced: boolean, emailAddress?: string | null, correspondenceLanguage?: C_Correspondence_Language | null }> } | null };

export type DeleteWa_OrderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWa_OrderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_Order: boolean } | null };

export type GetWa_OrderDataOfCreatedOrderQueryVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type GetWa_OrderDataOfCreatedOrderQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OrderDataOfCreatedOrder: { __typename?: 'WA_OrderDataOfCreatedOrder', orderNo: number, orderDate: any, orderType: C_Order_Type, customerId: string, specialAddress?: string | null, referenceOrderNo?: string | null, deliveryTime?: string | null, tourplanId?: string | null, linkText?: string | null, note?: string | null, note2?: string | null, notePlainText?: string | null, isEditable: boolean, datetimeOfLastEmail?: any | null, caInfo: { __typename?: 'WA_OrderCashAssistInfo', cashRegisterNo?: number | null, receiptNo?: number | null, deliveryTime?: string | null, deliveryMethod?: string | null, userName?: string | null }, positions: Array<{ __typename?: 'WA_OrderPositionsGridItem', positionId?: string | null, virtualPositionId?: C_Virtual_Position | null, articleId?: string | null, articleNo?: string | null, description?: string | null, quantity?: number | null, correctionValue?: number | null, price?: number | null, total?: number | null, discount?: number | null, vatCode: C_Vat_Code, indTextDeliveryNote?: string | null, indTextProduction?: string | null, splittingPartsPreset?: Array<string | null> | null, quantityPerLot?: number | null, minQuantity?: number | null, maxQuantity?: number | null, saleUnit?: C_Sale_Unit | null, weight?: number | null, isChangeable: boolean }> } } | null };

export type GetCustomerInformationQueryVariables = Exact<{
  getCustomerDataId: Scalars['ID']['input'];
}>;


export type GetCustomerInformationQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getCustomerData: { __typename?: 'WA_Customer', id: string, customerNo?: string | null, internalOrFullName?: string | null, phoneBusiness?: string | null, phoneBusiness2?: string | null, phoneMobile?: string | null, phonePrivate?: string | null, fax?: string | null, email?: string | null, deliveryAddress?: string | null, informationTip?: string | null, discountKindId: C_Discount_Kind, isDeliverySplitting: boolean, deliverySplittingPartsCount?: number | null, transportSectorId?: string | null, transportSector?: { __typename?: 'WA_TransportSector', name?: string | null, isPriceRateFixed?: boolean | null, priceRateFixed?: number | null } | null } } | null };

export type SaveOrderMutationVariables = Exact<{
  orderProps: Wa_SaveOrderInputs;
}>;


export type SaveOrderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_Order: { __typename?: 'WA_CreatedOrdersGridItem', orderNo: number, customerNo?: string | null, orderId: string, orderDate: any, orderTotal?: number | null, internalOrFullName?: string | null } } | null };

export type CreateWa_OrdersFromXmlFileMutationVariables = Exact<{
  key: Scalars['String']['input'];
  ifOrderExistsCreateAnyway: Scalars['Boolean']['input'];
}>;


export type CreateWa_OrdersFromXmlFileMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_OrdersFromXMLFile: { __typename?: 'WA_OrdersImportResult', ordersCreated: number, ordersSkipped: number } } | null };

export type PrintWa_OrderReportsMutationVariables = Exact<{
  ordersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type PrintWa_OrderReportsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', printWA_OrderReports: { __typename?: 'PrintJobsCreationResult', countCreated: number, countErrors: number, successfullyPrintedOrderIds?: Array<string> | null } } | null };

export type ListSpecialAssortmentGroupsOfCustomerQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type ListSpecialAssortmentGroupsOfCustomerQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_SpecialAssortmentGroupsOfCustomerForSelectInOrderPosition: Array<string> } | null };

export type ListWa_SpecialAvailabilityStateForArticlesSelectedInOrderPositionQueryVariables = Exact<{
  onDate: Scalars['Date']['input'];
}>;


export type ListWa_SpecialAvailabilityStateForArticlesSelectedInOrderPositionQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_SpecialAvailabilityStateForArticlesSelectedInOrderPosition: Array<{ __typename?: 'WA_SpecialAvailabilityStateForArticlesSelectedInOrderPosition', articleId: string, isDelivered: boolean }> } | null };

export type GetWa_ArticleDataAsOrderPositionQueryVariables = Exact<{
  orderAndArticleProps: Wa_OrderAndArticleInputs;
}>;


export type GetWa_ArticleDataAsOrderPositionQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ArticleDataAsOrderPosition: { __typename?: 'WA_ArticleDataAsOrderPosition', price?: number | null, discount?: number | null, minQuantity?: number | null, maxQuantity?: number | null, splittingPartsPreset?: Array<string | null> | null } } | null };

export type ListWa_ActualTaxsQueryVariables = Exact<{
  date: Scalars['Date']['input'];
}>;


export type ListWa_ActualTaxsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ActualTaxs: Array<{ __typename?: 'WA_ActualTaxs', id: C_Vat_Code, label?: string | null }> } | null };

export type GetWa_ArticleOrderPriceAndDiscountQueryVariables = Exact<{
  orderAndArticleProps: Wa_OrderAndArticleInputs;
}>;


export type GetWa_ArticleOrderPriceAndDiscountQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ArticleOrderPriceAndDiscount: { __typename?: 'WA_ArticleOrderPriceAndDiscount', price?: number | null, discount?: number | null } } | null };

export type GetWa_OrderDeliveryCostQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  totalWeight: Scalars['Float']['input'];
}>;


export type GetWa_OrderDeliveryCostQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OrderDeliveryCost: number } | null };

export type ListWa_OrderArticlesComparisonMetricsQueryVariables = Exact<{
  customerId: Scalars['ID']['input'];
  comparisonDate: Scalars['Date']['input'];
  articleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListWa_OrderArticlesComparisonMetricsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OrderArticlesComparisonMetrics: Array<{ __typename?: 'WA_OrderArticlesComparisonMetrics', articleId: string, ordered?: number | null, sold?: number | null, returned?: number | null }> } | null };

export type ListWa_OverviewOrdersQueryVariables = Exact<{
  filter: Wa_OverviewInput;
}>;


export type ListWa_OverviewOrdersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OverviewOrders: Array<{ __typename?: 'WA_OverviewOrdersGridItem', customerGroupName?: string | null, internalOrFullName?: string | null, customerNr?: string | null, deliveryNoteGroupName?: string | null, historyUserFullName?: string | null, orderDate?: any | null, orderId: string, orderNetTotal?: number | null, orderTotal?: number | null, orderType?: C_Order_Type | null, caOrderType?: string | null, orderNo?: string | null }> } | null };

export type ListWa_OverviewArticlesQueryVariables = Exact<{
  filter: Wa_OverviewInput;
}>;


export type ListWa_OverviewArticlesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_OverviewArticles: Array<{ __typename?: 'WA_OverviewArticlesGridItem', positionId: string, orderId: string, articleId?: string | null, articleNo?: string | null, customerNo?: string | null, quantity?: number | null, quantityProd?: number | null, articleName?: string | null, internalOrFullName?: string | null, orderDate?: any | null, indTextDeliveryNote?: string | null, indTextProduction?: string | null, orderNo?: string | null, positionPrice?: number | null, positionDiscount?: number | null }> } | null };

export type SavePositionsInMultipleOrdersMutationVariables = Exact<{
  params: Array<Wa_SavePositionsInMultiOrdersInputs> | Wa_SavePositionsInMultiOrdersInputs;
}>;


export type SavePositionsInMultipleOrdersMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_PositionsInMultipleOrders: Array<{ __typename?: 'SaveWA_PositionsInMultipleOrdersResult', id: string, success: boolean, errorMsg?: string | null, errorCode?: C_Order_Error_Code | null }> } | null };

export type ListWa_ProductionPrintListsQueryVariables = Exact<{
  filter: Wa_ProductionPrintListsGridFilter;
}>;


export type ListWa_ProductionPrintListsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProductionPrintLists: Array<{ __typename?: 'WA_ProductionPrintListsGridItem', id: string, name?: string | null }> } | null };

export type DeleteWa_ProductionPrintListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWa_ProductionPrintListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_ProductionPrintList: boolean } | null };

export type SaveProductionEditPrintListDataMutationVariables = Exact<{
  dataToSave: Wa_SaveProductionPrintListInput;
}>;


export type SaveProductionEditPrintListDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveProductionPrintListData: { __typename?: 'WA_SaveProductionPrintListsResult', status: C_Save_Operation_Status, updatedGridItem?: { __typename?: 'WA_ProductionPrintListsGridItem', id: string, name?: string | null } | null } } | null };

export type GetProductionPrintListDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductionPrintListDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getProductionPrintListData: { __typename?: 'WA_ProductionPrintList', id: string, name?: string | null, groupId?: string | null, isActive: boolean, isAvailableMon: boolean, isAvailableTue: boolean, isAvailableWed: boolean, isAvailableThu: boolean, isAvailableFri: boolean, isAvailableSat: boolean, isAvailableSun: boolean, reportId?: C_Report | null, reportGroupId?: C_Report_Group | null, addDaysForPreProduction?: number | null, articlesSortingKindId: C_Production_Article_Sorting_Kind, customersSortingKindId?: C_Production_Customer_Sorting_Kind | null, isShowSemiProductsDetails: boolean, isCrosstableEasyMode: boolean, crosstableEasyModeSplitNoFilter?: string | null, isNeedSignatureOnForwardingList: boolean, tourplanId?: string | null, tourplanDay?: string | null, isPrintDeliveryNotesForTourplan: boolean, isShowProductionDescription: boolean, isShowIndividualTexts: boolean, isOnlyPositionsWithIndividualText: boolean, isHighlightArticlesFromProductionCalc: boolean, isSplitDoughBeforePrint: boolean, isShowDeliverySplitting: boolean, crosstableConfigurationData: Array<{ __typename?: 'WA_ProductionPrintListCrosstableData', categoryId: string, categoryName: string, categoryCustomerId?: string | null, categoryCustomerListId?: string | null, categoryFilterDeliveryType?: C_Order_Type | null, categoryFilterSplitNo?: string | null, categoryFilterCustomer?: string | null, categoryCustomFilterDelivery?: string | null }>, tourplanConfigurationData: Array<{ __typename?: 'WA_ProductionPrintListTourplanData', categoryId: string, categoryName: string, categoryFilter: Array<{ __typename?: 'WA_ProductionPrintListFilterCheckedState', id: string, checked: boolean, label?: string | null } | null> }>, orderTypesFilter: Array<{ __typename?: 'WA_ProductionPrintListOrderFilterCheckedState', id: C_Order_Type, checked: boolean }>, customerListsFilter: Array<{ __typename?: 'WA_ProductionPrintListFilterCheckedState', id: string, checked: boolean, label?: string | null }>, articleListsFilter: Array<{ __typename?: 'WA_ProductionPrintListFilterCheckedState', id: string, checked: boolean, label?: string | null }> } } | null };

export type GetCrosstableConfigurationDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCrosstableConfigurationDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getProductionPrintListData: { __typename?: 'WA_ProductionPrintList', crosstableConfigurationData: Array<{ __typename?: 'WA_ProductionPrintListCrosstableData', categoryId: string, categoryName: string, categoryCustomerId?: string | null, categoryCustomerListId?: string | null, categoryFilterDeliveryType?: C_Order_Type | null, categoryFilterSplitNo?: string | null, categoryFilterCustomer?: string | null, categoryCustomFilterDelivery?: string | null }> } } | null };

export type CreateWa_ProductionPrintListMutationVariables = Exact<{
  data: Wa_CreateProductionPrintListInput;
}>;


export type CreateWa_ProductionPrintListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_ProductionPrintList: { __typename?: 'WA_ProductionPrintListsGridItem', id: string, name?: string | null } } | null };

export type CopyWa_ProductionPrintListMutationVariables = Exact<{
  originalId: Scalars['ID']['input'];
  data: Wa_CreateProductionPrintListInput;
}>;


export type CopyWa_ProductionPrintListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', copyWA_ProductionPrintList: { __typename?: 'WA_ProductionPrintListsGridItem', id: string, name?: string | null } } | null };

export type ListWa_ProductionPrintJobsQueryVariables = Exact<{
  filter: Wa_ProductionPrintJobsGridFilter;
}>;


export type ListWa_ProductionPrintJobsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProductionPrintJobs: Array<{ __typename?: 'WA_ProductionPrintJobsGridItem', id: string, name?: string | null, isActive: boolean, addDaysForPreProduction?: number | null, reportId?: C_Report | null, reportGroupId?: C_Report_Group | null }> } | null };

export type GetPrintJobsOrdersCountQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;


export type GetPrintJobsOrdersCountQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_OrdersCountForPrintJobs: number } | null };

export type GetPrintJobsPreProductionOrdersCountQueryVariables = Exact<{
  onDate: Scalars['Date']['input'];
}>;


export type GetPrintJobsPreProductionOrdersCountQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_PreProductionOrdersCountForPrintJobs: number } | null };

export type ListWa_ProductionDeliveryNotesQueryVariables = Exact<{
  fromDate: Scalars['Date']['input'];
  toDate: Scalars['Date']['input'];
}>;


export type ListWa_ProductionDeliveryNotesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProductionDeliveryNotes: Array<{ __typename?: 'WA_ProductionDeliveryNotesGridItem', id: string, customerNo?: string | null, internalOrFullName?: string | null, customerDeliveryNoteGroup?: string | null, orderNo: number, orderDate: any, orderType: C_Order_Type, caOrderType?: string | null, isPrinted: boolean, printedDateTime?: any | null }> } | null };

export type GetIncomingOrdersAcceptanceStatusQueryVariables = Exact<{
  externalSourceKind: C_Incoming_Orders_Source;
  onDate: Scalars['Date']['input'];
}>;


export type GetIncomingOrdersAcceptanceStatusQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_IncomingOrdersAcceptanceStatus: boolean } | null };

export type ChangeIncomingOrdersStatusMutationVariables = Exact<{
  externalSourceKind: C_Incoming_Orders_Source;
  onDate: Scalars['Date']['input'];
  isAccepted: Scalars['Boolean']['input'];
}>;


export type ChangeIncomingOrdersStatusMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveIncomingOrdersAcceptanceStatus: boolean } | null };

export type PrintWa_ProductionReportsMutationVariables = Exact<{
  reports: Array<PrintProductionReportParamsInput> | PrintProductionReportParamsInput;
}>;


export type PrintWa_ProductionReportsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', printWA_ProductionReports: { __typename?: 'PrintJobsCreationResult', countCreated: number, countErrors: number } } | null };

export type GetProductionReportsVersionsQueryVariables = Exact<{
  onDate: Scalars['Date']['input'];
}>;


export type GetProductionReportsVersionsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProductionReportsVersions: Array<{ __typename?: 'WA_ProductionReportsVersionsGridItem', id: string, versionNo: number, createdDateTime: any }> } | null };

export type GetProducedArticlesQuantityQueryVariables = Exact<{
  onDate: Scalars['Date']['input'];
  productionPrintListId: Scalars['ID']['input'];
}>;


export type GetProducedArticlesQuantityQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProducedArticlesQuantity: Array<{ __typename?: 'WA_ProducedArticlesQuantityGridItem', articleNo?: string | null, description?: string | null, producedQuantity?: number | null, recordId: string }> } | null };

export type DoughSplittingInfoGridItemFragment = { __typename?: 'WA_DoughSplittingInfoGridItem', id: string, roundTo?: number | null, doughNo?: string | null, doughName?: string | null, productionGroupId?: string | null, kilogramDoughRequired?: number | null, literDoughRequired?: number | null, isDoughSplitting: boolean, resPart1Amount?: number | null, resPart1LtAmount?: number | null, resPart2Amount?: number | null, resPart2LtAmount?: number | null, resPart3Amount?: number | null, resPart3LtAmount?: number | null, resPart4Amount?: number | null, resPart4LtAmount?: number | null, resPart5Amount?: number | null, resPart5LtAmount?: number | null, diff?: number | null, diffLt?: number | null, isSplitted: boolean, part1Def?: number | null, part2Def?: number | null, faktorLtKg?: number | null };

export type GetDoughsSplittingInformationQueryVariables = Exact<{
  onDate: Scalars['Date']['input'];
}>;


export type GetDoughsSplittingInformationQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_DoughsSplittingInfoOnDate: Array<{ __typename?: 'WA_DoughSplittingInfoGridItem', id: string, roundTo?: number | null, doughNo?: string | null, doughName?: string | null, productionGroupId?: string | null, kilogramDoughRequired?: number | null, literDoughRequired?: number | null, isDoughSplitting: boolean, resPart1Amount?: number | null, resPart1LtAmount?: number | null, resPart2Amount?: number | null, resPart2LtAmount?: number | null, resPart3Amount?: number | null, resPart3LtAmount?: number | null, resPart4Amount?: number | null, resPart4LtAmount?: number | null, resPart5Amount?: number | null, resPart5LtAmount?: number | null, diff?: number | null, diffLt?: number | null, isSplitted: boolean, part1Def?: number | null, part2Def?: number | null, faktorLtKg?: number | null }> } | null };

export type SaveDoughSplittingInformationMutationVariables = Exact<{
  dataToSave: Wa_SaveDoughSplittingInfoOnDateInput;
}>;


export type SaveDoughSplittingInformationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_DoughSplittingInfoOnDate: { __typename?: 'WA_SaveDoughSplittingInfoOnDateResult', status: C_Save_Operation_Status, updatedGridItem?: { __typename?: 'WA_DoughSplittingInfoGridItem', id: string, roundTo?: number | null, doughNo?: string | null, doughName?: string | null, productionGroupId?: string | null, kilogramDoughRequired?: number | null, literDoughRequired?: number | null, isDoughSplitting: boolean, resPart1Amount?: number | null, resPart1LtAmount?: number | null, resPart2Amount?: number | null, resPart2LtAmount?: number | null, resPart3Amount?: number | null, resPart3LtAmount?: number | null, resPart4Amount?: number | null, resPart4LtAmount?: number | null, resPart5Amount?: number | null, resPart5LtAmount?: number | null, diff?: number | null, diffLt?: number | null, isSplitted: boolean, part1Def?: number | null, part2Def?: number | null, faktorLtKg?: number | null } | null } } | null };

export type DeleteDoughSplittingInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type DeleteDoughSplittingInformationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_DoughSplittingInfoOnDate: { __typename?: 'WA_DeleteDoughSplittingInfoOnDateResult', status: C_Save_Operation_Status, updatedGridItem?: { __typename?: 'WA_DoughSplittingInfoGridItem', id: string, roundTo?: number | null, doughNo?: string | null, doughName?: string | null, productionGroupId?: string | null, kilogramDoughRequired?: number | null, literDoughRequired?: number | null, isDoughSplitting: boolean, resPart1Amount?: number | null, resPart1LtAmount?: number | null, resPart2Amount?: number | null, resPart2LtAmount?: number | null, resPart3Amount?: number | null, resPart3LtAmount?: number | null, resPart4Amount?: number | null, resPart4LtAmount?: number | null, resPart5Amount?: number | null, resPart5LtAmount?: number | null, diff?: number | null, diffLt?: number | null, isSplitted: boolean, part1Def?: number | null, part2Def?: number | null, faktorLtKg?: number | null } | null } } | null };

export type SaveProducedArticlesQuantityMutationVariables = Exact<{
  records: Array<Wa_ProducedArticlesQuantityInput> | Wa_ProducedArticlesQuantityInput;
}>;


export type SaveProducedArticlesQuantityMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_ProducedArticlesQuantity: boolean } | null };

export type CreateProductionReportsVersionMutationVariables = Exact<{
  onDate: Scalars['Date']['input'];
}>;


export type CreateProductionReportsVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_ProductionReportsVersion: { __typename?: 'WA_ProductionReportsVersionsGridItem', id: string, versionNo: number, createdDateTime: any } } | null };

export type DeleteProductionReportsVersionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProductionReportsVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_ProductionReportsVersion: boolean } | null };

export type Create_R1_BakingList2ColumnsReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R1_BakingList2ColumnsReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r1_BakingList2ColumnsReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R14_BakingListWithRecipe2ColumnsReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R14_BakingListWithRecipe2ColumnsReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r14_BakingListWithRecipe2ColumnsReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R26_BakingListWithRecipeA4ReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R26_BakingListWithRecipeA4ReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r26_BakingListWithRecipeA4ReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R27_BakingListWithRecipeA4ReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R27_BakingListWithRecipeA4ReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r27_BakingListWithRecipeA4ReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R34_BakingListA4ReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R34_BakingListA4ReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r34_BakingListA4ReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R41_BakingListA4DetailedReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R41_BakingListA4DetailedReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r41_BakingListA4DetailedReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R57_BakingListRawmaterials2ColumnsReportFromVersionMutationVariables = Exact<{
  params: Wa_ProductionReportFromVersionInput;
}>;


export type Create_R57_BakingListRawmaterials2ColumnsReportFromVersionMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r57_BakingListRawmaterials2ColumnsReportFromVersion?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R58_BakingListVersionsDifferenceWithRecipeMutationVariables = Exact<{
  params: Wa_ProductionReportDiffVersionsInput;
}>;


export type Create_R58_BakingListVersionsDifferenceWithRecipeMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r58_BakingListVersionsDifferenceWithRecipe?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R68_ForwardingListArticleCustomersVersionsDifferenceMutationVariables = Exact<{
  params: Wa_ProductionReportDiffVersionsInput;
}>;


export type Create_R68_ForwardingListArticleCustomersVersionsDifferenceMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r68_ForwardingListArticleCustomersVersionsDifference?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R56_BakingListVersionsDifferenceMutationVariables = Exact<{
  params: Wa_ProductionReportDiffVersionsInput;
}>;


export type Create_R56_BakingListVersionsDifferenceMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r56_BakingListVersionsDifference?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R56_BakingListVersionsDifferenceFromLiveDataMutationVariables = Exact<{
  params: Wa_ProductionReportDiffOrderedAndProducedInput;
}>;


export type Create_R56_BakingListVersionsDifferenceFromLiveDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r56_BakingListVersionsDifferenceFromLiveData?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type GetExportLabelAssistMutationVariables = Exact<{
  productionPrintListId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type GetExportLabelAssistMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', prepareLabelAssistExport: boolean } | null };

export type GetExportSmartScaleMutationVariables = Exact<{
  productionPrintListId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type GetExportSmartScaleMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', prepareSmartScaleExport: boolean } | null };

export type ListProcurementProductsQueryVariables = Exact<{
  filter?: InputMaybe<Wa_ProcurementProductsGridFilter>;
}>;


export type ListProcurementProductsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProcurementProducts: Array<{ __typename?: 'WA_ProcurementProductsGridItem', id: string, productNo?: string | null, description?: string | null, storageMin?: number | null, storageMax?: number | null, storageActual?: number | null }> } | null };

export type GetProcurementProductDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProcurementProductDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getProcurementProductData: { __typename?: 'WA_ProcurementProduct', id: string, productNo?: string | null, description?: string | null, storageMin?: number | null, storageMax?: number | null, storageActual?: number | null, storageLocationId?: string | null } } | null };

export type ListProcurementProductStorageChangesQueryVariables = Exact<{
  procurementProductId: Scalars['ID']['input'];
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
}>;


export type ListProcurementProductStorageChangesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ProcurementProductStorageChanges: Array<{ __typename?: 'WA_ProcurementProductStorageChange', onDate?: any | null, quantityBeginOfTheDay?: number | null, historyUser?: string | null, operationDate?: any | null, numberOfSource?: number | null, quantityDiff?: number | null }> } | null };

export type SaveProcurementProductDataMutationVariables = Exact<{
  dataToSave: Wa_SaveProcurementProductInput;
}>;


export type SaveProcurementProductDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveProcurementProductData: { __typename?: 'WA_SaveProcurementProductResult', status: C_Save_Operation_Status, updatedGridItem?: { __typename?: 'WA_ProcurementProductsGridItem', id: string, productNo?: string | null, description?: string | null, storageMin?: number | null, storageMax?: number | null, storageActual?: number | null } | null } } | null };

export type GetProcurementProductStorageQuantityQueryVariables = Exact<{
  procurementProductId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
}>;


export type GetProcurementProductStorageQuantityQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ProcurementProductStorageQuantity: number } | null };

export type ChangeProcurementProductStorageQuantityMutationVariables = Exact<{
  procurementProductId: Scalars['ID']['input'];
  onDate: Scalars['Date']['input'];
  difference: Scalars['Float']['input'];
}>;


export type ChangeProcurementProductStorageQuantityMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', changeWA_ProcurementProductStorageQuantity: boolean } | null };

export type SendStockListToCloudPrinterMutationVariables = Exact<{
  params: Wa_SendStockListToCloudPrinterInput;
}>;


export type SendStockListToCloudPrinterMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', sendStockListToCloudPrinter: boolean } | null };

export type GetToolboxConfigDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetToolboxConfigDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getConfigData: { __typename?: 'WA_Config', toolboxExportArticleListsFilterCheckedState: Array<{ __typename?: 'WA_ArticleListCheckedState', id: string, name?: string | null, checked?: boolean | null }> } } | null };

export type PrepareToolboxExportFilesQueryVariables = Exact<{
  onDate: Scalars['Date']['input'];
}>;


export type PrepareToolboxExportFilesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', prepareToolboxExportFiles: { __typename?: 'WA_ToolboxExportResult', url: string, ordersCount: number } } | null };

export type GetTasksStatusQueryVariables = Exact<{
  tasksId: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetTasksStatusQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWinReportTasksStatuses: Array<{ __typename?: 'WinReportTaskState', taskId: number, status: C_Win_Report_Task_Status }> } | null };

export type Create_R1_BakingList2ColumnsReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R1_BakingList2ColumnsReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r1_BakingList2ColumnsReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R11_CrosstableReportA4LandscapeReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R11_CrosstableReportA4LandscapeReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r11_CrosstableReportA4LandscapeReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R14_BakingListWithRecipe2ColumnsReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R14_BakingListWithRecipe2ColumnsReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r14_BakingListWithRecipe2ColumnsReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R15_ForwardingListCustomerArticlesReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R15_ForwardingListCustomerArticlesReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r15_ForwardingListCustomerArticlesReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R20_ForwardingListArticleCustomersReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R20_ForwardingListArticleCustomersReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r20_ForwardingListArticleCustomersReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R25_BakingList2ColumnsCombinedReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R25_BakingList2ColumnsCombinedReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r25_BakingList2ColumnsCombinedReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R26_BakingListWithRecipeA4ReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R26_BakingListWithRecipeA4ReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r26_BakingListWithRecipeA4Report?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R27_BakingListWithRecipeA5ReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R27_BakingListWithRecipeA5ReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r27_BakingListWithRecipeA5Report?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R32_TourlistReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R32_TourlistReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r32_TourlistReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R34_BakingListA4ReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R34_BakingListA4ReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r34_BakingListA4Report?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R41_BakingListA4DetailedReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R41_BakingListA4DetailedReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r41_BakingListA4DetailedReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R42_ForwardingListCustomerArticlesOnePerPageReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R42_ForwardingListCustomerArticlesOnePerPageReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r42_ForwardingListCustomerArticlesOnePerPageReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R51_DeliveryNotesReportsMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R51_DeliveryNotesReportsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r51_DeliveryNotesReports?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R57_BakingListRawmaterials2ColumnsReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R57_BakingListRawmaterials2ColumnsReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r57_BakingListRawmaterials2ColumnsReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R65_CrosstableReportA4PortraitReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R65_CrosstableReportA4PortraitReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r65_CrosstableReportA4PortraitReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type Create_R66_BakingListForCakesAndPiesReportMutationVariables = Exact<{
  params: CreateProductionReportParamsInput;
}>;


export type Create_R66_BakingListForCakesAndPiesReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r66_BakingListForCakesAndPiesReport?: { __typename?: 'WinReportTask', url: string, taskId: number, s3Key: string } | null } | null };

export type ListWa_AutomationTasksQueryVariables = Exact<{
  filter?: InputMaybe<AutomationTaskFilterInput>;
  cursors?: InputMaybe<AutomationTaskCursorsInput>;
}>;


export type ListWa_AutomationTasksQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_AutomationTasks?: { __typename?: 'ScheduledAutomationTaskConnection', items: Array<{ __typename?: 'ScheduledAutomationTask', taskName: string, isActive: boolean, taskType: C_Automation_Task_Type, scheduleCron: string, nextExecution?: Array<any> | null, targetLambdaPayload?: any | null, id: string, schedule: { __typename?: 'AutomationTaskSchedule', hours?: Array<any> | null, minutes: Array<any>, month?: Array<number> | null, monthDay?: Array<number> | null, weekDay?: Array<number> | null }, additonalInfo?: { __typename?: 'AutomationTaskAdditionalInfo', lastExecutedAt?: any | null } | null } | null>, cursors: { __typename?: 'AutomationTaskCursors', hasNext: boolean, after?: string | null } } | null } | null };

export type GetWa_AutomationTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWa_AutomationTaskQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_AutomationTask: { __typename?: 'ScheduledAutomationTask', taskName: string, isActive: boolean, taskType: C_Automation_Task_Type, scheduleCron: string, nextExecution?: Array<any> | null, targetLambdaPayload?: any | null, id: string, schedule: { __typename?: 'AutomationTaskSchedule', hours?: Array<any> | null, minutes: Array<any>, month?: Array<number> | null, monthDay?: Array<number> | null, weekDay?: Array<number> | null }, additonalInfo?: { __typename?: 'AutomationTaskAdditionalInfo', lastExecutedAt?: any | null } | null } } | null };

export type CreateWa_AutomationTaskMutationVariables = Exact<{
  params: AutomationCreateInput;
}>;


export type CreateWa_AutomationTaskMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createWA_AutomationTask: { __typename?: 'AutomationTaskCreateResult', scheduleCron: string, id: string } } | null };

export type UpdateWa_AutomationTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: AutomationTaskUpdateInput;
}>;


export type UpdateWa_AutomationTaskMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', updateWA_AutomationTask: { __typename?: 'ScheduledAutomationTask', taskName: string, isActive: boolean, taskType: C_Automation_Task_Type, scheduleCron: string, nextExecution?: Array<any> | null, targetLambdaPayload?: any | null, id: string, schedule: { __typename?: 'AutomationTaskSchedule', hours?: Array<any> | null, minutes: Array<any>, month?: Array<number> | null, monthDay?: Array<number> | null, weekDay?: Array<number> | null }, additonalInfo?: { __typename?: 'AutomationTaskAdditionalInfo', lastExecutedAt?: any | null } | null } } | null };

export type DeleteWa_AutomationTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWa_AutomationTaskMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_AutomationTask: { __typename?: 'AutomationTaskDeleteResult', id: string } } | null };

export type RunWa_AutomationTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RunWa_AutomationTaskMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', runWA_AutomationTask: boolean } | null };

export type ListBakery2bQueryVariables = Exact<{ [key: string]: never; }>;


export type ListBakery2bQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_Bakery2b: Array<{ __typename?: 'WA_ListBakery2b', id: string, note?: string | null, email: string, isDeactivated: boolean, name: string, orderAddNewItem: boolean, orderShowPrice: boolean, orderNoDelivery: boolean, standardOrderEdit: boolean, whyDeactivated?: string | null }> } | null };

export type SaveBakery2bClientMutationVariables = Exact<{
  dataToSave: Wa_SaveBakery2bClientInput;
}>;


export type SaveBakery2bClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_Bakery2bClient: { __typename?: 'WA_SaveConfigResult', status: C_Save_Operation_Status } } | null };

export type ActivateBakery2bClientMutationVariables = Exact<{
  activateWaBakery2BClientId: Scalars['ID']['input'];
}>;


export type ActivateBakery2bClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', activateWA_Bakery2bClient: { __typename?: 'WA_ActivateConfigRecordResult', status: C_Activate_Operation_Status } } | null };

export type AddCustomerConnectedWithBakery2BClientMutationVariables = Exact<{
  customerData: Wa_AddCustomerConnectedWithBakery2BClientInput;
}>;


export type AddCustomerConnectedWithBakery2BClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', addWA_CustomerConnectedWithBakery2BClient: { __typename?: 'WA_AddCustomerConnectedWithBakery2BClientResult', customerId: string, customerNo: string, name: string } } | null };

export type DeactivateBakery2bClientMutationVariables = Exact<{
  deactivateWaBakery2BClientId: Scalars['ID']['input'];
  whyDeactivated: Scalars['String']['input'];
}>;


export type DeactivateBakery2bClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deactivateWA_Bakery2bClient: { __typename?: 'WA_DeactivateConfigRecordResult', status: C_Deactivate_Operation_Status } } | null };

export type DeleteBakery2bClientMutationVariables = Exact<{
  deleteWaBakery2BClientId: Scalars['ID']['input'];
}>;


export type DeleteBakery2bClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_Bakery2bClient: { __typename?: 'WA_DeleteConfigRecordResult', status: C_Delete_Operation_Status } } | null };

export type DeleteCustomerConnectedWithBakery2BClientMutationVariables = Exact<{
  customerData: Wa_DeleteCustomerConnectedWithBakery2BClientInput;
}>;


export type DeleteCustomerConnectedWithBakery2BClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteWA_CustomerConnectedWithBakery2BClient: { __typename?: 'WA_DeleteConfigRecordResult', status: C_Delete_Operation_Status } } | null };

export type ListCustomerConnectedWithBakery2bClientQueryVariables = Exact<{
  listWaCustomerConnectedWithBakery2BClientId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ListCustomerConnectedWithBakery2bClientQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_CustomerConnectedWithBakery2bClient: Array<{ __typename?: 'WA_ListCustomerConnectedWithBakery2bClient', id: string, customerNo: string, name: string }> } | null };

export type ReinviteBakery2bClientMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type ReinviteBakery2bClientMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', reinviteWA_Bakery2bClient: { __typename?: 'WA_SendInviteResult', status: C_Invite_Operation_Status } } | null };

export type GetWa_Bakery2bSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWa_Bakery2bSettingsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_Bakery2bSettings: { __typename?: 'WA_Bakery2bSettings', allowZeroOrders: boolean, brandName?: string | null, companyName?: string | null, emailForOrderNotifications?: string | null, isMultiOrders: boolean, language: C_Bakery2B_Language, mainCurrency: C_Bakery2B_Currency, menuBgColor?: C_Bakery2B_Menu_Color | null, menuBgImg?: string | null, orderFutureDays: number, orderMinimalValue: number, profileLogo?: string | null, showTotalColumn: boolean, site?: string | null, useWholeNumbers: boolean }, getConfigData: { __typename?: 'WA_Config', isEditUsualOrdersInBakery2b: boolean } } | null };

export type SaveWa_Bakery2bSettingsMutationVariables = Exact<{
  params: Wa_SaveBakery2bSettings;
}>;


export type SaveWa_Bakery2bSettingsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_Bakery2bSettings: boolean } | null };

export type ListBakery2bStatisticQueryVariables = Exact<{
  params: Wa_Bakery2bStatisticInput;
}>;


export type ListBakery2bStatisticQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_Bakery2bStatistic: Array<{ __typename?: 'WA_Bakery2bStatistic', email?: string | null, name?: string | null, newBakery2bOrders: number, orders: number, totalOrders: number }> } | null };

export type ListWa_TaxesPeriodsAndRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWa_TaxesPeriodsAndRatesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_TaxesPeriodsAndRates: Array<{ __typename?: 'WA_TaxesPeriodAndRates', fromDate: any, toDate?: any | null, vatNormal: number, vatReduced: number, vatSpecial1: number, vatSpecial2: number, vatZero: number }> } | null };

export type ExecuteWa_ArticlesImportMutationVariables = Exact<{
  importData: Array<Wa_ArticleImportDataInput> | Wa_ArticleImportDataInput;
}>;


export type ExecuteWa_ArticlesImportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', executeWA_ArticlesImport: { __typename?: 'WA_ImportResult', recordsInserted?: number | null, recordsUpdated?: number | null, recordsSkipped?: number | null } } | null };

export type ExecuteWa_CustomersImportMutationVariables = Exact<{
  importData: Array<Wa_CustomerImportDataInput> | Wa_CustomerImportDataInput;
}>;


export type ExecuteWa_CustomersImportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', executeWA_CustomersImport: { __typename?: 'WA_ImportResult', recordsInserted?: number | null, recordsUpdated?: number | null, recordsSkipped?: number | null } } | null };

export type ListWa_ArticleNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWa_ArticleNumbersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Articles: Array<{ __typename?: 'WA_ArticleDictItem', articleNo?: string | null }> } | null };

export type ListWa_CustomerNumbersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWa_CustomerNumbersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Customers: Array<{ __typename?: 'WA_CustomerDictItem', customerNo?: string | null }> } | null };

export type GetWa_ImportDataFromFileQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetWa_ImportDataFromFileQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ImportDataFromFile: { __typename?: 'WA_ImportDataWithStatus', status: C_Xls_File_Processing_Status, data?: { __typename?: 'WA_ImportData', customerImportData: Array<{ __typename?: 'WA_CustomerImportData', customerNo: string, isActive?: boolean | null, informationTip?: string | null, customerAddressKindId?: string | null, customerGroupId?: string | null, deliveryNoteGroupId?: string | null, salutation?: string | null, name?: string | null, surname?: string | null, internalName?: string | null, addition?: string | null, street?: string | null, postBox?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, deliveryAddressSalutation?: string | null, deliveryAddressName?: string | null, deliveryAddressAddition?: string | null, deliveryAddressStreet?: string | null, deliveryAddressPostBox?: string | null, deliveryAddressZipCode?: string | null, deliveryAddressCity?: string | null, deliveryAddressCountry?: string | null, contactPerson?: string | null, phoneBusiness?: string | null, phoneBusiness2?: string | null, phonePrivate?: string | null, phoneMobile?: string | null, fax?: string | null, email?: string | null, emailForInvoice?: string | null, website?: string | null, priceCategoryId?: string | null, taxSystemId?: string | null, discountKindId?: string | null, quantityDiscountSettingId?: string | null, discountOnGroup1?: number | null, discountOnGroup2?: number | null, discountOnGroup3?: number | null, discountOnGroup4?: number | null, discountOnGroup5?: number | null, discountOnGroup6?: number | null, discountOnGroup7?: number | null, discountOnGroup8?: number | null, discountOnGroup9?: number | null, discountOnGroup10?: number | null, discountOnGroup11?: number | null, discountOnGroup12?: number | null, discountOnGroup13?: number | null, discountOnGroup14?: number | null, discountOnGroup15?: number | null, discountOnGroup16?: number | null, discountOnGroup17?: number | null, discountOnGroup18?: number | null, discountOnGroup19?: number | null, discountOnGroup20?: number | null, invoicingIntervalId?: string | null, debitorStatus?: string | null, returnLimit?: number | null, eInvoiceFormat?: string | null, eInvoiceRoutingAddress?: string | null, paymentPeriod?: number | null, individualPaymentTerms?: string | null, skonto?: number | null, skontoPeriod?: number | null, besrBankId?: string | null, debtorAccount?: number | null, slipReferenceNo?: string | null, directDebitBankId?: string | null, bank1Name?: string | null, bank1BIN?: string | null, bank1AccountNo?: string | null, bank1IBAN?: string | null, bank1BIC?: string | null, bank1MandatNo?: string | null, bank1MandatSignatureDate?: any | null, bank2Name?: string | null, bank2BIN?: string | null, bank2AccountNo?: string | null, bank2IBAN?: string | null, bank2BIC?: string | null, bank2MandatNo?: string | null, bank2MandatSignatureDate?: any | null, isDeliveredMon?: boolean | null, isDeliveredTue?: boolean | null, isDeliveredWed?: boolean | null, isDeliveredThu?: boolean | null, isDeliveredFri?: boolean | null, isDeliveredSat?: boolean | null, isDeliveredSun?: boolean | null, defaultOrderSourceId?: string | null, isAllowedAutoOrder?: boolean | null, isDeliverySplitting?: boolean | null, deliverySplittingPartsCount?: number | null, isFlexibleOrders?: boolean | null, distributionLowerLimit?: number | null, distributionHigherLimit?: number | null, transportSectorId?: string | null, isAlwaysInTourplan?: boolean | null, tourplanNote?: string | null, tourplanId?: string | null, tourPreparationArea?: string | null, tourDepartureTime?: string | null, tourPosition?: number | null, tourplanSatId?: string | null, tourSatPreparationArea?: string | null, tourSatDepartureTime?: string | null, tourSatPosition?: number | null, tourplanSunId?: string | null, tourSunPreparationArea?: string | null, tourSunDepartureTime?: string | null, tourSunPosition?: number | null, defaultNoteInOrder?: string | null, defaultNoteInOrder2?: string | null, defaultNoteInInvoice?: string | null, defaultNoteInInvoice2?: string | null, deliveryNoteCopies?: number | null, invoiceCopies?: number | null, eBillAccount?: string | null, orderReportId?: string | null, invoiceReportId?: string | null, invoiceSummaryReportId?: string | null, invoicePaymentSlipReportId?: string | null, offerReportId?: string | null, isCashAssistCreditCustomer?: boolean | null, caPriceAndDiscountSourceId?: string | null, caSpecialDiscount?: number | null }>, articleImportData: Array<{ __typename?: 'WA_ArticleImportData', articleNo: string, description?: string | null, isActive?: boolean | null, note?: string | null, isNotifyOnOrderStage?: boolean | null, discountGroupId?: string | null, productionGroupId?: string | null, marketingGroupId?: string | null, shippingPointId?: string | null, saleUnitId?: string | null, quantityPerLot?: number | null, vatCode?: string | null, isNoDiscount?: boolean | null, price1?: number | null, price2?: number | null, price3?: number | null, price4?: number | null, price5?: number | null, price6?: number | null, price7?: number | null, price8?: number | null, price9?: number | null, price10?: number | null, isDeliveredMon?: boolean | null, isDeliveredTue?: boolean | null, isDeliveredWed?: boolean | null, isDeliveredThu?: boolean | null, isDeliveredFri?: boolean | null, isDeliveredSat?: boolean | null, isDeliveredSun?: boolean | null, availabilityInProcurementKindId?: string | null, isShowOnProductionPrintLists?: boolean | null, isDough?: boolean | null, doughWeightBeforeBaking?: number | null, countPerSheetOfCuttingMachine?: number | null, countOfSheetsPerCuttingMachine?: number | null, weightOfLiterOfDough?: number | null, roundLitersTo?: number | null, willReplacedWithProductionCalc?: boolean | null, isProductionQuantityRounding?: boolean | null, productionQuantityRoundTo?: number | null, caTemplateId?: string | null, caProductGroupId?: string | null, caVisibilityStatusId?: string | null, eanCode?: string | null, isEanCodeManagedByCA?: boolean | null, declaration?: string | null, consumersInformation?: string | null, consumersStorageInfo?: string | null, daysToSell?: number | null, daysToConsume?: number | null, daysShelfLife?: number | null, isStoreInCoolPlace?: boolean | null, storagePlace?: string | null, sellingWeight?: number | null, shippingWeight?: number | null, daysToProduce?: number | null, isDoughSplitting?: boolean | null, doughSplittingDough1Amount?: number | null, descriptionTranslations?: Array<{ __typename?: 'WA_ArticleImportTranslatedContent', content: string, languageId?: string | null, languageTag?: string | null }> | null, declarationTranslations?: Array<{ __typename?: 'WA_ArticleImportTranslatedContent', content: string, languageId?: string | null, languageTag?: string | null }> | null }> } | null } } | null };

export type InitWa_ProcessingFileWithImportDataMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type InitWa_ProcessingFileWithImportDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', initWA_ProcessingFileWithImportData: string } | null };

export type ListArticleNumberDuplicatesFromCaQueryVariables = Exact<{ [key: string]: never; }>;


export type ListArticleNumberDuplicatesFromCaQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ArticleNumberDuplicatesFromCA: Array<{ __typename?: 'WA_ArticleNumberDuplicateFromCA', caId: string, caArticleNo?: string | null, caDescription?: string | null }> } | null };

export type ListPriceCategoriesMappingBetweenWaAndCaQueryVariables = Exact<{ [key: string]: never; }>;


export type ListPriceCategoriesMappingBetweenWaAndCaQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_PriceCategoriesMappingBetweenWAAndCA: Array<{ __typename?: 'WA_PriceCategoryMappingBetweenWAAndCA', caCategoryId: string, caCategoryName?: string | null, caCategoryIsCafe: boolean, waCategoryId?: string | null, waCategoryName?: string | null }> } | null };

export type ExecuteArticlesImportFromCaMutationVariables = Exact<{ [key: string]: never; }>;


export type ExecuteArticlesImportFromCaMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', executeWA_ArticlesImportFromCA: { __typename?: 'WA_ImportResult', recordsInserted?: number | null, recordsUpdated?: number | null, recordsSkipped?: number | null } } | null };

export type SavePriceCategoriesMappingBetweenWaAndCaMutationVariables = Exact<{
  mapping: Array<Wa_PriceCategoryMappingBetweenWaAndCaInput> | Wa_PriceCategoryMappingBetweenWaAndCaInput;
}>;


export type SavePriceCategoriesMappingBetweenWaAndCaMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', savePriceCategoriesMappingBetweenWAAndCA: { __typename?: 'WA_SaveConfigResult', status: C_Save_Operation_Status } } | null };

export type GetReportsConfigurationQueryVariables = Exact<{
  subCompanyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetReportsConfigurationQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getReportsConfiguration: { __typename?: 'WA_ReportsConfiguration', subCompanyId?: string | null, articlePricelist: { __typename?: 'WA_ReportConfigArticlePricelist', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, address: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, logo1Page: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, logoFrom2ndPage: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, articlePricelistDefaultValues: { __typename?: 'WA_ReportConfigArticlePricelist', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, address: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, logo1Page: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, logoFrom2ndPage: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, offer: { __typename?: 'WA_ReportConfigOffer', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, phoneNumber: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, offerDefaultValues: { __typename?: 'WA_ReportConfigOffer', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, phoneNumber: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, deliveryNoteA4: { __typename?: 'WA_ReportConfigDeliveryNoteA4', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, phoneNumber: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, sellerPerson: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, receiversSignature: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, deliveryNoteA4DefaultValues: { __typename?: 'WA_ReportConfigDeliveryNoteA4', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, phoneNumber: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, sellerPerson: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, receiversSignature: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, deliveryNoteA5: { __typename?: 'WA_ReportConfigDeliveryNoteA5', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, phoneNumber: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, deliveryNoteA5DefaultValues: { __typename?: 'WA_ReportConfigDeliveryNoteA5', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, phoneNumber: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, invoice: { __typename?: 'WA_ReportConfigInvoice', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo1Page: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, logoFrom2ndPage: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number }, invoiceAddressFrom2ndPage: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, reasonForDeletion: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, bankInformation: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, invoiceDefaultValues: { __typename?: 'WA_ReportConfigInvoice', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo1Page: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, logoFrom2ndPage: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, invoiceAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, deliveryAddress: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number }, invoiceAddressFrom2ndPage: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, reasonForDeletion: { __typename?: 'WA_ReportObject', isVisible: boolean, left: number, top: number, height: number, width: number }, bankInformation: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, companyVatNo: { __typename?: 'WA_ReportObjectVisibility', isVisible: boolean }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, paymentSlip: { __typename?: 'WA_ReportConfigPaymentSlip', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, customText: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, picture: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null } }, paymentSlipDefaultValues: { __typename?: 'WA_ReportConfigPaymentSlip', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, customText: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, picture: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null } }, debtReminder: { __typename?: 'WA_ReportConfigDebtReminder', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, address: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, bankInformation: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } }, debtReminderDefaultValues: { __typename?: 'WA_ReportConfigDebtReminder', pageMargins: { __typename?: 'WA_ReportPageMargins', left: number, top: number, bottom: number }, pageBgImage: { __typename?: 'WA_ReportPageBgImage', isVisible: boolean, image?: string | null }, letterhead: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, logo: { __typename?: 'WA_ReportImage', isVisible: boolean, left: number, top: number, height: number, width: number, image?: string | null }, address: { __typename?: 'WA_ReportObjectWithCustomFont', isVisible: boolean, left: number, top: number, height: number, width: number, fontOverride?: { __typename?: 'WA_FontDescription', family: string, size: number, style: { __typename?: 'WA_FontStyle', isBold: boolean, isItalic: boolean, isUnderline: boolean } } | null }, bankInformation: { __typename?: 'WA_ReportObjectWithFormattedText', isVisible: boolean, left: number, top: number, height: number, width: number, formattedText?: string | null }, footerImage: { __typename?: 'WA_ReportFooterImage', isVisible: boolean, left: number, height: number, width: number, image?: string | null }, footerText: { __typename?: 'WA_ReportFooterObjectWithFormattedText', isVisible: boolean, left: number, height: number, width: number, formattedText?: string | null }, printedAt: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, pageNumbering: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number }, createdBy: { __typename?: 'WA_ReportFooterObject', isVisible: boolean, left: number, height: number, width: number } } } } | null };

export type SaveReportsConfigurationMutationVariables = Exact<{
  dataToSave: Wa_ReportsConfigurationInput;
}>;


export type SaveReportsConfigurationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveReportsConfiguration: { __typename?: 'WA_SaveReportsConfigResult', status: C_Save_Operation_Status } } | null };

export type GetWa_DataForReportsConfigurationPreviewQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWa_DataForReportsConfigurationPreviewQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_DataForReportsConfigurationPreview: { __typename?: 'WA_ReportsConfigurationPreviewData', offerPreviewData: Array<{ __typename?: 'WA_ReportConfigOfferPreviewData', offerId?: string | null, subCompanyId?: string | null }>, deliveryNoteA4PreviewData: Array<{ __typename?: 'WA_ReportConfigDeliveryNoteA4PreviewData', orderId?: string | null, subCompanyId?: string | null }>, deliveryNoteA5PreviewData: Array<{ __typename?: 'WA_ReportConfigDeliveryNoteA5PreviewData', orderId?: string | null, subCompanyId?: string | null }>, invoicePreviewData: Array<{ __typename?: 'WA_ReportConfigInvoicePreviewData', invoiceId?: string | null, subCompanyId?: string | null }>, paymentSlipPreviewData: Array<{ __typename?: 'WA_ReportConfigPaymentSlipPreviewData', invoiceId?: string | null, subCompanyId?: string | null }>, debtReminderPreviewData: Array<{ __typename?: 'WA_ReportConfigDebtReminderPreviewData', invoiceId?: string | null, invoiceDate?: any | null, customerId?: string | null, subCompanyId?: string | null }>, articlePricelistPreviewData: Array<{ __typename?: 'WA_ReportConfigArticlePricelistPreviewData', articlesIds: Array<string>, customerId?: string | null, subCompanyId?: string | null }> } } | null };

export type ListReportPrinterMappingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListReportPrinterMappingsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ReportPrinterMappings: Array<{ __typename?: 'WA_ListReportPrinterMapping', printedReportsKindId: C_Printed_Reports_Kind, printerId?: string | null }> } | null };

export type SaveReportPrinterMappingsMutationVariables = Exact<{
  mapping: Array<Wa_SaveReportPrinterMappingsInput> | Wa_SaveReportPrinterMappingsInput;
}>;


export type SaveReportPrinterMappingsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveWA_ReportPrinterMappings: { __typename?: 'WA_SaveReportPrinterMappingsResult', status: C_Save_Operation_Status } } | null };

export type Wa_InitOrderStatisticCalcMutationVariables = Exact<{
  orderStatisticProps: Wa_InitOrderStatisticInputs;
}>;


export type Wa_InitOrderStatisticCalcMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', WA_initOrderStatisticCalc: { __typename?: 'WA_InitStatisticCalc', jobId: string } } | null };

export type GetStatisticDataQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetStatisticDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_statisticData: { __typename?: 'WA_StatisticData', status: C_Statistic_Calc_Status, data?:
        | { __typename?: 'WA_OrderStatisticData', presentedOrderTypes: Array<C_Order_Type>, items: Array<{ __typename?: 'WA_OrderStatisticItem', articleId: number, totalQuantity: number, articleNo: string, articleDescription?: string | null, customerId?: number | null, customerNo?: string | null, customerName?: string | null, netSales?: number | null, netSalesByPeriods?: Array<number | null> | null, quantityByPeriods?: Array<number | null> | null, periodPartsCount?: number | null, periodPartsType?: C_Statistic_Period_Type | null, date?: any | null, id?: string | null, discountGroup?: string | null, marketingGroup?: string | null, productionGroup?: string | null, quantityByOrderTypes?: Array<{ __typename?: 'WA_QuantityByOrderTypesItem', orderType?: C_Order_Type | null, quantity?: number | null } | null> | null }>, summaryData: { __typename?: 'WA_SummaryData', topArticle?: string | null, topCustomer?: string | null, totalQuantity?: number | null, totalNetSales?: number | null }, chartsDataset: { __typename?: 'IChartDataset', values: Array<number>, keys: Array<string> } }
        | { __typename?: 'WA_ProductionStatisticData' }
       | null } } | null };

export type InitProdStatisticCalcMutationVariables = Exact<{
  prodStatisticProps: Wa_InitProdStatisticInputs;
}>;


export type InitProdStatisticCalcMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', initWA_ProdStatisticCalc: { __typename?: 'WA_InitStatisticCalc', jobId: string } } | null };

export type GetProdStatisticDataQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetProdStatisticDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_statisticData: { __typename?: 'WA_StatisticData', status: C_Statistic_Calc_Status, data?:
        | { __typename?: 'WA_OrderStatisticData' }
        | { __typename?: 'WA_ProductionStatisticData', gridData: Array<{ __typename?: 'WA_ProdStatisticItem', id?: string | null, articleNo?: string | null, articleDescription?: string | null, grossSales?: number | null, quantity?: number | null, discountGroup?: string | null, productionGroup?: string | null, doughArticleId?: string | null, doughArticleNo?: string | null, doughArticleDescription?: string | null, doughWeightKg?: number | null, doughVolumeLt?: number | null, articleId?: string | null, description?: string | null, doughRequiredPerSaleUnitG?: number | null, totalDoughRequiredG?: number | null, totalDoughRequiredLt?: number | null, hasConnectionsToProductionCalc?: boolean | null, rawMaterialIdRA?: string | null, hfRecipeUsedAsRawMaterialIdRA?: string | null, rawMaterialNummerRA?: string | null, rawMaterialDescriptionRA?: string | null, rawMaterialWeight?: number | null, doughArticleIdWA?: string | null, doughArticleNummerWA?: string | null, doughArticleDescriptionWA?: string | null, doughWeight?: number | null }>, summaryData: { __typename?: 'WA_ProdSummaryData', topArticle?: string | null, totalQuantity?: number | null, totalGrossSales?: number | null, topDough?: string | null, totalDoughKinds?: number | null, totalDoughWeight?: number | null, topRawMaterial?: string | null, totalRawMaterialKinds?: number | null, totalRawMaterialsWeight?: number | null }, chartsDataset: { __typename?: 'IChartDataset', values: Array<number>, keys: Array<string> } }
       | null } } | null };

export type SendWa_QueryToAiAssistantMutationVariables = Exact<{
  query: Scalars['String']['input'];
  appTimezoneOffset: Scalars['String']['input'];
}>;


export type SendWa_QueryToAiAssistantMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', sendWA_QueryToAIAssistant: string } | null };

export type GetWa_ReplyFromAiAssistantQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type GetWa_ReplyFromAiAssistantQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_ReplyFromAIAssistant: { __typename?: 'WA_AIAssistantReplyWithStatus', status: C_Ai_Assistant_Query_Status, reply: { __typename?: 'AssistantResponse', role: string, free_tokens: number, premium_tokens: number, content: { __typename?: 'AssistantContent', text: string, files: Array<{ __typename?: 'AssistantFileData', path: string, file_format: string } | null>, expert_mode: { __typename?: 'AssistantExpertMode', total_steps_count: number, total_time_spent_sec: number, steps: Array<{ __typename?: 'AssistantStep', number: number, name: string, details: { __typename?: 'AssistantStepDetails', type: string, model?: string | null, status: string, time_spent_sec: number, total_tokens_spent?: number | null, arguments?: { __typename?: 'AssistantStepArguments', code?: string | null } | null } }> } } } } } | null };

export type GetWa_AiAssistantInitialisationDataQueryVariables = Exact<{
  appTimezoneOffset: Scalars['String']['input'];
}>;


export type GetWa_AiAssistantInitialisationDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_AIAssistantInitialisationData: { __typename?: 'WA_AIAssistantInitialisationData', free_tokens: number, premium_tokens: number } } | null };

export type GetDictWa_TextBlockQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictWa_TextBlockQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_TextBlock: { __typename?: 'WA_TextBlock', textBlock?: string | null, textBlockTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type GetDictQuantityDiscountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictQuantityDiscountQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_QuantityDiscount: { __typename?: 'WA_QuantityDiscount', discountValues?: Array<{ __typename?: 'WA_QuantityDiscountValue', fromAmount?: number | null, discountOnAllGroups?: number | null, discountOnGroup1?: number | null, discountOnGroup2?: number | null, discountOnGroup3?: number | null, discountOnGroup4?: number | null, discountOnGroup5?: number | null, discountOnGroup6?: number | null, discountOnGroup7?: number | null, discountOnGroup8?: number | null, discountOnGroup9?: number | null, discountOnGroup10?: number | null, discountOnGroup11?: number | null, discountOnGroup12?: number | null, discountOnGroup13?: number | null, discountOnGroup14?: number | null, discountOnGroup15?: number | null, discountOnGroup16?: number | null, discountOnGroup17?: number | null, discountOnGroup18?: number | null, discountOnGroup19?: number | null, discountOnGroup20?: number | null }> | null } } | null };

export type GetDictWa_CustomerProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictWa_CustomerProfileQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_CustomerProfile: { __typename?: 'WA_CustomerProfile', id: string, name?: string | null, priceCategoryId: string, taxSystemId: C_Tax_System, discountKindId: C_Discount_Kind, quantityDiscountSettingId?: string | null, discountOnGroup1?: number | null, discountOnGroup2?: number | null, discountOnGroup3?: number | null, discountOnGroup4?: number | null, discountOnGroup5?: number | null, discountOnGroup6?: number | null, discountOnGroup7?: number | null, discountOnGroup8?: number | null, discountOnGroup9?: number | null, discountOnGroup10?: number | null, discountOnGroup11?: number | null, discountOnGroup12?: number | null, discountOnGroup13?: number | null, discountOnGroup14?: number | null, discountOnGroup15?: number | null, discountOnGroup16?: number | null, discountOnGroup17?: number | null, discountOnGroup18?: number | null, discountOnGroup19?: number | null, discountOnGroup20?: number | null, invoicingIntervalId: C_Invoice_Interval, debitorStatus: C_Debitor_Status, paymentPeriod?: number | null, skonto?: number | null, skontoPeriod?: number | null, besrBankId?: string | null, debtorAccount?: number | null, slipReferenceNo?: string | null, incomeAccount?: string | null, costCenter?: string | null, isDeliveredMon: boolean, isDeliveredTue: boolean, isDeliveredWed: boolean, isDeliveredThu: boolean, isDeliveredFri: boolean, isDeliveredSat: boolean, isDeliveredSun: boolean, orderReportId: C_Report, invoiceReportId: C_Report, invoiceSummaryReportId: C_Report, invoicePaymentSlipReportId: C_Report, customerDeliveryPeriodsSettings: { __typename?: 'WA_CustomerDeliveryPeriodsSettings', customerRegularDeliveryPeriods: Array<{ __typename?: 'WA_CustomerRegularDeliveryPeriod', id: string, fromDate?: any | null, toDate?: any | null, isRepeatYearly: boolean, description?: string | null }>, customerCustomWeekDaysAndDeliveryPeriods: Array<{ __typename?: 'WA_CustomerCustomWeekDaysAndDeliveryPeriod', id: string, fromDate?: any | null, toDate?: any | null, isDeliveredMon: boolean, isDeliveredTue: boolean, isDeliveredWed: boolean, isDeliveredThu: boolean, isDeliveredFri: boolean, isDeliveredSat: boolean, isDeliveredSun: boolean, isRepeatYearly: boolean, description?: string | null }>, customerVacations: Array<{ __typename?: 'WA_CustomerVacation', id: string, fromDate?: any | null, toDate?: any | null, description?: string | null }> } } } | null };

export type GetDictWa_BankQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictWa_BankQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_Bank: { __typename?: 'WA_Bank', id: string, name?: string | null, internalName?: string | null, internalNameOrName?: string | null, pcAccount?: string | null, memberNo?: string | null, bankLocation?: string | null, customerName1?: string | null, customerName2?: string | null, customerStreet?: string | null, customerLocation?: string | null, fibuAccount?: string | null, flagBookingAfter: C_Booking_Type, qrIBAN?: string | null, bankBIC?: string | null } } | null };

export type GetDictDebtReminderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictDebtReminderQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_DebtReminder: { __typename?: 'WA_DebtReminder', description?: string | null, reminderText?: string | null, descriptionTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }>, reminderTextTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type GetDictWa_SubCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictWa_SubCompanyQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_SubCompany: { __typename?: 'WA_SubCompany', id: string, countryId: C_Country, companySalutation?: string | null, companyName?: string | null, companyAddition?: string | null, companyStreet?: string | null, companyZipCode?: string | null, companyCity?: string | null, companyPhone?: string | null, companyFax?: string | null, companyEmail?: string | null, companyWebsite?: string | null, companyVatNo?: string | null, companyGLN?: string | null, bankName?: string | null, bankBIN?: string | null, bankAccountNo?: string | null, bankIBAN?: string | null, creditorIdNumber?: string | null, bankBIC?: string | null } } | null };

export type SaveDictWa_DiscountGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_DiscountGroupInput;
}>;


export type SaveDictWa_DiscountGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_DiscountGroup: C_Save_Operation_Status } | null };

export type DeleteDictWa_DiscountGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_DiscountGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_DiscountGroup: boolean } | null };

export type SaveDictWa_PriceCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_PriceCategoryInput;
}>;


export type SaveDictWa_PriceCategoryMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_PriceCategory: C_Save_Operation_Status } | null };

export type DeleteDictWa_PriceCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_PriceCategoryMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_PriceCategory: boolean } | null };

export type SaveDictWa_DeliveryNoteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_DeliveryNoteGroupInput;
}>;


export type SaveDictWa_DeliveryNoteGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_DeliveryNoteGroup: C_Save_Operation_Status } | null };

export type DeleteDictWa_DeliveryNoteGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_DeliveryNoteGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_DeliveryNoteGroup: boolean } | null };

export type CreateDictWa_ArticleListMutationVariables = Exact<{
  fields: Wa_ArticleListInput;
}>;


export type CreateDictWa_ArticleListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_ArticleList: { __typename?: 'WA_ArticleList', id: string } } | null };

export type SaveDictWa_ArticleListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_ArticleListInput;
}>;


export type SaveDictWa_ArticleListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_ArticleList: { __typename?: 'WA_ArticleList', id: string } } | null };

export type DeleteDictWa_ArticleListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_ArticleListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_ArticleList: boolean } | null };

export type CreateDictWa_CustomerListMutationVariables = Exact<{
  fields: Wa_CustomerListInput;
}>;


export type CreateDictWa_CustomerListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_CustomerList: { __typename?: 'WA_CustomerList', id: string } } | null };

export type SaveDictWa_CustomerListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_CustomerListInput;
}>;


export type SaveDictWa_CustomerListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_CustomerList: { __typename?: 'WA_CustomerList', id: string } } | null };

export type DeleteDictWa_CustomerListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_CustomerListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_CustomerList: boolean } | null };

export type CreateDictWa_CustomerGroupMutationVariables = Exact<{
  fields: Wa_CustomerGroupInput;
}>;


export type CreateDictWa_CustomerGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_CustomerGroup: { __typename?: 'WA_CustomerGroup', id: string } } | null };

export type SaveDictWa_CustomerGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_CustomerGroupInput;
}>;


export type SaveDictWa_CustomerGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_CustomerGroup: { __typename?: 'WA_CustomerGroup', id: string } } | null };

export type DeleteDictWa_CustomerGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_CustomerGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_CustomerGroup: boolean } | null };

export type CreateDictWa_TransportSectorMutationVariables = Exact<{
  fields: Wa_TransportSectorInput;
}>;


export type CreateDictWa_TransportSectorMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_TransportSector: { __typename?: 'WA_TransportSector', id: string } } | null };

export type CreateDictWa_CustomerProfileMutationVariables = Exact<{
  fields: Wa_CustomerProfileInput;
}>;


export type CreateDictWa_CustomerProfileMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_CustomerProfile: { __typename?: 'WA_CustomerProfile', id: string } } | null };

export type DeleteDictWa_CustomerProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDictWa_CustomerProfileMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_CustomerProfile: boolean } | null };

export type SaveDictWa_CustomerProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_CustomerProfileInput;
}>;


export type SaveDictWa_CustomerProfileMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_CustomerProfile: { __typename?: 'WA_CustomerProfile', id: string } } | null };

export type GetDictWa_TransportSectorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDictWa_TransportSectorQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getDictWA_TransportSector: { __typename?: 'WA_TransportSector', id: string, name?: string | null, isPriceRateFixed?: boolean | null, priceRateFixed?: number | null, priceRatesForWeight?: Array<{ __typename?: 'WA_PriceRateForWeight', id: string, weight?: number | null, price?: number | null }> | null } } | null };

export type DeleteDictWa_TransportSectorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_TransportSectorMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_TransportSector: boolean } | null };

export type SaveDictWa_TransportSectorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_TransportSectorInput;
}>;


export type SaveDictWa_TransportSectorMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_TransportSector: { __typename?: 'WA_TransportSector', id: string } } | null };

export type CreateDictWa_TextBlockMutationVariables = Exact<{
  fields: Wa_TextBlockInput;
}>;


export type CreateDictWa_TextBlockMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_TextBlock: { __typename?: 'WA_TextBlock', id: string } } | null };

export type SaveDictWa_TextBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_TextBlockInput;
}>;


export type SaveDictWa_TextBlockMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_TextBlock: { __typename?: 'WA_TextBlock', id: string } } | null };

export type DeleteDictWa_TextBlockMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_TextBlockMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_TextBlock: boolean } | null };

export type CreateDictWa_TourplanMutationVariables = Exact<{
  fields: Wa_TourplanInput;
}>;


export type CreateDictWa_TourplanMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_Tourplan: { __typename?: 'WA_Tourplan', id: string } } | null };

export type SaveDictWa_TourplanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_TourplanInput;
}>;


export type SaveDictWa_TourplanMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_Tourplan: { __typename?: 'WA_Tourplan', id: string } } | null };

export type DeleteDictWa_TourplanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_TourplanMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_Tourplan: boolean } | null };

export type CreateDictWa_ProductionGroupMutationVariables = Exact<{
  fields: Wa_ProductionGroupInput;
}>;


export type CreateDictWa_ProductionGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_ProductionGroup: { __typename?: 'WA_ProductionGroup', id: string } } | null };

export type SaveDictWa_ProductionGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_ProductionGroupInput;
}>;


export type SaveDictWa_ProductionGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_ProductionGroup: { __typename?: 'WA_ProductionGroup', id: string } } | null };

export type DeleteDictWa_ProductionGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_ProductionGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_ProductionGroup: boolean } | null };

export type CreateDictWa_ProductionPrintListGroupMutationVariables = Exact<{
  fields: Wa_ProductionPrintListGroupInput;
}>;


export type CreateDictWa_ProductionPrintListGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_ProductionPrintListGroup: { __typename?: 'WA_ProductionPrintListGroup', id: string } } | null };

export type SaveDictWa_ProductionPrintListGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_ProductionPrintListGroupInput;
}>;


export type SaveDictWa_ProductionPrintListGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_ProductionPrintListGroup: { __typename?: 'WA_ProductionPrintListGroup', id: string } } | null };

export type DeleteDictWa_ProductionPrintListGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_ProductionPrintListGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_ProductionPrintListGroup: boolean } | null };

export type CreateDictWa_ShippingPointMutationVariables = Exact<{
  fields: Wa_ShippingPointInput;
}>;


export type CreateDictWa_ShippingPointMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_ShippingPoint: { __typename?: 'WA_ShippingPoint', id: string } } | null };

export type SaveDictWa_ShippingPointMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_ShippingPointInput;
}>;


export type SaveDictWa_ShippingPointMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_ShippingPoint: { __typename?: 'WA_ShippingPoint', id: string } } | null };

export type DeleteDictWa_ShippingPointMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_ShippingPointMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_ShippingPoint: boolean } | null };

export type CreateDictWa_MarketingGroupMutationVariables = Exact<{
  fields: Wa_MarketingGroupInput;
}>;


export type CreateDictWa_MarketingGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_MarketingGroup: { __typename?: 'WA_MarketingGroup', id: string } } | null };

export type SaveDictWa_MarketingGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_MarketingGroupInput;
}>;


export type SaveDictWa_MarketingGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_MarketingGroup: { __typename?: 'WA_MarketingGroup', id: string } } | null };

export type DeleteDictWa_MarketingGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_MarketingGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_MarketingGroup: boolean } | null };

export type CreateDictWa_AssortimentGroupMutationVariables = Exact<{
  fields: Wa_AssortimentGroupInput;
}>;


export type CreateDictWa_AssortimentGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_AssortimentGroup: { __typename?: 'WA_AssortimentGroup', id: string } } | null };

export type SaveDictWa_AssortimentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_AssortimentGroupInput;
}>;


export type SaveDictWa_AssortimentGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_AssortimentGroup: { __typename?: 'WA_AssortimentGroup', id: string } } | null };

export type DeleteDictWa_AssortimentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_AssortimentGroupMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_AssortimentGroup: boolean } | null };

export type CreateDictQuantityDiscountMutationVariables = Exact<{
  fields: Wa_QuantityDiscountInput;
}>;


export type CreateDictQuantityDiscountMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_QuantityDiscount: { __typename?: 'WA_QuantityDiscount', id: string } } | null };

export type SaveDictQuantityDiscountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_QuantityDiscountInput;
}>;


export type SaveDictQuantityDiscountMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_QuantityDiscount: { __typename?: 'WA_QuantityDiscount', id: string } } | null };

export type DeleteDictQuantityDiscountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictQuantityDiscountMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_QuantityDiscount: boolean } | null };

export type CreateDictWa_BankMutationVariables = Exact<{
  fields: Wa_BankInput;
}>;


export type CreateDictWa_BankMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_Bank: { __typename?: 'WA_Bank', id: string } } | null };

export type SaveDictWa_BankMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_BankInput;
}>;


export type SaveDictWa_BankMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_Bank: { __typename?: 'WA_Bank', id: string } } | null };

export type DeleteDictWa_BankMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_BankMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_Bank: boolean } | null };

export type CreateDictDebtReminderMutationVariables = Exact<{
  fields: Wa_DebtReminderInput;
}>;


export type CreateDictDebtReminderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_DebtReminder: { __typename?: 'WA_DebtReminder', id: string } } | null };

export type SaveDictDebtReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_DebtReminderInput;
}>;


export type SaveDictDebtReminderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_DebtReminder: { __typename?: 'WA_DebtReminder', id: string } } | null };

export type DeleteDictDebtReminderMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDictDebtReminderMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_DebtReminder: boolean } | null };

export type CreateDictStorageLocationMutationVariables = Exact<{
  fields: Wa_StorageLocationInput;
}>;


export type CreateDictStorageLocationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_StorageLocation: { __typename?: 'WA_StorageLocation', id: string } } | null };

export type SaveDictStorageLocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_StorageLocationInput;
}>;


export type SaveDictStorageLocationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_StorageLocation: { __typename?: 'WA_StorageLocation', id: string, name?: string | null } } | null };

export type DeleteDictStorageLocationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictStorageLocationMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_StorageLocation: boolean } | null };

export type CreateDictCloudPrinterMutationVariables = Exact<{
  fields: Wa_CloudPrinterInput;
}>;


export type CreateDictCloudPrinterMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_CloudPrinter: { __typename?: 'WA_CloudPrinter', id: string } } | null };

export type SaveDictCloudPrinterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_CloudPrinterInput;
}>;


export type SaveDictCloudPrinterMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_CloudPrinter: { __typename?: 'WA_CloudPrinter', id: string, name: string, serialNo: string } } | null };

export type DeleteDictCloudPrinterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictCloudPrinterMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_CloudPrinter: boolean } | null };

export type CreateDictWa_SpecialDateMutationVariables = Exact<{
  fields: Wa_SpecialDateInput;
}>;


export type CreateDictWa_SpecialDateMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_SpecialDate: { __typename?: 'WA_SpecialDate', id: string, date: any, replacingDate: any, description?: string | null } } | null };

export type SaveDictWa_SpecialDateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_SpecialDateInput;
}>;


export type SaveDictWa_SpecialDateMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_SpecialDate: { __typename?: 'WA_SpecialDate', id: string, date: any, replacingDate: any, description?: string | null } } | null };

export type DeleteDictWa_SpecialDateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDictWa_SpecialDateMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_SpecialDate: boolean } | null };

export type CreateDictWa_SubCompanyMutationVariables = Exact<{
  fields: Wa_SubCompanyInput;
}>;


export type CreateDictWa_SubCompanyMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', createDictWA_SubCompany: { __typename?: 'WA_SubCompany', id: string, countryId: C_Country, companySalutation?: string | null, companyName?: string | null, companyAddition?: string | null, companyStreet?: string | null, companyZipCode?: string | null, companyCity?: string | null, companyPhone?: string | null, companyFax?: string | null, companyEmail?: string | null, companyWebsite?: string | null, companyVatNo?: string | null, companyGLN?: string | null, bankName?: string | null, bankBIN?: string | null, bankAccountNo?: string | null, bankIBAN?: string | null, creditorIdNumber?: string | null, bankBIC?: string | null } } | null };

export type SaveDictWa_SubCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: Wa_SubCompanyInput;
}>;


export type SaveDictWa_SubCompanyMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveDictWA_SubCompany: { __typename?: 'WA_SubCompany', id: string, countryId: C_Country, companySalutation?: string | null, companyName?: string | null, companyAddition?: string | null, companyStreet?: string | null, companyZipCode?: string | null, companyCity?: string | null, companyPhone?: string | null, companyFax?: string | null, companyEmail?: string | null, companyWebsite?: string | null, companyVatNo?: string | null, companyGLN?: string | null, bankName?: string | null, bankBIN?: string | null, bankAccountNo?: string | null, bankIBAN?: string | null, creditorIdNumber?: string | null, bankBIC?: string | null } } | null };

export type DeleteDictWa_SubCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  forceUnbindAndDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteDictWa_SubCompanyMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', deleteDictWA_SubCompany: boolean } | null };

export type EmailTrackingByDocumentQueryVariables = Exact<{
  docType: C_Email_Msg_Doctype;
  id: Scalars['ID']['input'];
}>;


export type EmailTrackingByDocumentQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_EmailTrackingByDocument: Array<{ __typename?: 'WA_EmailTrackingByDocument', messageId: string, senderAddress: string, receiverAddress: string, messageSubject?: string | null, timestamp?: any | null, events: Array<{ __typename?: 'WA_EmailTrackingEvent', timestamp?: any | null, type: C_Email_Tracking_Event_Type, diagnosticInfo?: string | null }> }> } | null };

export type ListHs_AppsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHs_AppsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listHS_Apps: Array<{ __typename?: 'HS_App', isAvailable: boolean, appType: C_Hs_App }> } | null };

export type GetWa_AiContentTranslationQueryVariables = Exact<{
  params: Wa_AiContentTranslationInput;
}>;


export type GetWa_AiContentTranslationQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getWA_AIContentTranslation: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } | null };

export type SendEmailMutationVariables = Exact<{
  params: SendSingleEmailInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', sendEmail: { __typename?: 'SentMessages', messageId: string, timestamp: any } } | null };

export type Wa_MergePdFsMutationVariables = Exact<{
  mergeItems: Array<Wa_MergePdfInput> | Wa_MergePdfInput;
}>;


export type Wa_MergePdFsMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', WA_mergePDFs: { __typename?: 'WA_MergedFile', url: string, s3Key: string } } | null };

export type GetConfigDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConfigDataQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', getConfigData: { __typename?: 'WA_Config', id: string, countryId: C_Country, companyLanguageId: C_Language, decimalPlacesCount?: number | null, isShippingFunctionActivated: boolean, isBakery2bActivated: boolean, isDefaultEmailTextForInvoice: boolean, customEmailTextForInvoice?: string | null, isDefaultEmailTextForOrder: boolean, isDefaultEmailTextForOffer: boolean, customEmailTextForOffer?: string | null, customEmailTextForOrder?: string | null, isDefaultEmailTextForDebtor: boolean, customEmailTextForDebtor?: string | null, orderPositionsSortingKindId: C_Order_Positions_Sorting_Kind, kiloAmountRepresentationId: C_Kg_Representation, defaultFontOfNoteInOrder?: string | null, isDoughInLitersInProductionReports: boolean, isAllowSameEANForMultipleArticles: boolean, isShowShippingPointsInArticle: boolean, nextDeliveryDate: any, companyNameInReports?: string | null, fibuClient?: number | null, fibuVatCodeNormal?: string | null, fibuVatCodeReduced?: string | null, fibuVatCodeWithoutVAT?: string | null, canForbidIncomingOrdersCAdirect: boolean, canWorkWithVersionsInProduction?: boolean | null, globalTaxSystemId: C_Tax_System, isUseProcurementLogicInProductionReports: boolean, isDatevCommitment: boolean, isAutoCustomerNo: boolean, autoCustomerNoPrefix?: string | null, autoCustomerNoCounter?: number | null, actualInvoiceNo?: number | null, actualOrderNo?: number | null, roundingArticlePricesMethodId: C_Rounding_Method, isUsePriceCategoryAhead: boolean, isGotoNextDeliveryDay: boolean, roundingTotalPricesMethodId: C_Rounding_Method, standardBankId?: string | null, besrFormatId: C_Besr_Format, operationCostCenter?: number | null, isPrintingAvailable: boolean, isCADBAvailable: boolean, isRADBAvailable: boolean, companySalutation?: string | null, companyName?: string | null, companyAddition?: string | null, companyStreet?: string | null, companyZipCode?: string | null, companyCity?: string | null, companyPhone?: string | null, companyFax?: string | null, companyEmail?: string | null, companyWebsite?: string | null, companyGLN?: string | null, companyVatNo?: string | null, companyTimeZone?: string | null, bankName?: string | null, bankBIN?: string | null, bankAccountNo?: string | null, bankIBAN?: string | null, creditorIdNumber?: string | null, bankBIC?: string | null, isDeliveryOnMon: boolean, isDeliveryOnTue: boolean, isDeliveryOnWed: boolean, isDeliveryOnThu: boolean, isDeliveryOnFri: boolean, isDeliveryOnSat: boolean, isDeliveryOnSun: boolean, isShowSplittedAmountInLiters: boolean, isShowRASemiproductsDetails: boolean, useTourSettingForEveryOrder: boolean, oneTimeCustomerDefaultSettingsId?: string | null, orderTypesFilterInProductionReportsCheckedState: Array<{ __typename?: 'WA_OrderTypesFilterInProductionReportsCheckedState', id: C_Order_Type, checked: boolean }>, currentUser: { __typename?: 'WA_CurrentUser', name?: string | null, company?: string | null, role?: string | null, avatarUrl?: string | null, userLanguageId?: C_Language | null }, orderEmailTextTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }>, offerEmailTextTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }>, invoiceEmailTextTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }>, debtReminderEmailTextTranslations: Array<{ __typename?: 'WA_TranslatedContent', content: string, languageId: string }> } } | null };

export type SaveConfigDataMutationVariables = Exact<{
  dataToSave: Wa_SaveConfigInput;
}>;


export type SaveConfigDataMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', saveConfigData: { __typename?: 'WA_SaveConfigResult', status: C_Save_Operation_Status } } | null };

export type DictWa_CustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CustomersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Customers: Array<{ __typename?: 'WA_CustomerDictItem', id: string, customerNo?: string | null, internalOrFullName?: string | null, isActive: boolean }> } | null };

export type DictWa_CustomerGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CustomerGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CustomerGroups: Array<{ __typename?: 'WA_CustomerGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_CustomerListsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CustomerListsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CustomerLists: Array<{ __typename?: 'WA_CustomerListDictItem', id: string, label?: string | null }> } | null };

export type DictWa_TransportSectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_TransportSectorsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_TransportSectors: Array<{ __typename?: 'WA_TransportSectorDictItem', id: string, label?: string | null }> } | null };

export type DictWa_QuantityDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_QuantityDiscountsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_QuantityDiscounts: Array<{ __typename?: 'WA_QuantityDiscountDictItem', id: string, label?: string | null }> } | null };

export type DictWa_CustomerProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CustomerProfilesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CustomerProfiles: Array<{ __typename?: 'WA_CustomerProfileDictItem', id: string, label?: string | null }> } | null };

export type DictWa_TourplansQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_TourplansQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Tourplans: Array<{ __typename?: 'WA_TourplanDictItem', id: string, label?: string | null }> } | null };

export type DictWa_StorageLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_StorageLocationsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_StorageLocations: Array<{ __typename?: 'WA_StorageLocationDictItem', id: string, label?: string | null }> } | null };

export type ListWa_ArticlesForSelectInOrderPositionQueryVariables = Exact<{ [key: string]: never; }>;


export type ListWa_ArticlesForSelectInOrderPositionQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_ArticlesForSelectInOrderPosition: Array<{ __typename?: 'WA_ArticleForSelectInOrderPosition', id: string, articleNo?: string | null, vatCode: C_Vat_Code, qtyPerLot?: number | null, saleUnit: C_Sale_Unit, weight?: number | null, warningMsg?: string | null, isDeliveredDays: Array<boolean>, assortmentGroups: Array<string>, isActive: boolean, isDough: boolean, eanCode?: string | null, label?: string | null }> } | null };

export type DictWa_SpecialDatesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_SpecialDatesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_SpecialDates: Array<{ __typename?: 'WA_SpecialDate', date: any, id: string, replacingDate: any, description?: string | null }> } | null };

export type DictWa_DeliveryNoteGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_DeliveryNoteGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_DeliveryNoteGroups: Array<{ __typename?: 'WA_DeliveryNoteGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_TextBlocksQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_TextBlocksQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_TextBlocks: Array<{ __typename?: 'WA_TextBlockDictItem', id: string, isDefaultForInvoice: boolean, isDefaultForOrder: boolean, isDefaultForOffer: boolean, label?: string | null }> } | null };

export type DictWa_PriceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_PriceCategoriesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_PriceCategories: Array<{ __typename?: 'WA_PriceCategoryDictItem', id: string, vat?: C_Tax_System | null, label?: string | null }> } | null };

export type DictWa_ArticleListsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_ArticleListsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_ArticleLists: Array<{ __typename?: 'WA_ArticleListDictItem', id: string, label?: string | null }> } | null };

export type DictWa_AssortmentGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_AssortmentGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_AssortimentGroups: Array<{ __typename?: 'WA_AssortimentGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_CashAssistProductGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CashAssistProductGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CashAssistProductGroups: Array<{ __typename?: 'WA_CashAssistProductGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_CashAssistTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CashAssistTemplatesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CashAssistTemplates: Array<{ __typename?: 'WA_CashAssistTemplateDictItem', id: string, label?: string | null }> } | null };

export type DictWa_DiscountGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_DiscountGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_DiscountGroups: Array<{ __typename?: 'WA_DiscountGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_MarketingGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_MarketingGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_MarketingGroups: Array<{ __typename?: 'WA_MarketingGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_ProductionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_ProductionGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_ProductionGroups: Array<{ __typename?: 'WA_ProductionGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_ProductionPrintListGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_ProductionPrintListGroupsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_ProductionPrintListGroups: Array<{ __typename?: 'WA_ProductionPrintListGroupDictItem', id: string, label?: string | null }> } | null };

export type DictWa_BanksQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_BanksQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Banks: Array<{ __typename?: 'WA_BankDictItem', id: string, name?: string | null, internalName?: string | null, label?: string | null }> } | null };

export type DictWa_ShippingPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_ShippingPointsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_ShippingPoints: Array<{ __typename?: 'WA_ShippingPointDictItem', id: string, label?: string | null }> } | null };

export type DictWa_SubCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_SubCompaniesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_SubCompanies: Array<{ __typename?: 'WA_SubCompanyDictItem', id: string, label?: string | null }> } | null };

export type DictWa_RecipesWithConnectedArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_RecipesWithConnectedArticlesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_RecipesWithConnectedArticles: Array<{ __typename?: 'WA_ReceipeWithConnectedArticle', recipeId: string, recipeNo?: string | null, recipeName?: string | null, connectedArticleId?: string | null, connectedArticleNo?: string | null, connectedArticleName?: string | null }> } | null };

export type DictWa_ArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_ArticlesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Articles: Array<{ __typename?: 'WA_ArticleDictItem', articleNo?: string | null, description?: string | null, id: string, isDough: boolean, isActive: boolean, isFractionArticle: boolean }> } | null };

export type DictWa_DebtRemindersQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_DebtRemindersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_DebtReminders: Array<{ __typename?: 'WA_DebtReminderDictItem', id: string, label?: string | null }> } | null };

export type DictWa_ProductionPrintListsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_ProductionPrintListsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_ProductionPrintLists: Array<{ __typename?: 'WA_ProductionPrintListDictItem', id: string, reportId?: C_Report | null, label?: string | null }> } | null };

export type DictWa_CloudPrintersQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_CloudPrintersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CloudPrinters: Array<{ __typename?: 'WA_CloudPrinterDictItem', id: string, serialNo: string, label: string }> } | null };

export type DictWa_Bakery2bAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_Bakery2bAccountsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_Bakery2bAccounts: Array<{ __typename?: 'WA_Bakery2bAccountDictItem', id: string, email: string, name?: string | null }> } | null };

export type DictCompanyPrintersQueryVariables = Exact<{ [key: string]: never; }>;


export type DictCompanyPrintersQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_CompanyPrinters: Array<{ __typename?: 'WA_CompanyPrinterDictItem', isDeactivated: boolean, printerAvailable: boolean, id: string, label?: string | null }> } | null };

export type DictWa_TranslationLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type DictWa_TranslationLanguagesQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', dictWA_TranslationLanguages: Array<{ __typename?: 'WA_TranslationLanguage', id: string, name?: string | null }> } | null };

export type ListWa_HistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  historyFormTypeId: C_History_Form_Types;
}>;


export type ListWa_HistoryQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_History: Array<{ __typename?: 'WA_History', id: string, operationId?: C_History_Operations | null, dOperation?: string | null, fieldName?: string | null, oldValue?: string | null, newValue?: string | null, content?: string | null, userFullName?: string | null }> } | null };

export type ListWa_HistoryDeletedQueryVariables = Exact<{
  historyFormTypeId: C_History_Form_Types;
}>;


export type ListWa_HistoryDeletedQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_HistoryDeleted: Array<{ __typename?: 'WA_History', id: string, recordID: string, operationId?: C_History_Operations | null, dOperation?: string | null, content?: string | null, userFullName?: string | null }> } | null };

export type ListWa_PdfHistoryReportsQueryVariables = Exact<{
  params: Wa_ListReportsInput;
}>;


export type ListWa_PdfHistoryReportsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_PdfHistoryReports: { __typename?: 'WA_PdfHistoryReportsList', mergedFile?: { __typename?: 'WA_MergedFile', url: string, s3Key: string, bucket: C_S3_Bucket } | null, reports: Array<{ __typename?: 'WA_PdfHistoryReport', documentId: string, documentNo: number, reportId: C_Report, url: string, s3Key: string, bucket: C_S3_Bucket }> } } | null };

export type SendEmailWithDocumentMutationVariables = Exact<{
  messageParams: SendMultipleEmailsInput;
  docType: C_Email_Msg_Doctype;
  documentId: Scalars['ID']['input'];
}>;


export type SendEmailWithDocumentMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', sendEmailWithDocument: { __typename?: 'SendEmailResult', sentMessages: Array<{ __typename?: 'SentMessages', messageId: string, timestamp: any }>, unsentMessages: Array<{ __typename?: 'UnsentMessages', recipient: string }> } } | null };

export type ExtractXmlFromPdfOfInvoicesMutationVariables = Exact<{
  invoices: Array<Wa_PdfFileOfInvoiceInput> | Wa_PdfFileOfInvoiceInput;
}>;


export type ExtractXmlFromPdfOfInvoicesMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', extractXmlFromPdfOfInvoices: Array<{ __typename?: 'WA_XmlFileOfInvoice', invoiceId: string, xmlFile: { __typename?: 'WA_FileOfDocument', s3Bucket: C_S3_Bucket, s3Key: string, url: string } }> } | null };

export type ListWa_DataForMultiEmailsQueryVariables = Exact<{
  emailsDocType: C_Email_Msg_Doctype;
  documentsIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ListWa_DataForMultiEmailsQuery = { __typename?: 'Query', wawiAssist?: { __typename?: 'WA_Query', listWA_DataForMultiEmails: Array<{ __typename?: 'WA_DocumentsForMultiEmailsGridItem', documentId: string, documentNo: number, documentDate: any, customerId: string, customerNo?: string | null, internalOrFullName?: string | null, email?: string | null, eInvoiceFormat: C_E_Invoice_Format }> } | null };

export type Create_R6_ArticleListReportMutationVariables = Exact<{
  params: R6_ArticleListInput;
}>;


export type Create_R6_ArticleListReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r6_ArticleListReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R36_ArticleListAllPriceCategoriesReportMutationVariables = Exact<{
  params: R36_ArticleListAllPriceCategoriesInput;
}>;


export type Create_R36_ArticleListAllPriceCategoriesReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r36_ArticleListAllPriceCategoriesReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R50_ArticleListWithImageReportMutationVariables = Exact<{
  params: R50_ArticleListWithImageInput;
}>;


export type Create_R50_ArticleListWithImageReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r50_ArticleListWithImageReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R21_InvoiceJournalReportMutationVariables = Exact<{
  invoicesIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Create_R21_InvoiceJournalReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r21_InvoiceJournalReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R3_CustomerAddressesListReportMutationVariables = Exact<{
  customersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Create_R3_CustomerAddressesListReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r3_CustomerAddressesListReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R4_CustomerFactSheetReportMutationVariables = Exact<{
  customersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Create_R4_CustomerFactSheetReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r4_CustomerFactSheetReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R5_CustomerPhonesListReportMutationVariables = Exact<{
  customersIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Create_R5_CustomerPhonesListReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r5_CustomerPhonesListReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R37_OfferA4MutationVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;


export type Create_R37_OfferA4Mutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r37_OfferA4?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R8_DeliveryNoteA4WithPriceReportMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type Create_R8_DeliveryNoteA4WithPriceReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r8_DeliveryNoteA4WithPriceReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R29_DeliveryNoteA5LandscapeWithPriceReportMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type Create_R29_DeliveryNoteA5LandscapeWithPriceReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r29_DeliveryNoteA5LandscapeWithPriceReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R9_InvoiceA4ReportMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type Create_R9_InvoiceA4ReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r9_InvoiceA4Report?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R59_InvoicePaymentSlipWithQrReportMutationVariables = Exact<{
  invoiceId: Scalars['ID']['input'];
}>;


export type Create_R59_InvoicePaymentSlipWithQrReportMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r59_InvoicePaymentSlipWithQRReport?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R10_CustomersDebtNotifierMutationVariables = Exact<{
  params: Wa_DebitorReportParamsInput;
}>;


export type Create_R10_CustomersDebtNotifierMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r10_CustomersDebtNotifier?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R23_DebitorJournalA4LandscapeMutationVariables = Exact<{
  params: Wa_DebitorReportParamsInput;
}>;


export type Create_R23_DebitorJournalA4LandscapeMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r23_DebitorJournalA4Landscape?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R24_PaymentJournalA4MutationVariables = Exact<{
  paymentsId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Create_R24_PaymentJournalA4Mutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r24_PaymentJournalA4?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R35_ExtendedPaymentJournalMutationVariables = Exact<{
  paymentsId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type Create_R35_ExtendedPaymentJournalMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r35_ExtendedPaymentJournal?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R22_BesrImportA4MutationVariables = Exact<{
  batchId: Scalars['Int']['input'];
}>;


export type Create_R22_BesrImportA4Mutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r22_BESRImportA4?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R7_WeeklyOrderingListMutationVariables = Exact<{
  params: Wa_CustomerDefOrderReportInput;
}>;


export type Create_R7_WeeklyOrderingListMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r7_WeeklyOrderingList?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R33_PriceListForCustomerMutationVariables = Exact<{
  params: Wa_CustomerDefOrderReportInput;
}>;


export type Create_R33_PriceListForCustomerMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r33_PriceListForCustomer?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R28_WeeklyOrderingList_Blank_QuantityMutationVariables = Exact<{
  params: Wa_CustomerDefOrderReportInput;
}>;


export type Create_R28_WeeklyOrderingList_Blank_QuantityMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r28_WeeklyOrderingList_blank_quantity?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };

export type Create_R47_WeeklyOrderingList_Blank_Quantity_Blank_DateMutationVariables = Exact<{
  params: Wa_CustomerDefOrderReportInput;
}>;


export type Create_R47_WeeklyOrderingList_Blank_Quantity_Blank_DateMutation = { __typename?: 'Mutation', wawiAssist?: { __typename?: 'WA_Mutation', create_r47_WeeklyOrderingList_blank_quantity_blank_date?: { __typename?: 'WinReportTask', taskId: number, url: string, s3Key: string } | null } | null };
